(() => {
  // src/js/modules/components/accordion.js
  function initAccordion(accordionElement) {
    if (!accordionElement) {
      console.warn("Accordion element not found");
      return;
    }
    if (accordionElement.dataset.accordionInitialized === "true") {
      return;
    }
    const buttonElement = accordionElement.querySelector(".js-accordion__trigger");
    const contentElement = accordionElement.querySelector(".js-accordion__content");
    if (!buttonElement || !contentElement) {
      console.warn("Accordion: Required elements not found", {
        button: !!buttonElement,
        content: !!contentElement
      });
      return;
    }
    const isOpen = accordionElement.classList.contains("is-active");
    accordionElement.dataset.accordionInitialized = "true";
    buttonElement.setAttribute("aria-expanded", isOpen ? "true" : "false");
    if (isOpen) {
      contentElement.style.maxHeight = `${contentElement.scrollHeight}px`;
    }
    buttonElement.addEventListener("click", () => {
      toggleAccordion(accordionElement, buttonElement, contentElement);
    });
  }
  function toggleAccordion(accordionElement, buttonElement, contentElement) {
    const isOpen = accordionElement.classList.contains("is-active");
    const newState = !isOpen;
    accordionElement.classList.toggle("is-active", newState);
    buttonElement.setAttribute("aria-expanded", newState ? "true" : "false");
    if (newState) {
      contentElement.style.maxHeight = `${contentElement.scrollHeight}px`;
    } else {
      contentElement.style.maxHeight = null;
    }
  }
  function initAccordions(selector = ".js-accordion", root = document, options = {}) {
    const { excludeDrawer = false } = options;
    const accordions = root.querySelectorAll(selector);
    accordions.forEach((accordionElement) => {
      if (excludeDrawer && accordionElement.closest(".js-drawer")) {
        return;
      }
      if (accordionElement.dataset.accordionInitialized === "true") {
        return;
      }
      initAccordion(accordionElement);
    });
  }
  function refreshAccordionHeights(root, selector = ".js-accordion") {
    root.querySelectorAll(selector).forEach((accordionElement) => {
      const contentElement = accordionElement.querySelector(".js-accordion__content");
      if (!contentElement || !accordionElement.classList.contains("is-active")) {
        return;
      }
      contentElement.style.maxHeight = `${contentElement.scrollHeight}px`;
    });
  }
  function ensureDrawerAccordionsInitialized(drawerRoot) {
    if (!drawerRoot) {
      return;
    }
    const done = drawerRoot.dataset.drawerAccordionsInitialized === "true";
    if (!done) {
      initAccordions(".js-accordion", drawerRoot);
      drawerRoot.dataset.drawerAccordionsInitialized = "true";
      return;
    }
    refreshAccordionHeights(drawerRoot);
  }

  // src/js/modules/components/legacy-accordion.js
  function initLegacyAccordion(accordionElement) {
    if (!accordionElement) {
      console.warn("Legacy accordion element not found");
      return;
    }
    if (accordionElement.dataset.legacyAccordionInitialized === "true") {
      return;
    }
    accordionElement.dataset.legacyAccordionInitialized = "true";
    accordionElement.addEventListener("click", () => {
      accordionElement.classList.toggle("is-active");
    });
  }
  function initLegacyAccordions(selector = ".js-legacy-accordion") {
    const accordions = document.querySelectorAll(selector);
    accordions.forEach((accordionElement) => {
      if (accordionElement.dataset.legacyAccordionInitialized === "true") {
        return;
      }
      initLegacyAccordion(accordionElement);
    });
  }

  // src/js/constants/breakpoints.js
  var BREAKPOINT_SP = 749;
  var BREAKPOINT_TB = 989;
  var BREAKPOINT_PC = 1269;
  var toMinWidthAbove = (maxWidthBreakpoint) => maxWidthBreakpoint + 1;
  var MIN_WIDTH_ABOVE_TB = toMinWidthAbove(BREAKPOINT_TB);
  var MIN_WIDTH_ABOVE_SP = toMinWidthAbove(BREAKPOINT_SP);
  var MIN_WIDTH_ABOVE_PC = toMinWidthAbove(BREAKPOINT_PC);
  var mediaQuerySp = `(max-width: ${BREAKPOINT_SP}px)`;
  var mediaQueryTb = `(max-width: ${BREAKPOINT_TB}px)`;

  // src/js/modules/components/drawer.js
  var OPEN_CLASS = "is-drawer-open";
  var drawerAbort = null;
  var lastFocusTrigger = null;
  function closeDrawer(drawerRoot) {
    if (!drawerRoot) {
      return;
    }
    const id = drawerRoot.dataset.jsDrawerId;
    drawerRoot.classList.remove(OPEN_CLASS);
    drawerRoot.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove(OPEN_CLASS);
    drawerRoot.querySelectorAll(".js-drawer__close").forEach((btn) => {
      btn.setAttribute("tabindex", "-1");
    });
    document.querySelectorAll(`[data-js-drawer-target="${id}"]`).forEach((btn) => {
      btn.setAttribute("aria-expanded", "false");
    });
    if (lastFocusTrigger && document.body.contains(lastFocusTrigger)) {
      lastFocusTrigger.focus({ preventScroll: true });
    }
    lastFocusTrigger = null;
  }
  function openDrawerProgrammatically(drawerRoot) {
    if (!drawerRoot?.classList.contains("js-drawer")) {
      return;
    }
    openDrawer(drawerRoot, null);
  }
  function closeOpenDrawers() {
    document.querySelectorAll(".js-drawer.is-drawer-open").forEach((drawerRoot) => {
      closeDrawer(drawerRoot);
    });
  }
  function openDrawer(drawerRoot, trigger) {
    document.querySelectorAll(".js-drawer.is-drawer-open").forEach((other) => {
      if (other !== drawerRoot) {
        closeDrawer(other);
      }
    });
    lastFocusTrigger = trigger ?? null;
    drawerRoot.classList.add(OPEN_CLASS);
    drawerRoot.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add(OPEN_CLASS);
    const id = drawerRoot.dataset.jsDrawerId;
    document.querySelectorAll(`[data-js-drawer-target="${id}"]`).forEach((btn) => {
      btn.setAttribute("aria-expanded", "true");
    });
    drawerRoot.querySelectorAll(".js-drawer__close").forEach((btn) => {
      btn.setAttribute("tabindex", "0");
    });
    const panel = drawerRoot.querySelector(".js-drawer__panel");
    if (panel) {
      panel.focus({ preventScroll: true });
    }
    requestAnimationFrame(() => {
      ensureDrawerAccordionsInitialized(drawerRoot);
    });
  }
  function resetAllDrawersUi() {
    document.documentElement.classList.remove(OPEN_CLASS);
    document.querySelectorAll(".js-drawer").forEach((root) => {
      root.classList.remove(OPEN_CLASS);
      root.setAttribute("aria-hidden", "true");
      root.querySelectorAll(".js-drawer__close").forEach((btn) => {
        btn.setAttribute("tabindex", "-1");
      });
    });
    document.querySelectorAll(".js-drawer__trigger").forEach((btn) => {
      btn.setAttribute("aria-expanded", "false");
    });
  }
  function bindDrawerChrome(drawerRoot, signal) {
    const id = drawerRoot.dataset.jsDrawerId;
    if (!id) {
      return;
    }
    const backdrop = drawerRoot.querySelector(".js-drawer__backdrop");
    backdrop?.addEventListener(
      "click",
      () => {
        closeDrawer(drawerRoot);
      },
      { signal }
    );
    drawerRoot.querySelectorAll(".js-drawer__close").forEach((closeBtn) => {
      closeBtn.addEventListener(
        "click",
        () => {
          closeDrawer(drawerRoot);
        },
        { signal }
      );
    });
  }
  function initDrawers() {
    drawerAbort?.abort();
    resetAllDrawersUi();
    drawerAbort = new AbortController();
    const { signal } = drawerAbort;
    document.addEventListener(
      "click",
      (e) => {
        const trigger = e.target.closest("[data-js-drawer-target]");
        if (!trigger || trigger.disabled) {
          return;
        }
        const targetId = trigger.dataset.jsDrawerTarget;
        if (!targetId || !/^[a-zA-Z0-9_-]+$/.test(targetId)) {
          return;
        }
        const drawerRoot = document.querySelector(
          `.js-drawer[data-js-drawer-id="${targetId}"]`
        );
        if (!drawerRoot) {
          return;
        }
        e.preventDefault();
        const isOpen = drawerRoot.classList.contains(OPEN_CLASS);
        if (isOpen) {
          closeDrawer(drawerRoot);
        } else {
          openDrawer(drawerRoot, trigger);
        }
      },
      { signal }
    );
    document.querySelectorAll(".js-drawer[data-js-drawer-id]").forEach((drawerRoot) => {
      bindDrawerChrome(drawerRoot, signal);
    });
    document.addEventListener(
      "keydown",
      (e) => {
        if (e.key !== "Escape") {
          return;
        }
        const openDrawerEl = document.querySelector(".js-drawer.is-drawer-open");
        if (!openDrawerEl) {
          return;
        }
        closeDrawer(openDrawerEl);
      },
      { signal }
    );
  }

  // src/js/modules/utils/header-metrics.js
  var HEADER_STICKY_OFFSET_FALLBACK_PX = 100;
  var PRODUCT_CONTENT_NAVI_HEIGHT_FALLBACK_PX = 40;
  var PRODUCT_CONTENT_ROOT_SELECTOR = ".js-product-content";
  var PRODUCT_CONTENT_NAVI_SELECTOR = ".js-product-content-navi";
  function readHeaderStickyOffsetPx(fallback = HEADER_STICKY_OFFSET_FALLBACK_PX) {
    const raw = getComputedStyle(document.documentElement).getPropertyValue("--header-sticky-offset").trim();
    if (!raw) {
      return fallback;
    }
    const value = parseFloat(raw);
    return Number.isFinite(value) && value >= 0 ? value : fallback;
  }
  function isProductContentAnchor(element) {
    return element instanceof Element && Boolean(element.closest(PRODUCT_CONTENT_ROOT_SELECTOR));
  }
  function readProductContentNaviHeightPx(fallback = PRODUCT_CONTENT_NAVI_HEIGHT_FALLBACK_PX) {
    const nav = document.querySelector(PRODUCT_CONTENT_NAVI_SELECTOR);
    if (!nav) {
      return 0;
    }
    const measured = nav.getBoundingClientRect().height;
    if (measured > 0) {
      return measured;
    }
    const contentRoot = nav.closest(PRODUCT_CONTENT_ROOT_SELECTOR);
    if (contentRoot) {
      const raw = getComputedStyle(contentRoot).getPropertyValue("--product-content-navi-height").trim();
      const parsed = parseFloat(raw);
      if (Number.isFinite(parsed) && parsed > 0) {
        return parsed;
      }
    }
    return fallback;
  }
  function readProductContentAnchorOffsetPx(fallbackHeader = HEADER_STICKY_OFFSET_FALLBACK_PX) {
    return readHeaderStickyOffsetPx(fallbackHeader) + readProductContentNaviHeightPx();
  }

  // src/js/modules/components/smooth-scroll.js
  var DEFAULT_CONFIG = {
    duration: 400,
    // アニメーション時間（ms）
    offset: 0,
    // スクロール位置のオフセット（px）
    easing: "easeInOutQuad"
    // イージング関数
  };
  var HASH_LOAD_CORRECTION_DELAYS_MS = [300, 800];
  var activeSmoothScrollRafId = null;
  var smoothScrollConfig = null;
  var easingFunctions = {
    linear: (t) => t,
    easeInQuad: (t) => t * t,
    easeOutQuad: (t) => t * (2 - t),
    easeInOutQuad: (t) => t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t,
    easeInCubic: (t) => t * t * t,
    easeOutCubic: (t) => --t * t * t + 1,
    easeInOutCubic: (t) => t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1
  };
  function cancelActiveSmoothScroll() {
    if (activeSmoothScrollRafId !== null) {
      cancelAnimationFrame(activeSmoothScrollRafId);
      activeSmoothScrollRafId = null;
    }
  }
  function getEasingFunction(name) {
    return easingFunctions[name] || easingFunctions.easeInOutQuad;
  }
  function getScrollPosition(element, offset = 0) {
    const rect = element.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return rect.top + scrollTop - offset;
  }
  function normalizePathname(pathname) {
    const normalized = pathname.replace(/\/+$/, "");
    return normalized || "/";
  }
  function isTbViewport(config) {
    const breakpoint = config.breakpoint ?? BREAKPOINT_SP;
    return window.innerWidth <= breakpoint;
  }
  function usesHeaderStickyOffset(config) {
    return config.offsetPc !== void 0 && config.offsetSp !== void 0 && isTbViewport(config);
  }
  function resolveScrollOffset(config, anchorElement = null) {
    if (usesHeaderStickyOffset(config)) {
      const fallback = config.offsetSpHasNavi ?? config.offsetSp;
      if (anchorElement && isProductContentAnchor(anchorElement)) {
        return readProductContentAnchorOffsetPx(fallback);
      }
      return readHeaderStickyOffsetPx(fallback);
    }
    if (anchorElement && isProductContentAnchor(anchorElement) && !isTbViewport(config)) {
      return readProductContentNaviHeightPx();
    }
    const breakpoint = config.breakpoint ?? BREAKPOINT_SP;
    const isPc = window.innerWidth > breakpoint;
    if (config.offsetPc !== void 0 && config.offsetSp !== void 0) {
      return isPc ? config.offsetPc : config.offsetSp;
    }
    return config.offset !== void 0 ? config.offset : DEFAULT_CONFIG.offset;
  }
  function snapScrollToAnchor(anchorElement, config) {
    window.scrollTo(0, getScrollPosition(anchorElement, resolveScrollOffset(config, anchorElement)));
  }
  function isSamePageAnchorHref(href) {
    if (!href || !href.includes("#")) {
      return false;
    }
    if (href.startsWith("#")) {
      return true;
    }
    try {
      const url = new URL(href, window.location.href);
      if (url.origin !== window.location.origin) {
        return false;
      }
      return normalizePathname(url.pathname) === normalizePathname(window.location.pathname);
    } catch {
      return false;
    }
  }
  function shouldIgnoreSmoothScrollHref(href) {
    if (!href || !href.includes("#")) {
      return false;
    }
    try {
      const url = new URL(href, window.location.href);
      if (normalizePathname(url.pathname) !== "/pages/indiancurry") {
        return false;
      }
      return url.hash === "#message" || url.hash === "#featured";
    } catch {
      return false;
    }
  }
  function shouldIgnoreSmoothScrollLink(link) {
    if (link.hasAttribute("data-smooth-scroll-ignore")) {
      return true;
    }
    return shouldIgnoreSmoothScrollHref(link.getAttribute("href"));
  }
  function resolveLinkHash(href) {
    if (!href) {
      return null;
    }
    if (href === "#" || href === "") {
      return "html";
    }
    if (href.startsWith("#")) {
      return href;
    }
    const hashIndex = href.indexOf("#");
    if (hashIndex === -1) {
      return null;
    }
    const hash = href.slice(hashIndex);
    return hash.length > 1 ? hash : "html";
  }
  function getTargetElementFromHash(hash) {
    if (hash === "html") {
      return document.documentElement;
    }
    return document.querySelector(hash);
  }
  function getLocationHashTarget() {
    const rawHash = location.hash;
    if (!rawHash || rawHash === "#") {
      return null;
    }
    try {
      const id = decodeURIComponent(rawHash.slice(1));
      if (!id) {
        return null;
      }
      return document.getElementById(id);
    } catch {
      return document.querySelector(rawHash);
    }
  }
  function scheduleHashScrollCorrections(config) {
    const target = getLocationHashTarget();
    if (!target) {
      return;
    }
    if ("scrollRestoration" in history) {
      history.scrollRestoration = "manual";
    }
    const snap = () => {
      if (!document.body.contains(target)) {
        return;
      }
      snapScrollToAnchor(target, config);
    };
    requestAnimationFrame(() => {
      requestAnimationFrame(snap);
    });
    window.addEventListener("load", snap, { once: true });
    for (const delay of HASH_LOAD_CORRECTION_DELAYS_MS) {
      setTimeout(snap, delay);
    }
  }
  function correctLocationHashScroll() {
    if (!smoothScrollConfig) {
      return;
    }
    scheduleHashScrollCorrections(smoothScrollConfig);
  }
  function smoothScrollTo(targetPosition, config = {}) {
    cancelActiveSmoothScroll();
    const duration = config.duration ?? DEFAULT_CONFIG.duration;
    const easingFunction = getEasingFunction(config.easing ?? DEFAULT_CONFIG.easing);
    const startPosition = window.pageYOffset || document.documentElement.scrollTop;
    const distance = targetPosition - startPosition;
    let startTime = null;
    function animation(currentTime) {
      if (startTime === null) {
        startTime = currentTime;
      }
      const timeElapsed = currentTime - startTime;
      const progress = Math.min(timeElapsed / duration, 1);
      const ease = easingFunction(progress);
      window.scrollTo(0, startPosition + distance * ease);
      if (progress < 1) {
        activeSmoothScrollRafId = requestAnimationFrame(animation);
      } else {
        activeSmoothScrollRafId = null;
      }
    }
    activeSmoothScrollRafId = requestAnimationFrame(animation);
  }
  function smoothScrollToAnchor(anchorElement, config = {}) {
    cancelActiveSmoothScroll();
    const duration = config.duration ?? DEFAULT_CONFIG.duration;
    const easingFunction = getEasingFunction(config.easing ?? DEFAULT_CONFIG.easing);
    const startPosition = window.pageYOffset || document.documentElement.scrollTop;
    let startTime = null;
    function animation(currentTime) {
      if (startTime === null) {
        startTime = currentTime;
      }
      const timeElapsed = currentTime - startTime;
      const progress = Math.min(timeElapsed / duration, 1);
      const ease = easingFunction(progress);
      const targetPosition = getScrollPosition(anchorElement, resolveScrollOffset(config, anchorElement));
      window.scrollTo(0, startPosition + (targetPosition - startPosition) * ease);
      if (progress < 1) {
        activeSmoothScrollRafId = requestAnimationFrame(animation);
      } else {
        activeSmoothScrollRafId = requestAnimationFrame(() => {
          snapScrollToAnchor(anchorElement, config);
          activeSmoothScrollRafId = null;
        });
      }
    }
    activeSmoothScrollRafId = requestAnimationFrame(animation);
  }
  function navigateToHashTarget(targetElement, hash, config) {
    if (usesHeaderStickyOffset(config)) {
      smoothScrollToAnchor(targetElement, config);
    } else {
      const offset = resolveScrollOffset(config, targetElement);
      smoothScrollTo(getScrollPosition(targetElement, offset), config);
    }
    if (hash === "html") {
      history.pushState(null, "", `${window.location.pathname}${window.location.search}`);
    } else {
      history.pushState(null, "", hash);
    }
  }
  function handleAnchorLinkClick(event2, config = {}) {
    const link = event2.currentTarget;
    if (shouldIgnoreSmoothScrollLink(link)) {
      return;
    }
    const href = link.getAttribute("href");
    if (!isSamePageAnchorHref(href)) {
      return;
    }
    const hash = resolveLinkHash(href);
    if (!hash) {
      return;
    }
    const targetElement = getTargetElementFromHash(hash);
    if (!targetElement) {
      return;
    }
    event2.preventDefault();
    closeOpenDrawers();
    navigateToHashTarget(targetElement, hash, config);
  }
  function initSmoothScroll(options = {}) {
    const {
      selector = 'a[href*="#"]',
      duration = DEFAULT_CONFIG.duration,
      offset = DEFAULT_CONFIG.offset,
      offsetPc,
      offsetSp,
      offsetSpHasNavi,
      breakpoint = BREAKPOINT_SP,
      easing = DEFAULT_CONFIG.easing
    } = options;
    smoothScrollConfig = { duration, offset, easing, offsetPc, offsetSp, offsetSpHasNavi, breakpoint, selector };
    bindSmoothScrollLinks(document, smoothScrollConfig);
  }
  function refreshSmoothScrollLinks(root = document) {
    if (!smoothScrollConfig) {
      return;
    }
    bindSmoothScrollLinks(root, smoothScrollConfig);
  }
  function bindSmoothScrollLinks(root, config) {
    const selector = config.selector || 'a[href*="#"]';
    const links = root.querySelectorAll(selector);
    links.forEach((link) => {
      if (link.dataset.smoothScrollInitialized === "true") {
        return;
      }
      const href = link.getAttribute("href");
      if (!href || !href.includes("#")) {
        return;
      }
      if (shouldIgnoreSmoothScrollLink(link)) {
        return;
      }
      if (href.includes("://")) {
        try {
          const url = new URL(href);
          if (url.origin !== window.location.origin) {
            return;
          }
        } catch {
          return;
        }
      }
      link.dataset.smoothScrollInitialized = "true";
      link.addEventListener("click", (event2) => {
        handleAnchorLinkClick(event2, config);
      });
    });
  }

  // src/js/modules/components/column-detail-mokuji.js
  var MOKUJI_SELECTOR = "#js-column-detail__mokuji";
  var CONTENT_SELECTOR = "#js-column-detail__mokuji-content";
  var HEADING_SELECTOR = "h2";
  function initColumnDetailMokuji(root = document) {
    const scope = root.querySelector ? root : document;
    const mokuji = (scope.matches?.(MOKUJI_SELECTOR) ? scope : null) || scope.querySelector?.(MOKUJI_SELECTOR) || document.querySelector(MOKUJI_SELECTOR);
    if (!mokuji || mokuji.dataset.mokujiInitialized === "true") {
      return;
    }
    const content = mokuji.parentElement?.querySelector(CONTENT_SELECTOR) || scope.querySelector?.(CONTENT_SELECTOR) || document.querySelector(CONTENT_SELECTOR);
    if (!content) {
      mokuji.hidden = true;
      mokuji.dataset.mokujiInitialized = "true";
      return;
    }
    const headings = [...content.querySelectorAll(HEADING_SELECTOR)];
    if (headings.length === 0) {
      mokuji.innerHTML = "";
      mokuji.hidden = true;
      mokuji.dataset.mokujiInitialized = "true";
      return;
    }
    const items = headings.map((heading, index) => {
      const id = `section${index}`;
      heading.id = id;
      return {
        id,
        title: (heading.textContent || "").trim()
      };
    });
    mokuji.hidden = false;
    mokuji.innerHTML = `
    <p class="p-column-detail__mokuji-title">\u76EE\u6B21</p>
    <ul>
      ${items.map(
      (item) => `<li><a href="#${escapeHtml(item.id)}">${escapeHtml(item.title)}</a></li>`
    ).join("")}
    </ul>
  `;
    mokuji.dataset.mokujiInitialized = "true";
    refreshSmoothScrollLinks(mokuji);
  }
  function escapeHtml(value) {
    return String(value).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
  }

  // node_modules/swiper/shared/ssr-window.esm.mjs
  function isObject(obj) {
    return obj !== null && typeof obj === "object" && "constructor" in obj && obj.constructor === Object;
  }
  function extend(target, src) {
    if (target === void 0) {
      target = {};
    }
    if (src === void 0) {
      src = {};
    }
    const noExtend = ["__proto__", "constructor", "prototype"];
    Object.keys(src).filter((key) => noExtend.indexOf(key) < 0).forEach((key) => {
      if (typeof target[key] === "undefined") target[key] = src[key];
      else if (isObject(src[key]) && isObject(target[key]) && Object.keys(src[key]).length > 0) {
        extend(target[key], src[key]);
      }
    });
  }
  var ssrDocument = {
    body: {},
    addEventListener() {
    },
    removeEventListener() {
    },
    activeElement: {
      blur() {
      },
      nodeName: ""
    },
    querySelector() {
      return null;
    },
    querySelectorAll() {
      return [];
    },
    getElementById() {
      return null;
    },
    createEvent() {
      return {
        initEvent() {
        }
      };
    },
    createElement() {
      return {
        children: [],
        childNodes: [],
        style: {},
        setAttribute() {
        },
        getElementsByTagName() {
          return [];
        }
      };
    },
    createElementNS() {
      return {};
    },
    importNode() {
      return null;
    },
    location: {
      hash: "",
      host: "",
      hostname: "",
      href: "",
      origin: "",
      pathname: "",
      protocol: "",
      search: ""
    }
  };
  function getDocument() {
    const doc = typeof document !== "undefined" ? document : {};
    extend(doc, ssrDocument);
    return doc;
  }
  var ssrWindow = {
    document: ssrDocument,
    navigator: {
      userAgent: ""
    },
    location: {
      hash: "",
      host: "",
      hostname: "",
      href: "",
      origin: "",
      pathname: "",
      protocol: "",
      search: ""
    },
    history: {
      replaceState() {
      },
      pushState() {
      },
      go() {
      },
      back() {
      }
    },
    CustomEvent: function CustomEvent2() {
      return this;
    },
    addEventListener() {
    },
    removeEventListener() {
    },
    getComputedStyle() {
      return {
        getPropertyValue() {
          return "";
        }
      };
    },
    Image() {
    },
    Date() {
    },
    screen: {},
    setTimeout() {
    },
    clearTimeout() {
    },
    matchMedia() {
      return {};
    },
    requestAnimationFrame(callback) {
      if (typeof setTimeout === "undefined") {
        callback();
        return null;
      }
      return setTimeout(callback, 0);
    },
    cancelAnimationFrame(id) {
      if (typeof setTimeout === "undefined") {
        return;
      }
      clearTimeout(id);
    }
  };
  function getWindow() {
    const win = typeof window !== "undefined" ? window : {};
    extend(win, ssrWindow);
    return win;
  }

  // node_modules/swiper/shared/utils.mjs
  function classesToTokens(classes2) {
    if (classes2 === void 0) {
      classes2 = "";
    }
    return classes2.trim().split(" ").filter((c) => !!c.trim());
  }
  function deleteProps(obj) {
    const object = obj;
    Object.keys(object).forEach((key) => {
      try {
        object[key] = null;
      } catch (e) {
      }
      try {
        delete object[key];
      } catch (e) {
      }
    });
  }
  function nextTick(callback, delay) {
    if (delay === void 0) {
      delay = 0;
    }
    return setTimeout(callback, delay);
  }
  function now() {
    return Date.now();
  }
  function getComputedStyle2(el) {
    const window2 = getWindow();
    let style;
    if (window2.getComputedStyle) {
      style = window2.getComputedStyle(el, null);
    }
    if (!style && el.currentStyle) {
      style = el.currentStyle;
    }
    if (!style) {
      style = el.style;
    }
    return style;
  }
  function getTranslate(el, axis) {
    if (axis === void 0) {
      axis = "x";
    }
    const window2 = getWindow();
    let matrix;
    let curTransform;
    let transformMatrix;
    const curStyle = getComputedStyle2(el);
    if (window2.WebKitCSSMatrix) {
      curTransform = curStyle.transform || curStyle.webkitTransform;
      if (curTransform.split(",").length > 6) {
        curTransform = curTransform.split(", ").map((a) => a.replace(",", ".")).join(", ");
      }
      transformMatrix = new window2.WebKitCSSMatrix(curTransform === "none" ? "" : curTransform);
    } else {
      transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,");
      matrix = transformMatrix.toString().split(",");
    }
    if (axis === "x") {
      if (window2.WebKitCSSMatrix) curTransform = transformMatrix.m41;
      else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
      else curTransform = parseFloat(matrix[4]);
    }
    if (axis === "y") {
      if (window2.WebKitCSSMatrix) curTransform = transformMatrix.m42;
      else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
      else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
  }
  function isObject2(o) {
    return typeof o === "object" && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === "Object";
  }
  function isNode(node) {
    if (typeof window !== "undefined" && typeof window.HTMLElement !== "undefined") {
      return node instanceof HTMLElement;
    }
    return node && (node.nodeType === 1 || node.nodeType === 11);
  }
  function extend2() {
    const to = Object(arguments.length <= 0 ? void 0 : arguments[0]);
    const noExtend = ["__proto__", "constructor", "prototype"];
    for (let i = 1; i < arguments.length; i += 1) {
      const nextSource = i < 0 || arguments.length <= i ? void 0 : arguments[i];
      if (nextSource !== void 0 && nextSource !== null && !isNode(nextSource)) {
        const keysArray = Object.keys(Object(nextSource)).filter((key) => noExtend.indexOf(key) < 0);
        for (let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
          const nextKey = keysArray[nextIndex];
          const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
          if (desc !== void 0 && desc.enumerable) {
            if (isObject2(to[nextKey]) && isObject2(nextSource[nextKey])) {
              if (nextSource[nextKey].__swiper__) {
                to[nextKey] = nextSource[nextKey];
              } else {
                extend2(to[nextKey], nextSource[nextKey]);
              }
            } else if (!isObject2(to[nextKey]) && isObject2(nextSource[nextKey])) {
              to[nextKey] = {};
              if (nextSource[nextKey].__swiper__) {
                to[nextKey] = nextSource[nextKey];
              } else {
                extend2(to[nextKey], nextSource[nextKey]);
              }
            } else {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
    }
    return to;
  }
  function setCSSProperty(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
  }
  function animateCSSModeScroll(_ref) {
    let {
      swiper,
      targetPosition,
      side
    } = _ref;
    const window2 = getWindow();
    const startPosition = -swiper.translate;
    let startTime = null;
    let time;
    const duration = swiper.params.speed;
    swiper.wrapperEl.style.scrollSnapType = "none";
    window2.cancelAnimationFrame(swiper.cssModeFrameID);
    const dir = targetPosition > startPosition ? "next" : "prev";
    const isOutOfBound = (current, target) => {
      return dir === "next" && current >= target || dir === "prev" && current <= target;
    };
    const animate = () => {
      time = (/* @__PURE__ */ new Date()).getTime();
      if (startTime === null) {
        startTime = time;
      }
      const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
      const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
      let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
      if (isOutOfBound(currentPosition, targetPosition)) {
        currentPosition = targetPosition;
      }
      swiper.wrapperEl.scrollTo({
        [side]: currentPosition
      });
      if (isOutOfBound(currentPosition, targetPosition)) {
        swiper.wrapperEl.style.overflow = "hidden";
        swiper.wrapperEl.style.scrollSnapType = "";
        setTimeout(() => {
          swiper.wrapperEl.style.overflow = "";
          swiper.wrapperEl.scrollTo({
            [side]: currentPosition
          });
        });
        window2.cancelAnimationFrame(swiper.cssModeFrameID);
        return;
      }
      swiper.cssModeFrameID = window2.requestAnimationFrame(animate);
    };
    animate();
  }
  function getSlideTransformEl(slideEl) {
    return slideEl.querySelector(".swiper-slide-transform") || slideEl.shadowRoot && slideEl.shadowRoot.querySelector(".swiper-slide-transform") || slideEl;
  }
  function elementChildren(element, selector) {
    if (selector === void 0) {
      selector = "";
    }
    const window2 = getWindow();
    const children = [...element.children];
    if (window2.HTMLSlotElement && element instanceof HTMLSlotElement) {
      children.push(...element.assignedElements());
    }
    if (!selector) {
      return children;
    }
    return children.filter((el) => el.matches(selector));
  }
  function elementIsChildOfSlot(el, slot) {
    const elementsQueue = [slot];
    while (elementsQueue.length > 0) {
      const elementToCheck = elementsQueue.shift();
      if (el === elementToCheck) {
        return true;
      }
      elementsQueue.push(...elementToCheck.children, ...elementToCheck.shadowRoot ? elementToCheck.shadowRoot.children : [], ...elementToCheck.assignedElements ? elementToCheck.assignedElements() : []);
    }
  }
  function elementIsChildOf(el, parent) {
    const window2 = getWindow();
    let isChild = parent.contains(el);
    if (!isChild && window2.HTMLSlotElement && parent instanceof HTMLSlotElement) {
      const children = [...parent.assignedElements()];
      isChild = children.includes(el);
      if (!isChild) {
        isChild = elementIsChildOfSlot(el, parent);
      }
    }
    return isChild;
  }
  function showWarning(text) {
    try {
      console.warn(text);
      return;
    } catch (err) {
    }
  }
  function createElement(tag, classes2) {
    if (classes2 === void 0) {
      classes2 = [];
    }
    const el = document.createElement(tag);
    el.classList.add(...Array.isArray(classes2) ? classes2 : classesToTokens(classes2));
    return el;
  }
  function elementPrevAll(el, selector) {
    const prevEls = [];
    while (el.previousElementSibling) {
      const prev = el.previousElementSibling;
      if (selector) {
        if (prev.matches(selector)) prevEls.push(prev);
      } else prevEls.push(prev);
      el = prev;
    }
    return prevEls;
  }
  function elementNextAll(el, selector) {
    const nextEls = [];
    while (el.nextElementSibling) {
      const next = el.nextElementSibling;
      if (selector) {
        if (next.matches(selector)) nextEls.push(next);
      } else nextEls.push(next);
      el = next;
    }
    return nextEls;
  }
  function elementStyle(el, prop) {
    const window2 = getWindow();
    return window2.getComputedStyle(el, null).getPropertyValue(prop);
  }
  function elementIndex(el) {
    let child = el;
    let i;
    if (child) {
      i = 0;
      while ((child = child.previousSibling) !== null) {
        if (child.nodeType === 1) i += 1;
      }
      return i;
    }
    return void 0;
  }
  function elementParents(el, selector) {
    const parents = [];
    let parent = el.parentElement;
    while (parent) {
      if (selector) {
        if (parent.matches(selector)) parents.push(parent);
      } else {
        parents.push(parent);
      }
      parent = parent.parentElement;
    }
    return parents;
  }
  function elementTransitionEnd(el, callback) {
    function fireCallBack(e) {
      if (e.target !== el) return;
      callback.call(el, e);
      el.removeEventListener("transitionend", fireCallBack);
    }
    if (callback) {
      el.addEventListener("transitionend", fireCallBack);
    }
  }
  function elementOuterSize(el, size, includeMargins) {
    const window2 = getWindow();
    if (includeMargins) {
      return el[size === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(window2.getComputedStyle(el, null).getPropertyValue(size === "width" ? "margin-right" : "margin-top")) + parseFloat(window2.getComputedStyle(el, null).getPropertyValue(size === "width" ? "margin-left" : "margin-bottom"));
    }
    return el.offsetWidth;
  }
  function makeElementsArray(el) {
    return (Array.isArray(el) ? el : [el]).filter((e) => !!e);
  }
  function setInnerHTML(el, html) {
    if (html === void 0) {
      html = "";
    }
    if (typeof trustedTypes !== "undefined") {
      el.innerHTML = trustedTypes.createPolicy("html", {
        createHTML: (s) => s
      }).createHTML(html);
    } else {
      el.innerHTML = html;
    }
  }

  // node_modules/swiper/shared/swiper-core.mjs
  var support;
  function calcSupport() {
    const window2 = getWindow();
    const document2 = getDocument();
    return {
      smoothScroll: document2.documentElement && document2.documentElement.style && "scrollBehavior" in document2.documentElement.style,
      touch: !!("ontouchstart" in window2 || window2.DocumentTouch && document2 instanceof window2.DocumentTouch)
    };
  }
  function getSupport() {
    if (!support) {
      support = calcSupport();
    }
    return support;
  }
  var deviceCached;
  function calcDevice(_temp) {
    let {
      userAgent
    } = _temp === void 0 ? {} : _temp;
    const support2 = getSupport();
    const window2 = getWindow();
    const platform = window2.navigator.platform;
    const ua = userAgent || window2.navigator.userAgent;
    const device = {
      ios: false,
      android: false
    };
    const screenWidth = window2.screen.width;
    const screenHeight = window2.screen.height;
    const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/);
    let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    const windows = platform === "Win32";
    let macos = platform === "MacIntel";
    const iPadScreens = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
    if (!ipad && macos && support2.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
      ipad = ua.match(/(Version)\/([\d.]+)/);
      if (!ipad) ipad = [0, 1, "13_0_0"];
      macos = false;
    }
    if (android && !windows) {
      device.os = "android";
      device.android = true;
    }
    if (ipad || iphone || ipod) {
      device.os = "ios";
      device.ios = true;
    }
    return device;
  }
  function getDevice(overrides) {
    if (overrides === void 0) {
      overrides = {};
    }
    if (!deviceCached) {
      deviceCached = calcDevice(overrides);
    }
    return deviceCached;
  }
  var browser;
  function calcBrowser() {
    const window2 = getWindow();
    const device = getDevice();
    let needPerspectiveFix = false;
    function isSafari() {
      const ua = window2.navigator.userAgent.toLowerCase();
      return ua.indexOf("safari") >= 0 && ua.indexOf("chrome") < 0 && ua.indexOf("android") < 0;
    }
    if (isSafari()) {
      const ua = String(window2.navigator.userAgent);
      if (ua.includes("Version/")) {
        const [major, minor] = ua.split("Version/")[1].split(" ")[0].split(".").map((num) => Number(num));
        needPerspectiveFix = major < 16 || major === 16 && minor < 2;
      }
    }
    const isWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window2.navigator.userAgent);
    const isSafariBrowser = isSafari();
    const need3dFix = isSafariBrowser || isWebView && device.ios;
    return {
      isSafari: needPerspectiveFix || isSafariBrowser,
      needPerspectiveFix,
      need3dFix,
      isWebView
    };
  }
  function getBrowser() {
    if (!browser) {
      browser = calcBrowser();
    }
    return browser;
  }
  function Resize(_ref) {
    let {
      swiper,
      on,
      emit
    } = _ref;
    const window2 = getWindow();
    let observer = null;
    let animationFrame = null;
    const resizeHandler = () => {
      if (!swiper || swiper.destroyed || !swiper.initialized) return;
      emit("beforeResize");
      emit("resize");
    };
    const createObserver = () => {
      if (!swiper || swiper.destroyed || !swiper.initialized) return;
      observer = new ResizeObserver((entries) => {
        animationFrame = window2.requestAnimationFrame(() => {
          const {
            width,
            height
          } = swiper;
          let newWidth = width;
          let newHeight = height;
          entries.forEach((_ref2) => {
            let {
              contentBoxSize,
              contentRect,
              target
            } = _ref2;
            if (target && target !== swiper.el) return;
            newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
            newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
          });
          if (newWidth !== width || newHeight !== height) {
            resizeHandler();
          }
        });
      });
      observer.observe(swiper.el);
    };
    const removeObserver = () => {
      if (animationFrame) {
        window2.cancelAnimationFrame(animationFrame);
      }
      if (observer && observer.unobserve && swiper.el) {
        observer.unobserve(swiper.el);
        observer = null;
      }
    };
    const orientationChangeHandler = () => {
      if (!swiper || swiper.destroyed || !swiper.initialized) return;
      emit("orientationchange");
    };
    on("init", () => {
      if (swiper.params.resizeObserver && typeof window2.ResizeObserver !== "undefined") {
        createObserver();
        return;
      }
      window2.addEventListener("resize", resizeHandler);
      window2.addEventListener("orientationchange", orientationChangeHandler);
    });
    on("destroy", () => {
      removeObserver();
      window2.removeEventListener("resize", resizeHandler);
      window2.removeEventListener("orientationchange", orientationChangeHandler);
    });
  }
  function Observer(_ref) {
    let {
      swiper,
      extendParams,
      on,
      emit
    } = _ref;
    const observers = [];
    const window2 = getWindow();
    const attach = function(target, options) {
      if (options === void 0) {
        options = {};
      }
      const ObserverFunc = window2.MutationObserver || window2.WebkitMutationObserver;
      const observer = new ObserverFunc((mutations) => {
        if (swiper.__preventObserver__) return;
        if (mutations.length === 1) {
          emit("observerUpdate", mutations[0]);
          return;
        }
        const observerUpdate = function observerUpdate2() {
          emit("observerUpdate", mutations[0]);
        };
        if (window2.requestAnimationFrame) {
          window2.requestAnimationFrame(observerUpdate);
        } else {
          window2.setTimeout(observerUpdate, 0);
        }
      });
      observer.observe(target, {
        attributes: typeof options.attributes === "undefined" ? true : options.attributes,
        childList: swiper.isElement || (typeof options.childList === "undefined" ? true : options).childList,
        characterData: typeof options.characterData === "undefined" ? true : options.characterData
      });
      observers.push(observer);
    };
    const init = () => {
      if (!swiper.params.observer) return;
      if (swiper.params.observeParents) {
        const containerParents = elementParents(swiper.hostEl);
        for (let i = 0; i < containerParents.length; i += 1) {
          attach(containerParents[i]);
        }
      }
      attach(swiper.hostEl, {
        childList: swiper.params.observeSlideChildren
      });
      attach(swiper.wrapperEl, {
        attributes: false
      });
    };
    const destroy = () => {
      observers.forEach((observer) => {
        observer.disconnect();
      });
      observers.splice(0, observers.length);
    };
    extendParams({
      observer: false,
      observeParents: false,
      observeSlideChildren: false
    });
    on("init", init);
    on("destroy", destroy);
  }
  var eventsEmitter = {
    on(events2, handler, priority) {
      const self = this;
      if (!self.eventsListeners || self.destroyed) return self;
      if (typeof handler !== "function") return self;
      const method = priority ? "unshift" : "push";
      events2.split(" ").forEach((event2) => {
        if (!self.eventsListeners[event2]) self.eventsListeners[event2] = [];
        self.eventsListeners[event2][method](handler);
      });
      return self;
    },
    once(events2, handler, priority) {
      const self = this;
      if (!self.eventsListeners || self.destroyed) return self;
      if (typeof handler !== "function") return self;
      function onceHandler() {
        self.off(events2, onceHandler);
        if (onceHandler.__emitterProxy) {
          delete onceHandler.__emitterProxy;
        }
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        handler.apply(self, args);
      }
      onceHandler.__emitterProxy = handler;
      return self.on(events2, onceHandler, priority);
    },
    onAny(handler, priority) {
      const self = this;
      if (!self.eventsListeners || self.destroyed) return self;
      if (typeof handler !== "function") return self;
      const method = priority ? "unshift" : "push";
      if (self.eventsAnyListeners.indexOf(handler) < 0) {
        self.eventsAnyListeners[method](handler);
      }
      return self;
    },
    offAny(handler) {
      const self = this;
      if (!self.eventsListeners || self.destroyed) return self;
      if (!self.eventsAnyListeners) return self;
      const index = self.eventsAnyListeners.indexOf(handler);
      if (index >= 0) {
        self.eventsAnyListeners.splice(index, 1);
      }
      return self;
    },
    off(events2, handler) {
      const self = this;
      if (!self.eventsListeners || self.destroyed) return self;
      if (!self.eventsListeners) return self;
      events2.split(" ").forEach((event2) => {
        if (typeof handler === "undefined") {
          self.eventsListeners[event2] = [];
        } else if (self.eventsListeners[event2]) {
          self.eventsListeners[event2].forEach((eventHandler, index) => {
            if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) {
              self.eventsListeners[event2].splice(index, 1);
            }
          });
        }
      });
      return self;
    },
    emit() {
      const self = this;
      if (!self.eventsListeners || self.destroyed) return self;
      if (!self.eventsListeners) return self;
      let events2;
      let data;
      let context;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      if (typeof args[0] === "string" || Array.isArray(args[0])) {
        events2 = args[0];
        data = args.slice(1, args.length);
        context = self;
      } else {
        events2 = args[0].events;
        data = args[0].data;
        context = args[0].context || self;
      }
      data.unshift(context);
      const eventsArray = Array.isArray(events2) ? events2 : events2.split(" ");
      eventsArray.forEach((event2) => {
        if (self.eventsAnyListeners && self.eventsAnyListeners.length) {
          self.eventsAnyListeners.forEach((eventHandler) => {
            eventHandler.apply(context, [event2, ...data]);
          });
        }
        if (self.eventsListeners && self.eventsListeners[event2]) {
          self.eventsListeners[event2].forEach((eventHandler) => {
            eventHandler.apply(context, data);
          });
        }
      });
      return self;
    }
  };
  function updateSize() {
    const swiper = this;
    let width;
    let height;
    const el = swiper.el;
    if (typeof swiper.params.width !== "undefined" && swiper.params.width !== null) {
      width = swiper.params.width;
    } else {
      width = el.clientWidth;
    }
    if (typeof swiper.params.height !== "undefined" && swiper.params.height !== null) {
      height = swiper.params.height;
    } else {
      height = el.clientHeight;
    }
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
      return;
    }
    width = width - parseInt(elementStyle(el, "padding-left") || 0, 10) - parseInt(elementStyle(el, "padding-right") || 0, 10);
    height = height - parseInt(elementStyle(el, "padding-top") || 0, 10) - parseInt(elementStyle(el, "padding-bottom") || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    Object.assign(swiper, {
      width,
      height,
      size: swiper.isHorizontal() ? width : height
    });
  }
  function updateSlides() {
    const swiper = this;
    function getDirectionPropertyValue(node, label) {
      return parseFloat(node.getPropertyValue(swiper.getDirectionLabel(label)) || 0);
    }
    const params = swiper.params;
    const {
      wrapperEl,
      slidesEl,
      size: swiperSize,
      rtlTranslate: rtl,
      wrongRTL
    } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    const slides = elementChildren(slidesEl, `.${swiper.params.slideClass}, swiper-slide`);
    const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    let snapGrid = [];
    const slidesGrid = [];
    const slidesSizesGrid = [];
    let offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === "function") {
      offsetBefore = params.slidesOffsetBefore.call(swiper);
    }
    let offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === "function") {
      offsetAfter = params.slidesOffsetAfter.call(swiper);
    }
    const previousSnapGridLength = swiper.snapGrid.length;
    const previousSlidesGridLength = swiper.slidesGrid.length;
    let spaceBetween = params.spaceBetween;
    let slidePosition = -offsetBefore;
    let prevSlideSize = 0;
    let index = 0;
    if (typeof swiperSize === "undefined") {
      return;
    }
    if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) {
      spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiperSize;
    } else if (typeof spaceBetween === "string") {
      spaceBetween = parseFloat(spaceBetween);
    }
    swiper.virtualSize = -spaceBetween;
    slides.forEach((slideEl) => {
      if (rtl) {
        slideEl.style.marginLeft = "";
      } else {
        slideEl.style.marginRight = "";
      }
      slideEl.style.marginBottom = "";
      slideEl.style.marginTop = "";
    });
    if (params.centeredSlides && params.cssMode) {
      setCSSProperty(wrapperEl, "--swiper-centered-offset-before", "");
      setCSSProperty(wrapperEl, "--swiper-centered-offset-after", "");
    }
    const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) {
      swiper.grid.initSlides(slides);
    } else if (swiper.grid) {
      swiper.grid.unsetSlides();
    }
    let slideSize;
    const shouldResetSlideSize = params.slidesPerView === "auto" && params.breakpoints && Object.keys(params.breakpoints).filter((key) => {
      return typeof params.breakpoints[key].slidesPerView !== "undefined";
    }).length > 0;
    for (let i = 0; i < slidesLength; i += 1) {
      slideSize = 0;
      let slide2;
      if (slides[i]) slide2 = slides[i];
      if (gridEnabled) {
        swiper.grid.updateSlide(i, slide2, slides);
      }
      if (slides[i] && elementStyle(slide2, "display") === "none") continue;
      if (params.slidesPerView === "auto") {
        if (shouldResetSlideSize) {
          slides[i].style[swiper.getDirectionLabel("width")] = ``;
        }
        const slideStyles = getComputedStyle(slide2);
        const currentTransform = slide2.style.transform;
        const currentWebKitTransform = slide2.style.webkitTransform;
        if (currentTransform) {
          slide2.style.transform = "none";
        }
        if (currentWebKitTransform) {
          slide2.style.webkitTransform = "none";
        }
        if (params.roundLengths) {
          slideSize = swiper.isHorizontal() ? elementOuterSize(slide2, "width", true) : elementOuterSize(slide2, "height", true);
        } else {
          const width = getDirectionPropertyValue(slideStyles, "width");
          const paddingLeft = getDirectionPropertyValue(slideStyles, "padding-left");
          const paddingRight = getDirectionPropertyValue(slideStyles, "padding-right");
          const marginLeft = getDirectionPropertyValue(slideStyles, "margin-left");
          const marginRight = getDirectionPropertyValue(slideStyles, "margin-right");
          const boxSizing = slideStyles.getPropertyValue("box-sizing");
          if (boxSizing && boxSizing === "border-box") {
            slideSize = width + marginLeft + marginRight;
          } else {
            const {
              clientWidth,
              offsetWidth
            } = slide2;
            slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
          }
        }
        if (currentTransform) {
          slide2.style.transform = currentTransform;
        }
        if (currentWebKitTransform) {
          slide2.style.webkitTransform = currentWebKitTransform;
        }
        if (params.roundLengths) slideSize = Math.floor(slideSize);
      } else {
        slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
        if (params.roundLengths) slideSize = Math.floor(slideSize);
        if (slides[i]) {
          slides[i].style[swiper.getDirectionLabel("width")] = `${slideSize}px`;
        }
      }
      if (slides[i]) {
        slides[i].swiperSlideSize = slideSize;
      }
      slidesSizesGrid.push(slideSize);
      if (params.centeredSlides) {
        slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
        if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
        if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
        if (Math.abs(slidePosition) < 1 / 1e3) slidePosition = 0;
        if (params.roundLengths) slidePosition = Math.floor(slidePosition);
        if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
        slidesGrid.push(slidePosition);
      } else {
        if (params.roundLengths) slidePosition = Math.floor(slidePosition);
        if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
        slidesGrid.push(slidePosition);
        slidePosition = slidePosition + slideSize + spaceBetween;
      }
      swiper.virtualSize += slideSize + spaceBetween;
      prevSlideSize = slideSize;
      index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === "slide" || params.effect === "coverflow")) {
      wrapperEl.style.width = `${swiper.virtualSize + spaceBetween}px`;
    }
    if (params.setWrapperSize) {
      wrapperEl.style[swiper.getDirectionLabel("width")] = `${swiper.virtualSize + spaceBetween}px`;
    }
    if (gridEnabled) {
      swiper.grid.updateWrapperSize(slideSize, snapGrid);
    }
    if (!params.centeredSlides) {
      const newSlidesGrid = [];
      for (let i = 0; i < snapGrid.length; i += 1) {
        let slidesGridItem = snapGrid[i];
        if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
        if (snapGrid[i] <= swiper.virtualSize - swiperSize) {
          newSlidesGrid.push(slidesGridItem);
        }
      }
      snapGrid = newSlidesGrid;
      if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
        snapGrid.push(swiper.virtualSize - swiperSize);
      }
    }
    if (isVirtual && params.loop) {
      const size = slidesSizesGrid[0] + spaceBetween;
      if (params.slidesPerGroup > 1) {
        const groups = Math.ceil((swiper.virtual.slidesBefore + swiper.virtual.slidesAfter) / params.slidesPerGroup);
        const groupSize = size * params.slidesPerGroup;
        for (let i = 0; i < groups; i += 1) {
          snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
        }
      }
      for (let i = 0; i < swiper.virtual.slidesBefore + swiper.virtual.slidesAfter; i += 1) {
        if (params.slidesPerGroup === 1) {
          snapGrid.push(snapGrid[snapGrid.length - 1] + size);
        }
        slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
        swiper.virtualSize += size;
      }
    }
    if (snapGrid.length === 0) snapGrid = [0];
    if (spaceBetween !== 0) {
      const key = swiper.isHorizontal() && rtl ? "marginLeft" : swiper.getDirectionLabel("marginRight");
      slides.filter((_, slideIndex) => {
        if (!params.cssMode || params.loop) return true;
        if (slideIndex === slides.length - 1) {
          return false;
        }
        return true;
      }).forEach((slideEl) => {
        slideEl.style[key] = `${spaceBetween}px`;
      });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
      let allSlidesSize = 0;
      slidesSizesGrid.forEach((slideSizeValue) => {
        allSlidesSize += slideSizeValue + (spaceBetween || 0);
      });
      allSlidesSize -= spaceBetween;
      const maxSnap = allSlidesSize > swiperSize ? allSlidesSize - swiperSize : 0;
      snapGrid = snapGrid.map((snap) => {
        if (snap <= 0) return -offsetBefore;
        if (snap > maxSnap) return maxSnap + offsetAfter;
        return snap;
      });
    }
    if (params.centerInsufficientSlides) {
      let allSlidesSize = 0;
      slidesSizesGrid.forEach((slideSizeValue) => {
        allSlidesSize += slideSizeValue + (spaceBetween || 0);
      });
      allSlidesSize -= spaceBetween;
      const offsetSize = (params.slidesOffsetBefore || 0) + (params.slidesOffsetAfter || 0);
      if (allSlidesSize + offsetSize < swiperSize) {
        const allSlidesOffset = (swiperSize - allSlidesSize - offsetSize) / 2;
        snapGrid.forEach((snap, snapIndex) => {
          snapGrid[snapIndex] = snap - allSlidesOffset;
        });
        slidesGrid.forEach((snap, snapIndex) => {
          slidesGrid[snapIndex] = snap + allSlidesOffset;
        });
      }
    }
    Object.assign(swiper, {
      slides,
      snapGrid,
      slidesGrid,
      slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
      setCSSProperty(wrapperEl, "--swiper-centered-offset-before", `${-snapGrid[0]}px`);
      setCSSProperty(wrapperEl, "--swiper-centered-offset-after", `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
      const addToSnapGrid = -swiper.snapGrid[0];
      const addToSlidesGrid = -swiper.slidesGrid[0];
      swiper.snapGrid = swiper.snapGrid.map((v) => v + addToSnapGrid);
      swiper.slidesGrid = swiper.slidesGrid.map((v) => v + addToSlidesGrid);
    }
    if (slidesLength !== previousSlidesLength) {
      swiper.emit("slidesLengthChange");
    }
    if (snapGrid.length !== previousSnapGridLength) {
      if (swiper.params.watchOverflow) swiper.checkOverflow();
      swiper.emit("snapGridLengthChange");
    }
    if (slidesGrid.length !== previousSlidesGridLength) {
      swiper.emit("slidesGridLengthChange");
    }
    if (params.watchSlidesProgress) {
      swiper.updateSlidesOffset();
    }
    swiper.emit("slidesUpdated");
    if (!isVirtual && !params.cssMode && (params.effect === "slide" || params.effect === "fade")) {
      const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
      const hasClassBackfaceClassAdded = swiper.el.classList.contains(backFaceHiddenClass);
      if (slidesLength <= params.maxBackfaceHiddenSlides) {
        if (!hasClassBackfaceClassAdded) swiper.el.classList.add(backFaceHiddenClass);
      } else if (hasClassBackfaceClassAdded) {
        swiper.el.classList.remove(backFaceHiddenClass);
      }
    }
  }
  function updateAutoHeight(speed) {
    const swiper = this;
    const activeSlides = [];
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    let newHeight = 0;
    let i;
    if (typeof speed === "number") {
      swiper.setTransition(speed);
    } else if (speed === true) {
      swiper.setTransition(swiper.params.speed);
    }
    const getSlideByIndex = (index) => {
      if (isVirtual) {
        return swiper.slides[swiper.getSlideIndexByData(index)];
      }
      return swiper.slides[index];
    };
    if (swiper.params.slidesPerView !== "auto" && swiper.params.slidesPerView > 1) {
      if (swiper.params.centeredSlides) {
        (swiper.visibleSlides || []).forEach((slide2) => {
          activeSlides.push(slide2);
        });
      } else {
        for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
          const index = swiper.activeIndex + i;
          if (index > swiper.slides.length && !isVirtual) break;
          activeSlides.push(getSlideByIndex(index));
        }
      }
    } else {
      activeSlides.push(getSlideByIndex(swiper.activeIndex));
    }
    for (i = 0; i < activeSlides.length; i += 1) {
      if (typeof activeSlides[i] !== "undefined") {
        const height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
      }
    }
    if (newHeight || newHeight === 0) swiper.wrapperEl.style.height = `${newHeight}px`;
  }
  function updateSlidesOffset() {
    const swiper = this;
    const slides = swiper.slides;
    const minusOffset = swiper.isElement ? swiper.isHorizontal() ? swiper.wrapperEl.offsetLeft : swiper.wrapperEl.offsetTop : 0;
    for (let i = 0; i < slides.length; i += 1) {
      slides[i].swiperSlideOffset = (swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop) - minusOffset - swiper.cssOverflowAdjustment();
    }
  }
  var toggleSlideClasses$1 = (slideEl, condition, className) => {
    if (condition && !slideEl.classList.contains(className)) {
      slideEl.classList.add(className);
    } else if (!condition && slideEl.classList.contains(className)) {
      slideEl.classList.remove(className);
    }
  };
  function updateSlidesProgress(translate2) {
    if (translate2 === void 0) {
      translate2 = this && this.translate || 0;
    }
    const swiper = this;
    const params = swiper.params;
    const {
      slides,
      rtlTranslate: rtl,
      snapGrid
    } = swiper;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === "undefined") swiper.updateSlidesOffset();
    let offsetCenter = -translate2;
    if (rtl) offsetCenter = translate2;
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    let spaceBetween = params.spaceBetween;
    if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) {
      spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiper.size;
    } else if (typeof spaceBetween === "string") {
      spaceBetween = parseFloat(spaceBetween);
    }
    for (let i = 0; i < slides.length; i += 1) {
      const slide2 = slides[i];
      let slideOffset = slide2.swiperSlideOffset;
      if (params.cssMode && params.centeredSlides) {
        slideOffset -= slides[0].swiperSlideOffset;
      }
      const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide2.swiperSlideSize + spaceBetween);
      const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide2.swiperSlideSize + spaceBetween);
      const slideBefore = -(offsetCenter - slideOffset);
      const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
      const isFullyVisible = slideBefore >= 0 && slideBefore <= swiper.size - swiper.slidesSizesGrid[i];
      const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
      if (isVisible) {
        swiper.visibleSlides.push(slide2);
        swiper.visibleSlidesIndexes.push(i);
      }
      toggleSlideClasses$1(slide2, isVisible, params.slideVisibleClass);
      toggleSlideClasses$1(slide2, isFullyVisible, params.slideFullyVisibleClass);
      slide2.progress = rtl ? -slideProgress : slideProgress;
      slide2.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
  }
  function updateProgress(translate2) {
    const swiper = this;
    if (typeof translate2 === "undefined") {
      const multiplier = swiper.rtlTranslate ? -1 : 1;
      translate2 = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    const params = swiper.params;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    let {
      progress,
      isBeginning,
      isEnd,
      progressLoop
    } = swiper;
    const wasBeginning = isBeginning;
    const wasEnd = isEnd;
    if (translatesDiff === 0) {
      progress = 0;
      isBeginning = true;
      isEnd = true;
    } else {
      progress = (translate2 - swiper.minTranslate()) / translatesDiff;
      const isBeginningRounded = Math.abs(translate2 - swiper.minTranslate()) < 1;
      const isEndRounded = Math.abs(translate2 - swiper.maxTranslate()) < 1;
      isBeginning = isBeginningRounded || progress <= 0;
      isEnd = isEndRounded || progress >= 1;
      if (isBeginningRounded) progress = 0;
      if (isEndRounded) progress = 1;
    }
    if (params.loop) {
      const firstSlideIndex = swiper.getSlideIndexByData(0);
      const lastSlideIndex = swiper.getSlideIndexByData(swiper.slides.length - 1);
      const firstSlideTranslate = swiper.slidesGrid[firstSlideIndex];
      const lastSlideTranslate = swiper.slidesGrid[lastSlideIndex];
      const translateMax = swiper.slidesGrid[swiper.slidesGrid.length - 1];
      const translateAbs = Math.abs(translate2);
      if (translateAbs >= firstSlideTranslate) {
        progressLoop = (translateAbs - firstSlideTranslate) / translateMax;
      } else {
        progressLoop = (translateAbs + translateMax - lastSlideTranslate) / translateMax;
      }
      if (progressLoop > 1) progressLoop -= 1;
    }
    Object.assign(swiper, {
      progress,
      progressLoop,
      isBeginning,
      isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate2);
    if (isBeginning && !wasBeginning) {
      swiper.emit("reachBeginning toEdge");
    }
    if (isEnd && !wasEnd) {
      swiper.emit("reachEnd toEdge");
    }
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
      swiper.emit("fromEdge");
    }
    swiper.emit("progress", progress);
  }
  var toggleSlideClasses = (slideEl, condition, className) => {
    if (condition && !slideEl.classList.contains(className)) {
      slideEl.classList.add(className);
    } else if (!condition && slideEl.classList.contains(className)) {
      slideEl.classList.remove(className);
    }
  };
  function updateSlidesClasses() {
    const swiper = this;
    const {
      slides,
      params,
      slidesEl,
      activeIndex
    } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    const getFilteredSlide = (selector) => {
      return elementChildren(slidesEl, `.${params.slideClass}${selector}, swiper-slide${selector}`)[0];
    };
    let activeSlide;
    let prevSlide;
    let nextSlide;
    if (isVirtual) {
      if (params.loop) {
        let slideIndex = activeIndex - swiper.virtual.slidesBefore;
        if (slideIndex < 0) slideIndex = swiper.virtual.slides.length + slideIndex;
        if (slideIndex >= swiper.virtual.slides.length) slideIndex -= swiper.virtual.slides.length;
        activeSlide = getFilteredSlide(`[data-swiper-slide-index="${slideIndex}"]`);
      } else {
        activeSlide = getFilteredSlide(`[data-swiper-slide-index="${activeIndex}"]`);
      }
    } else {
      if (gridEnabled) {
        activeSlide = slides.find((slideEl) => slideEl.column === activeIndex);
        nextSlide = slides.find((slideEl) => slideEl.column === activeIndex + 1);
        prevSlide = slides.find((slideEl) => slideEl.column === activeIndex - 1);
      } else {
        activeSlide = slides[activeIndex];
      }
    }
    if (activeSlide) {
      if (!gridEnabled) {
        nextSlide = elementNextAll(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
        if (params.loop && !nextSlide) {
          nextSlide = slides[0];
        }
        prevSlide = elementPrevAll(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
        if (params.loop && !prevSlide === 0) {
          prevSlide = slides[slides.length - 1];
        }
      }
    }
    slides.forEach((slideEl) => {
      toggleSlideClasses(slideEl, slideEl === activeSlide, params.slideActiveClass);
      toggleSlideClasses(slideEl, slideEl === nextSlide, params.slideNextClass);
      toggleSlideClasses(slideEl, slideEl === prevSlide, params.slidePrevClass);
    });
    swiper.emitSlidesClasses();
  }
  var processLazyPreloader = (swiper, imageEl) => {
    if (!swiper || swiper.destroyed || !swiper.params) return;
    const slideSelector = () => swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    const slideEl = imageEl.closest(slideSelector());
    if (slideEl) {
      let lazyEl = slideEl.querySelector(`.${swiper.params.lazyPreloaderClass}`);
      if (!lazyEl && swiper.isElement) {
        if (slideEl.shadowRoot) {
          lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
        } else {
          requestAnimationFrame(() => {
            if (slideEl.shadowRoot) {
              lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
              if (lazyEl) lazyEl.remove();
            }
          });
        }
      }
      if (lazyEl) lazyEl.remove();
    }
  };
  var unlazy = (swiper, index) => {
    if (!swiper.slides[index]) return;
    const imageEl = swiper.slides[index].querySelector('[loading="lazy"]');
    if (imageEl) imageEl.removeAttribute("loading");
  };
  var preload = (swiper) => {
    if (!swiper || swiper.destroyed || !swiper.params) return;
    let amount = swiper.params.lazyPreloadPrevNext;
    const len = swiper.slides.length;
    if (!len || !amount || amount < 0) return;
    amount = Math.min(amount, len);
    const slidesPerView = swiper.params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(swiper.params.slidesPerView);
    const activeIndex = swiper.activeIndex;
    if (swiper.params.grid && swiper.params.grid.rows > 1) {
      const activeColumn = activeIndex;
      const preloadColumns = [activeColumn - amount];
      preloadColumns.push(...Array.from({
        length: amount
      }).map((_, i) => {
        return activeColumn + slidesPerView + i;
      }));
      swiper.slides.forEach((slideEl, i) => {
        if (preloadColumns.includes(slideEl.column)) unlazy(swiper, i);
      });
      return;
    }
    const slideIndexLastInView = activeIndex + slidesPerView - 1;
    if (swiper.params.rewind || swiper.params.loop) {
      for (let i = activeIndex - amount; i <= slideIndexLastInView + amount; i += 1) {
        const realIndex = (i % len + len) % len;
        if (realIndex < activeIndex || realIndex > slideIndexLastInView) unlazy(swiper, realIndex);
      }
    } else {
      for (let i = Math.max(activeIndex - amount, 0); i <= Math.min(slideIndexLastInView + amount, len - 1); i += 1) {
        if (i !== activeIndex && (i > slideIndexLastInView || i < activeIndex)) {
          unlazy(swiper, i);
        }
      }
    }
  };
  function getActiveIndexByTranslate(swiper) {
    const {
      slidesGrid,
      params
    } = swiper;
    const translate2 = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    let activeIndex;
    for (let i = 0; i < slidesGrid.length; i += 1) {
      if (typeof slidesGrid[i + 1] !== "undefined") {
        if (translate2 >= slidesGrid[i] && translate2 < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
          activeIndex = i;
        } else if (translate2 >= slidesGrid[i] && translate2 < slidesGrid[i + 1]) {
          activeIndex = i + 1;
        }
      } else if (translate2 >= slidesGrid[i]) {
        activeIndex = i;
      }
    }
    if (params.normalizeSlideIndex) {
      if (activeIndex < 0 || typeof activeIndex === "undefined") activeIndex = 0;
    }
    return activeIndex;
  }
  function updateActiveIndex(newActiveIndex) {
    const swiper = this;
    const translate2 = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    const {
      snapGrid,
      params,
      activeIndex: previousIndex,
      realIndex: previousRealIndex,
      snapIndex: previousSnapIndex
    } = swiper;
    let activeIndex = newActiveIndex;
    let snapIndex;
    const getVirtualRealIndex = (aIndex) => {
      let realIndex2 = aIndex - swiper.virtual.slidesBefore;
      if (realIndex2 < 0) {
        realIndex2 = swiper.virtual.slides.length + realIndex2;
      }
      if (realIndex2 >= swiper.virtual.slides.length) {
        realIndex2 -= swiper.virtual.slides.length;
      }
      return realIndex2;
    };
    if (typeof activeIndex === "undefined") {
      activeIndex = getActiveIndexByTranslate(swiper);
    }
    if (snapGrid.indexOf(translate2) >= 0) {
      snapIndex = snapGrid.indexOf(translate2);
    } else {
      const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
      snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex && !swiper.params.loop) {
      if (snapIndex !== previousSnapIndex) {
        swiper.snapIndex = snapIndex;
        swiper.emit("snapIndexChange");
      }
      return;
    }
    if (activeIndex === previousIndex && swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
      swiper.realIndex = getVirtualRealIndex(activeIndex);
      return;
    }
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    let realIndex;
    if (swiper.virtual && params.virtual.enabled && params.loop) {
      realIndex = getVirtualRealIndex(activeIndex);
    } else if (gridEnabled) {
      const firstSlideInColumn = swiper.slides.find((slideEl) => slideEl.column === activeIndex);
      let activeSlideIndex = parseInt(firstSlideInColumn.getAttribute("data-swiper-slide-index"), 10);
      if (Number.isNaN(activeSlideIndex)) {
        activeSlideIndex = Math.max(swiper.slides.indexOf(firstSlideInColumn), 0);
      }
      realIndex = Math.floor(activeSlideIndex / params.grid.rows);
    } else if (swiper.slides[activeIndex]) {
      const slideIndex = swiper.slides[activeIndex].getAttribute("data-swiper-slide-index");
      if (slideIndex) {
        realIndex = parseInt(slideIndex, 10);
      } else {
        realIndex = activeIndex;
      }
    } else {
      realIndex = activeIndex;
    }
    Object.assign(swiper, {
      previousSnapIndex,
      snapIndex,
      previousRealIndex,
      realIndex,
      previousIndex,
      activeIndex
    });
    if (swiper.initialized) {
      preload(swiper);
    }
    swiper.emit("activeIndexChange");
    swiper.emit("snapIndexChange");
    if (swiper.initialized || swiper.params.runCallbacksOnInit) {
      if (previousRealIndex !== realIndex) {
        swiper.emit("realIndexChange");
      }
      swiper.emit("slideChange");
    }
  }
  function updateClickedSlide(el, path) {
    const swiper = this;
    const params = swiper.params;
    let slide2 = el.closest(`.${params.slideClass}, swiper-slide`);
    if (!slide2 && swiper.isElement && path && path.length > 1 && path.includes(el)) {
      [...path.slice(path.indexOf(el) + 1, path.length)].forEach((pathEl) => {
        if (!slide2 && pathEl.matches && pathEl.matches(`.${params.slideClass}, swiper-slide`)) {
          slide2 = pathEl;
        }
      });
    }
    let slideFound = false;
    let slideIndex;
    if (slide2) {
      for (let i = 0; i < swiper.slides.length; i += 1) {
        if (swiper.slides[i] === slide2) {
          slideFound = true;
          slideIndex = i;
          break;
        }
      }
    }
    if (slide2 && slideFound) {
      swiper.clickedSlide = slide2;
      if (swiper.virtual && swiper.params.virtual.enabled) {
        swiper.clickedIndex = parseInt(slide2.getAttribute("data-swiper-slide-index"), 10);
      } else {
        swiper.clickedIndex = slideIndex;
      }
    } else {
      swiper.clickedSlide = void 0;
      swiper.clickedIndex = void 0;
      return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== void 0 && swiper.clickedIndex !== swiper.activeIndex) {
      swiper.slideToClickedSlide();
    }
  }
  var update = {
    updateSize,
    updateSlides,
    updateAutoHeight,
    updateSlidesOffset,
    updateSlidesProgress,
    updateProgress,
    updateSlidesClasses,
    updateActiveIndex,
    updateClickedSlide
  };
  function getSwiperTranslate(axis) {
    if (axis === void 0) {
      axis = this.isHorizontal() ? "x" : "y";
    }
    const swiper = this;
    const {
      params,
      rtlTranslate: rtl,
      translate: translate2,
      wrapperEl
    } = swiper;
    if (params.virtualTranslate) {
      return rtl ? -translate2 : translate2;
    }
    if (params.cssMode) {
      return translate2;
    }
    let currentTranslate = getTranslate(wrapperEl, axis);
    currentTranslate += swiper.cssOverflowAdjustment();
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
  }
  function setTranslate(translate2, byController) {
    const swiper = this;
    const {
      rtlTranslate: rtl,
      params,
      wrapperEl,
      progress
    } = swiper;
    let x = 0;
    let y = 0;
    const z = 0;
    if (swiper.isHorizontal()) {
      x = rtl ? -translate2 : translate2;
    } else {
      y = translate2;
    }
    if (params.roundLengths) {
      x = Math.floor(x);
      y = Math.floor(y);
    }
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y;
    if (params.cssMode) {
      wrapperEl[swiper.isHorizontal() ? "scrollLeft" : "scrollTop"] = swiper.isHorizontal() ? -x : -y;
    } else if (!params.virtualTranslate) {
      if (swiper.isHorizontal()) {
        x -= swiper.cssOverflowAdjustment();
      } else {
        y -= swiper.cssOverflowAdjustment();
      }
      wrapperEl.style.transform = `translate3d(${x}px, ${y}px, ${z}px)`;
    }
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) {
      newProgress = 0;
    } else {
      newProgress = (translate2 - swiper.minTranslate()) / translatesDiff;
    }
    if (newProgress !== progress) {
      swiper.updateProgress(translate2);
    }
    swiper.emit("setTranslate", swiper.translate, byController);
  }
  function minTranslate() {
    return -this.snapGrid[0];
  }
  function maxTranslate() {
    return -this.snapGrid[this.snapGrid.length - 1];
  }
  function translateTo(translate2, speed, runCallbacks, translateBounds, internal) {
    if (translate2 === void 0) {
      translate2 = 0;
    }
    if (speed === void 0) {
      speed = this.params.speed;
    }
    if (runCallbacks === void 0) {
      runCallbacks = true;
    }
    if (translateBounds === void 0) {
      translateBounds = true;
    }
    const swiper = this;
    const {
      params,
      wrapperEl
    } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition) {
      return false;
    }
    const minTranslate2 = swiper.minTranslate();
    const maxTranslate2 = swiper.maxTranslate();
    let newTranslate;
    if (translateBounds && translate2 > minTranslate2) newTranslate = minTranslate2;
    else if (translateBounds && translate2 < maxTranslate2) newTranslate = maxTranslate2;
    else newTranslate = translate2;
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
      const isH = swiper.isHorizontal();
      if (speed === 0) {
        wrapperEl[isH ? "scrollLeft" : "scrollTop"] = -newTranslate;
      } else {
        if (!swiper.support.smoothScroll) {
          animateCSSModeScroll({
            swiper,
            targetPosition: -newTranslate,
            side: isH ? "left" : "top"
          });
          return true;
        }
        wrapperEl.scrollTo({
          [isH ? "left" : "top"]: -newTranslate,
          behavior: "smooth"
        });
      }
      return true;
    }
    if (speed === 0) {
      swiper.setTransition(0);
      swiper.setTranslate(newTranslate);
      if (runCallbacks) {
        swiper.emit("beforeTransitionStart", speed, internal);
        swiper.emit("transitionEnd");
      }
    } else {
      swiper.setTransition(speed);
      swiper.setTranslate(newTranslate);
      if (runCallbacks) {
        swiper.emit("beforeTransitionStart", speed, internal);
        swiper.emit("transitionStart");
      }
      if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onTranslateToWrapperTransitionEnd) {
          swiper.onTranslateToWrapperTransitionEnd = function transitionEnd2(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.wrapperEl.removeEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
            swiper.onTranslateToWrapperTransitionEnd = null;
            delete swiper.onTranslateToWrapperTransitionEnd;
            swiper.animating = false;
            if (runCallbacks) {
              swiper.emit("transitionEnd");
            }
          };
        }
        swiper.wrapperEl.addEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
      }
    }
    return true;
  }
  var translate = {
    getTranslate: getSwiperTranslate,
    setTranslate,
    minTranslate,
    maxTranslate,
    translateTo
  };
  function setTransition(duration, byController) {
    const swiper = this;
    if (!swiper.params.cssMode) {
      swiper.wrapperEl.style.transitionDuration = `${duration}ms`;
      swiper.wrapperEl.style.transitionDelay = duration === 0 ? `0ms` : "";
    }
    swiper.emit("setTransition", duration, byController);
  }
  function transitionEmit(_ref) {
    let {
      swiper,
      runCallbacks,
      direction,
      step
    } = _ref;
    const {
      activeIndex,
      previousIndex
    } = swiper;
    let dir = direction;
    if (!dir) {
      if (activeIndex > previousIndex) dir = "next";
      else if (activeIndex < previousIndex) dir = "prev";
      else dir = "reset";
    }
    swiper.emit(`transition${step}`);
    if (runCallbacks && dir === "reset") {
      swiper.emit(`slideResetTransition${step}`);
    } else if (runCallbacks && activeIndex !== previousIndex) {
      swiper.emit(`slideChangeTransition${step}`);
      if (dir === "next") {
        swiper.emit(`slideNextTransition${step}`);
      } else {
        swiper.emit(`slidePrevTransition${step}`);
      }
    }
  }
  function transitionStart(runCallbacks, direction) {
    if (runCallbacks === void 0) {
      runCallbacks = true;
    }
    const swiper = this;
    const {
      params
    } = swiper;
    if (params.cssMode) return;
    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }
    transitionEmit({
      swiper,
      runCallbacks,
      direction,
      step: "Start"
    });
  }
  function transitionEnd(runCallbacks, direction) {
    if (runCallbacks === void 0) {
      runCallbacks = true;
    }
    const swiper = this;
    const {
      params
    } = swiper;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    transitionEmit({
      swiper,
      runCallbacks,
      direction,
      step: "End"
    });
  }
  var transition = {
    setTransition,
    transitionStart,
    transitionEnd
  };
  function slideTo(index, speed, runCallbacks, internal, initial) {
    if (index === void 0) {
      index = 0;
    }
    if (runCallbacks === void 0) {
      runCallbacks = true;
    }
    if (typeof index === "string") {
      index = parseInt(index, 10);
    }
    const swiper = this;
    let slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    const {
      params,
      snapGrid,
      slidesGrid,
      previousIndex,
      activeIndex,
      rtlTranslate: rtl,
      wrapperEl,
      enabled
    } = swiper;
    if (!enabled && !internal && !initial || swiper.destroyed || swiper.animating && params.preventInteractionOnTransition) {
      return false;
    }
    if (typeof speed === "undefined") {
      speed = swiper.params.speed;
    }
    const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    const translate2 = -snapGrid[snapIndex];
    if (params.normalizeSlideIndex) {
      for (let i = 0; i < slidesGrid.length; i += 1) {
        const normalizedTranslate = -Math.floor(translate2 * 100);
        const normalizedGrid = Math.floor(slidesGrid[i] * 100);
        const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== "undefined") {
          if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) {
            slideIndex = i;
          } else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) {
            slideIndex = i + 1;
          }
        } else if (normalizedTranslate >= normalizedGrid) {
          slideIndex = i;
        }
      }
    }
    if (swiper.initialized && slideIndex !== activeIndex) {
      if (!swiper.allowSlideNext && (rtl ? translate2 > swiper.translate && translate2 > swiper.minTranslate() : translate2 < swiper.translate && translate2 < swiper.minTranslate())) {
        return false;
      }
      if (!swiper.allowSlidePrev && translate2 > swiper.translate && translate2 > swiper.maxTranslate()) {
        if ((activeIndex || 0) !== slideIndex) {
          return false;
        }
      }
    }
    if (slideIndex !== (previousIndex || 0) && runCallbacks) {
      swiper.emit("beforeSlideChangeStart");
    }
    swiper.updateProgress(translate2);
    let direction;
    if (slideIndex > activeIndex) direction = "next";
    else if (slideIndex < activeIndex) direction = "prev";
    else direction = "reset";
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    const isInitialVirtual = isVirtual && initial;
    if (!isInitialVirtual && (rtl && -translate2 === swiper.translate || !rtl && translate2 === swiper.translate)) {
      swiper.updateActiveIndex(slideIndex);
      if (params.autoHeight) {
        swiper.updateAutoHeight();
      }
      swiper.updateSlidesClasses();
      if (params.effect !== "slide") {
        swiper.setTranslate(translate2);
      }
      if (direction !== "reset") {
        swiper.transitionStart(runCallbacks, direction);
        swiper.transitionEnd(runCallbacks, direction);
      }
      return false;
    }
    if (params.cssMode) {
      const isH = swiper.isHorizontal();
      const t = rtl ? translate2 : -translate2;
      if (speed === 0) {
        if (isVirtual) {
          swiper.wrapperEl.style.scrollSnapType = "none";
          swiper._immediateVirtual = true;
        }
        if (isVirtual && !swiper._cssModeVirtualInitialSet && swiper.params.initialSlide > 0) {
          swiper._cssModeVirtualInitialSet = true;
          requestAnimationFrame(() => {
            wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
          });
        } else {
          wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
        }
        if (isVirtual) {
          requestAnimationFrame(() => {
            swiper.wrapperEl.style.scrollSnapType = "";
            swiper._immediateVirtual = false;
          });
        }
      } else {
        if (!swiper.support.smoothScroll) {
          animateCSSModeScroll({
            swiper,
            targetPosition: t,
            side: isH ? "left" : "top"
          });
          return true;
        }
        wrapperEl.scrollTo({
          [isH ? "left" : "top"]: t,
          behavior: "smooth"
        });
      }
      return true;
    }
    const browser2 = getBrowser();
    const isSafari = browser2.isSafari;
    if (isVirtual && !initial && isSafari && swiper.isElement) {
      swiper.virtual.update(false, false, slideIndex);
    }
    swiper.setTransition(speed);
    swiper.setTranslate(translate2);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit("beforeTransitionStart", speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) {
      swiper.transitionEnd(runCallbacks, direction);
    } else if (!swiper.animating) {
      swiper.animating = true;
      if (!swiper.onSlideToWrapperTransitionEnd) {
        swiper.onSlideToWrapperTransitionEnd = function transitionEnd2(e) {
          if (!swiper || swiper.destroyed) return;
          if (e.target !== this) return;
          swiper.wrapperEl.removeEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
          swiper.onSlideToWrapperTransitionEnd = null;
          delete swiper.onSlideToWrapperTransitionEnd;
          swiper.transitionEnd(runCallbacks, direction);
        };
      }
      swiper.wrapperEl.addEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
  }
  function slideToLoop(index, speed, runCallbacks, internal) {
    if (index === void 0) {
      index = 0;
    }
    if (runCallbacks === void 0) {
      runCallbacks = true;
    }
    if (typeof index === "string") {
      const indexAsNumber = parseInt(index, 10);
      index = indexAsNumber;
    }
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === "undefined") {
      speed = swiper.params.speed;
    }
    const gridEnabled = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
    let newIndex = index;
    if (swiper.params.loop) {
      if (swiper.virtual && swiper.params.virtual.enabled) {
        newIndex = newIndex + swiper.virtual.slidesBefore;
      } else {
        let targetSlideIndex;
        if (gridEnabled) {
          const slideIndex = newIndex * swiper.params.grid.rows;
          targetSlideIndex = swiper.slides.find((slideEl) => slideEl.getAttribute("data-swiper-slide-index") * 1 === slideIndex).column;
        } else {
          targetSlideIndex = swiper.getSlideIndexByData(newIndex);
        }
        const cols = gridEnabled ? Math.ceil(swiper.slides.length / swiper.params.grid.rows) : swiper.slides.length;
        const {
          centeredSlides
        } = swiper.params;
        let slidesPerView = swiper.params.slidesPerView;
        if (slidesPerView === "auto") {
          slidesPerView = swiper.slidesPerViewDynamic();
        } else {
          slidesPerView = Math.ceil(parseFloat(swiper.params.slidesPerView, 10));
          if (centeredSlides && slidesPerView % 2 === 0) {
            slidesPerView = slidesPerView + 1;
          }
        }
        let needLoopFix = cols - targetSlideIndex < slidesPerView;
        if (centeredSlides) {
          needLoopFix = needLoopFix || targetSlideIndex < Math.ceil(slidesPerView / 2);
        }
        if (internal && centeredSlides && swiper.params.slidesPerView !== "auto" && !gridEnabled) {
          needLoopFix = false;
        }
        if (needLoopFix) {
          const direction = centeredSlides ? targetSlideIndex < swiper.activeIndex ? "prev" : "next" : targetSlideIndex - swiper.activeIndex - 1 < swiper.params.slidesPerView ? "next" : "prev";
          swiper.loopFix({
            direction,
            slideTo: true,
            activeSlideIndex: direction === "next" ? targetSlideIndex + 1 : targetSlideIndex - cols + 1,
            slideRealIndex: direction === "next" ? swiper.realIndex : void 0
          });
        }
        if (gridEnabled) {
          const slideIndex = newIndex * swiper.params.grid.rows;
          newIndex = swiper.slides.find((slideEl) => slideEl.getAttribute("data-swiper-slide-index") * 1 === slideIndex).column;
        } else {
          newIndex = swiper.getSlideIndexByData(newIndex);
        }
      }
    }
    requestAnimationFrame(() => {
      swiper.slideTo(newIndex, speed, runCallbacks, internal);
    });
    return swiper;
  }
  function slideNext(speed, runCallbacks, internal) {
    if (runCallbacks === void 0) {
      runCallbacks = true;
    }
    const swiper = this;
    const {
      enabled,
      params,
      animating
    } = swiper;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === "undefined") {
      speed = swiper.params.speed;
    }
    let perGroup = params.slidesPerGroup;
    if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
      perGroup = Math.max(swiper.slidesPerViewDynamic("current", true), 1);
    }
    const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
      if (animating && !isVirtual && params.loopPreventsSliding) return false;
      swiper.loopFix({
        direction: "next"
      });
      swiper._clientLeft = swiper.wrapperEl.clientLeft;
      if (swiper.activeIndex === swiper.slides.length - 1 && params.cssMode) {
        requestAnimationFrame(() => {
          swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
        });
        return true;
      }
    }
    if (params.rewind && swiper.isEnd) {
      return swiper.slideTo(0, speed, runCallbacks, internal);
    }
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
  }
  function slidePrev(speed, runCallbacks, internal) {
    if (runCallbacks === void 0) {
      runCallbacks = true;
    }
    const swiper = this;
    const {
      params,
      snapGrid,
      slidesGrid,
      rtlTranslate,
      enabled,
      animating
    } = swiper;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === "undefined") {
      speed = swiper.params.speed;
    }
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
      if (animating && !isVirtual && params.loopPreventsSliding) return false;
      swiper.loopFix({
        direction: "prev"
      });
      swiper._clientLeft = swiper.wrapperEl.clientLeft;
    }
    const translate2 = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
      if (val < 0) return -Math.floor(Math.abs(val));
      return Math.floor(val);
    }
    const normalizedTranslate = normalize(translate2);
    const normalizedSnapGrid = snapGrid.map((val) => normalize(val));
    const isFreeMode = params.freeMode && params.freeMode.enabled;
    let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === "undefined" && (params.cssMode || isFreeMode)) {
      let prevSnapIndex;
      snapGrid.forEach((snap, snapIndex) => {
        if (normalizedTranslate >= snap) {
          prevSnapIndex = snapIndex;
        }
      });
      if (typeof prevSnapIndex !== "undefined") {
        prevSnap = isFreeMode ? snapGrid[prevSnapIndex] : snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
      }
    }
    let prevIndex = 0;
    if (typeof prevSnap !== "undefined") {
      prevIndex = slidesGrid.indexOf(prevSnap);
      if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
      if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
        prevIndex = prevIndex - swiper.slidesPerViewDynamic("previous", true) + 1;
        prevIndex = Math.max(prevIndex, 0);
      }
    }
    if (params.rewind && swiper.isBeginning) {
      const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
      return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
    } else if (params.loop && swiper.activeIndex === 0 && params.cssMode) {
      requestAnimationFrame(() => {
        swiper.slideTo(prevIndex, speed, runCallbacks, internal);
      });
      return true;
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
  }
  function slideReset(speed, runCallbacks, internal) {
    if (runCallbacks === void 0) {
      runCallbacks = true;
    }
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === "undefined") {
      speed = swiper.params.speed;
    }
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
  }
  function slideToClosest(speed, runCallbacks, internal, threshold) {
    if (runCallbacks === void 0) {
      runCallbacks = true;
    }
    if (threshold === void 0) {
      threshold = 0.5;
    }
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === "undefined") {
      speed = swiper.params.speed;
    }
    let index = swiper.activeIndex;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    const translate2 = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate2 >= swiper.snapGrid[snapIndex]) {
      const currentSnap = swiper.snapGrid[snapIndex];
      const nextSnap = swiper.snapGrid[snapIndex + 1];
      if (translate2 - currentSnap > (nextSnap - currentSnap) * threshold) {
        index += swiper.params.slidesPerGroup;
      }
    } else {
      const prevSnap = swiper.snapGrid[snapIndex - 1];
      const currentSnap = swiper.snapGrid[snapIndex];
      if (translate2 - prevSnap <= (currentSnap - prevSnap) * threshold) {
        index -= swiper.params.slidesPerGroup;
      }
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
  }
  function slideToClickedSlide() {
    const swiper = this;
    if (swiper.destroyed) return;
    const {
      params,
      slidesEl
    } = swiper;
    const slidesPerView = params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    let slideToIndex = swiper.getSlideIndexWhenGrid(swiper.clickedIndex);
    let realIndex;
    const slideSelector = swiper.isElement ? `swiper-slide` : `.${params.slideClass}`;
    const isGrid = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
    if (params.loop) {
      if (swiper.animating) return;
      realIndex = parseInt(swiper.clickedSlide.getAttribute("data-swiper-slide-index"), 10);
      if (params.centeredSlides) {
        swiper.slideToLoop(realIndex);
      } else if (slideToIndex > (isGrid ? (swiper.slides.length - slidesPerView) / 2 - (swiper.params.grid.rows - 1) : swiper.slides.length - slidesPerView)) {
        swiper.loopFix();
        slideToIndex = swiper.getSlideIndex(elementChildren(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
        nextTick(() => {
          swiper.slideTo(slideToIndex);
        });
      } else {
        swiper.slideTo(slideToIndex);
      }
    } else {
      swiper.slideTo(slideToIndex);
    }
  }
  var slide = {
    slideTo,
    slideToLoop,
    slideNext,
    slidePrev,
    slideReset,
    slideToClosest,
    slideToClickedSlide
  };
  function loopCreate(slideRealIndex, initial) {
    const swiper = this;
    const {
      params,
      slidesEl
    } = swiper;
    if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
    const initSlides = () => {
      const slides = elementChildren(slidesEl, `.${params.slideClass}, swiper-slide`);
      slides.forEach((el, index) => {
        el.setAttribute("data-swiper-slide-index", index);
      });
    };
    const clearBlankSlides = () => {
      const slides = elementChildren(slidesEl, `.${params.slideBlankClass}`);
      slides.forEach((el) => {
        el.remove();
      });
      if (slides.length > 0) {
        swiper.recalcSlides();
        swiper.updateSlides();
      }
    };
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    if (params.loopAddBlankSlides && (params.slidesPerGroup > 1 || gridEnabled)) {
      clearBlankSlides();
    }
    const slidesPerGroup = params.slidesPerGroup * (gridEnabled ? params.grid.rows : 1);
    const shouldFillGroup = swiper.slides.length % slidesPerGroup !== 0;
    const shouldFillGrid = gridEnabled && swiper.slides.length % params.grid.rows !== 0;
    const addBlankSlides = (amountOfSlides) => {
      for (let i = 0; i < amountOfSlides; i += 1) {
        const slideEl = swiper.isElement ? createElement("swiper-slide", [params.slideBlankClass]) : createElement("div", [params.slideClass, params.slideBlankClass]);
        swiper.slidesEl.append(slideEl);
      }
    };
    if (shouldFillGroup) {
      if (params.loopAddBlankSlides) {
        const slidesToAdd = slidesPerGroup - swiper.slides.length % slidesPerGroup;
        addBlankSlides(slidesToAdd);
        swiper.recalcSlides();
        swiper.updateSlides();
      } else {
        showWarning("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
      }
      initSlides();
    } else if (shouldFillGrid) {
      if (params.loopAddBlankSlides) {
        const slidesToAdd = params.grid.rows - swiper.slides.length % params.grid.rows;
        addBlankSlides(slidesToAdd);
        swiper.recalcSlides();
        swiper.updateSlides();
      } else {
        showWarning("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
      }
      initSlides();
    } else {
      initSlides();
    }
    swiper.loopFix({
      slideRealIndex,
      direction: params.centeredSlides ? void 0 : "next",
      initial
    });
  }
  function loopFix(_temp) {
    let {
      slideRealIndex,
      slideTo: slideTo2 = true,
      direction,
      setTranslate: setTranslate2,
      activeSlideIndex,
      initial,
      byController,
      byMousewheel
    } = _temp === void 0 ? {} : _temp;
    const swiper = this;
    if (!swiper.params.loop) return;
    swiper.emit("beforeLoopFix");
    const {
      slides,
      allowSlidePrev,
      allowSlideNext,
      slidesEl,
      params
    } = swiper;
    const {
      centeredSlides,
      initialSlide
    } = params;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    if (swiper.virtual && params.virtual.enabled) {
      if (slideTo2) {
        if (!params.centeredSlides && swiper.snapIndex === 0) {
          swiper.slideTo(swiper.virtual.slides.length, 0, false, true);
        } else if (params.centeredSlides && swiper.snapIndex < params.slidesPerView) {
          swiper.slideTo(swiper.virtual.slides.length + swiper.snapIndex, 0, false, true);
        } else if (swiper.snapIndex === swiper.snapGrid.length - 1) {
          swiper.slideTo(swiper.virtual.slidesBefore, 0, false, true);
        }
      }
      swiper.allowSlidePrev = allowSlidePrev;
      swiper.allowSlideNext = allowSlideNext;
      swiper.emit("loopFix");
      return;
    }
    let slidesPerView = params.slidesPerView;
    if (slidesPerView === "auto") {
      slidesPerView = swiper.slidesPerViewDynamic();
    } else {
      slidesPerView = Math.ceil(parseFloat(params.slidesPerView, 10));
      if (centeredSlides && slidesPerView % 2 === 0) {
        slidesPerView = slidesPerView + 1;
      }
    }
    const slidesPerGroup = params.slidesPerGroupAuto ? slidesPerView : params.slidesPerGroup;
    let loopedSlides = centeredSlides ? Math.max(slidesPerGroup, Math.ceil(slidesPerView / 2)) : slidesPerGroup;
    if (loopedSlides % slidesPerGroup !== 0) {
      loopedSlides += slidesPerGroup - loopedSlides % slidesPerGroup;
    }
    loopedSlides += params.loopAdditionalSlides;
    swiper.loopedSlides = loopedSlides;
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    if (slides.length < slidesPerView + loopedSlides || swiper.params.effect === "cards" && slides.length < slidesPerView + loopedSlides * 2) {
      showWarning("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters");
    } else if (gridEnabled && params.grid.fill === "row") {
      showWarning("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
    }
    const prependSlidesIndexes = [];
    const appendSlidesIndexes = [];
    const cols = gridEnabled ? Math.ceil(slides.length / params.grid.rows) : slides.length;
    const isInitialOverflow = initial && cols - initialSlide < slidesPerView && !centeredSlides;
    let activeIndex = isInitialOverflow ? initialSlide : swiper.activeIndex;
    if (typeof activeSlideIndex === "undefined") {
      activeSlideIndex = swiper.getSlideIndex(slides.find((el) => el.classList.contains(params.slideActiveClass)));
    } else {
      activeIndex = activeSlideIndex;
    }
    const isNext = direction === "next" || !direction;
    const isPrev = direction === "prev" || !direction;
    let slidesPrepended = 0;
    let slidesAppended = 0;
    const activeColIndex = gridEnabled ? slides[activeSlideIndex].column : activeSlideIndex;
    const activeColIndexWithShift = activeColIndex + (centeredSlides && typeof setTranslate2 === "undefined" ? -slidesPerView / 2 + 0.5 : 0);
    if (activeColIndexWithShift < loopedSlides) {
      slidesPrepended = Math.max(loopedSlides - activeColIndexWithShift, slidesPerGroup);
      for (let i = 0; i < loopedSlides - activeColIndexWithShift; i += 1) {
        const index = i - Math.floor(i / cols) * cols;
        if (gridEnabled) {
          const colIndexToPrepend = cols - index - 1;
          for (let i2 = slides.length - 1; i2 >= 0; i2 -= 1) {
            if (slides[i2].column === colIndexToPrepend) prependSlidesIndexes.push(i2);
          }
        } else {
          prependSlidesIndexes.push(cols - index - 1);
        }
      }
    } else if (activeColIndexWithShift + slidesPerView > cols - loopedSlides) {
      slidesAppended = Math.max(activeColIndexWithShift - (cols - loopedSlides * 2), slidesPerGroup);
      if (isInitialOverflow) {
        slidesAppended = Math.max(slidesAppended, slidesPerView - cols + initialSlide + 1);
      }
      for (let i = 0; i < slidesAppended; i += 1) {
        const index = i - Math.floor(i / cols) * cols;
        if (gridEnabled) {
          slides.forEach((slide2, slideIndex) => {
            if (slide2.column === index) appendSlidesIndexes.push(slideIndex);
          });
        } else {
          appendSlidesIndexes.push(index);
        }
      }
    }
    swiper.__preventObserver__ = true;
    requestAnimationFrame(() => {
      swiper.__preventObserver__ = false;
    });
    if (swiper.params.effect === "cards" && slides.length < slidesPerView + loopedSlides * 2) {
      if (appendSlidesIndexes.includes(activeSlideIndex)) {
        appendSlidesIndexes.splice(appendSlidesIndexes.indexOf(activeSlideIndex), 1);
      }
      if (prependSlidesIndexes.includes(activeSlideIndex)) {
        prependSlidesIndexes.splice(prependSlidesIndexes.indexOf(activeSlideIndex), 1);
      }
    }
    if (isPrev) {
      prependSlidesIndexes.forEach((index) => {
        slides[index].swiperLoopMoveDOM = true;
        slidesEl.prepend(slides[index]);
        slides[index].swiperLoopMoveDOM = false;
      });
    }
    if (isNext) {
      appendSlidesIndexes.forEach((index) => {
        slides[index].swiperLoopMoveDOM = true;
        slidesEl.append(slides[index]);
        slides[index].swiperLoopMoveDOM = false;
      });
    }
    swiper.recalcSlides();
    if (params.slidesPerView === "auto") {
      swiper.updateSlides();
    } else if (gridEnabled && (prependSlidesIndexes.length > 0 && isPrev || appendSlidesIndexes.length > 0 && isNext)) {
      swiper.slides.forEach((slide2, slideIndex) => {
        swiper.grid.updateSlide(slideIndex, slide2, swiper.slides);
      });
    }
    if (params.watchSlidesProgress) {
      swiper.updateSlidesOffset();
    }
    if (slideTo2) {
      if (prependSlidesIndexes.length > 0 && isPrev) {
        if (typeof slideRealIndex === "undefined") {
          const currentSlideTranslate = swiper.slidesGrid[activeIndex];
          const newSlideTranslate = swiper.slidesGrid[activeIndex + slidesPrepended];
          const diff = newSlideTranslate - currentSlideTranslate;
          if (byMousewheel) {
            swiper.setTranslate(swiper.translate - diff);
          } else {
            swiper.slideTo(activeIndex + Math.ceil(slidesPrepended), 0, false, true);
            if (setTranslate2) {
              swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
              swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
            }
          }
        } else {
          if (setTranslate2) {
            const shift = gridEnabled ? prependSlidesIndexes.length / params.grid.rows : prependSlidesIndexes.length;
            swiper.slideTo(swiper.activeIndex + shift, 0, false, true);
            swiper.touchEventsData.currentTranslate = swiper.translate;
          }
        }
      } else if (appendSlidesIndexes.length > 0 && isNext) {
        if (typeof slideRealIndex === "undefined") {
          const currentSlideTranslate = swiper.slidesGrid[activeIndex];
          const newSlideTranslate = swiper.slidesGrid[activeIndex - slidesAppended];
          const diff = newSlideTranslate - currentSlideTranslate;
          if (byMousewheel) {
            swiper.setTranslate(swiper.translate - diff);
          } else {
            swiper.slideTo(activeIndex - slidesAppended, 0, false, true);
            if (setTranslate2) {
              swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
              swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
            }
          }
        } else {
          const shift = gridEnabled ? appendSlidesIndexes.length / params.grid.rows : appendSlidesIndexes.length;
          swiper.slideTo(swiper.activeIndex - shift, 0, false, true);
        }
      }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.controller && swiper.controller.control && !byController) {
      const loopParams = {
        slideRealIndex,
        direction,
        setTranslate: setTranslate2,
        activeSlideIndex,
        byController: true
      };
      if (Array.isArray(swiper.controller.control)) {
        swiper.controller.control.forEach((c) => {
          if (!c.destroyed && c.params.loop) c.loopFix({
            ...loopParams,
            slideTo: c.params.slidesPerView === params.slidesPerView ? slideTo2 : false
          });
        });
      } else if (swiper.controller.control instanceof swiper.constructor && swiper.controller.control.params.loop) {
        swiper.controller.control.loopFix({
          ...loopParams,
          slideTo: swiper.controller.control.params.slidesPerView === params.slidesPerView ? slideTo2 : false
        });
      }
    }
    swiper.emit("loopFix");
  }
  function loopDestroy() {
    const swiper = this;
    const {
      params,
      slidesEl
    } = swiper;
    if (!params.loop || !slidesEl || swiper.virtual && swiper.params.virtual.enabled) return;
    swiper.recalcSlides();
    const newSlidesOrder = [];
    swiper.slides.forEach((slideEl) => {
      const index = typeof slideEl.swiperSlideIndex === "undefined" ? slideEl.getAttribute("data-swiper-slide-index") * 1 : slideEl.swiperSlideIndex;
      newSlidesOrder[index] = slideEl;
    });
    swiper.slides.forEach((slideEl) => {
      slideEl.removeAttribute("data-swiper-slide-index");
    });
    newSlidesOrder.forEach((slideEl) => {
      slidesEl.append(slideEl);
    });
    swiper.recalcSlides();
    swiper.slideTo(swiper.realIndex, 0);
  }
  var loop = {
    loopCreate,
    loopFix,
    loopDestroy
  };
  function setGrabCursor(moving) {
    const swiper = this;
    if (!swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    const el = swiper.params.touchEventsTarget === "container" ? swiper.el : swiper.wrapperEl;
    if (swiper.isElement) {
      swiper.__preventObserver__ = true;
    }
    el.style.cursor = "move";
    el.style.cursor = moving ? "grabbing" : "grab";
    if (swiper.isElement) {
      requestAnimationFrame(() => {
        swiper.__preventObserver__ = false;
      });
    }
  }
  function unsetGrabCursor() {
    const swiper = this;
    if (swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
      return;
    }
    if (swiper.isElement) {
      swiper.__preventObserver__ = true;
    }
    swiper[swiper.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "";
    if (swiper.isElement) {
      requestAnimationFrame(() => {
        swiper.__preventObserver__ = false;
      });
    }
  }
  var grabCursor = {
    setGrabCursor,
    unsetGrabCursor
  };
  function closestElement(selector, base) {
    if (base === void 0) {
      base = this;
    }
    function __closestFrom(el) {
      if (!el || el === getDocument() || el === getWindow()) return null;
      if (el.assignedSlot) el = el.assignedSlot;
      const found = el.closest(selector);
      if (!found && !el.getRootNode) {
        return null;
      }
      return found || __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
  }
  function preventEdgeSwipe(swiper, event2, startX) {
    const window2 = getWindow();
    const {
      params
    } = swiper;
    const edgeSwipeDetection = params.edgeSwipeDetection;
    const edgeSwipeThreshold = params.edgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window2.innerWidth - edgeSwipeThreshold)) {
      if (edgeSwipeDetection === "prevent") {
        event2.preventDefault();
        return true;
      }
      return false;
    }
    return true;
  }
  function onTouchStart(event2) {
    const swiper = this;
    const document2 = getDocument();
    let e = event2;
    if (e.originalEvent) e = e.originalEvent;
    const data = swiper.touchEventsData;
    if (e.type === "pointerdown") {
      if (data.pointerId !== null && data.pointerId !== e.pointerId) {
        return;
      }
      data.pointerId = e.pointerId;
    } else if (e.type === "touchstart" && e.targetTouches.length === 1) {
      data.touchId = e.targetTouches[0].identifier;
    }
    if (e.type === "touchstart") {
      preventEdgeSwipe(swiper, e, e.targetTouches[0].pageX);
      return;
    }
    const {
      params,
      touches,
      enabled
    } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === "mouse") return;
    if (swiper.animating && params.preventInteractionOnTransition) {
      return;
    }
    if (!swiper.animating && params.cssMode && params.loop) {
      swiper.loopFix();
    }
    let targetEl = e.target;
    if (params.touchEventsTarget === "wrapper") {
      if (!elementIsChildOf(targetEl, swiper.wrapperEl)) return;
    }
    if ("which" in e && e.which === 3) return;
    if ("button" in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return;
    const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== "";
    const eventPath = e.composedPath ? e.composedPath() : e.path;
    if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) {
      targetEl = eventPath[0];
    }
    const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
    const isTargetShadow = !!(e.target && e.target.shadowRoot);
    if (params.noSwiping && (isTargetShadow ? closestElement(noSwipingSelector, targetEl) : targetEl.closest(noSwipingSelector))) {
      swiper.allowClick = true;
      return;
    }
    if (params.swipeHandler) {
      if (!targetEl.closest(params.swipeHandler)) return;
    }
    touches.currentX = e.pageX;
    touches.currentY = e.pageY;
    const startX = touches.currentX;
    const startY = touches.currentY;
    if (!preventEdgeSwipe(swiper, e, startX)) {
      return;
    }
    Object.assign(data, {
      isTouched: true,
      isMoved: false,
      allowTouchCallbacks: true,
      isScrolling: void 0,
      startMoving: void 0
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = now();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = void 0;
    if (params.threshold > 0) data.allowThresholdMove = false;
    let preventDefault = true;
    if (targetEl.matches(data.focusableElements)) {
      preventDefault = false;
      if (targetEl.nodeName === "SELECT") {
        data.isTouched = false;
      }
    }
    if (document2.activeElement && document2.activeElement.matches(data.focusableElements) && document2.activeElement !== targetEl && (e.pointerType === "mouse" || e.pointerType !== "mouse" && !targetEl.matches(data.focusableElements))) {
      document2.activeElement.blur();
    }
    const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !targetEl.isContentEditable) {
      e.preventDefault();
    }
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) {
      swiper.freeMode.onTouchStart();
    }
    swiper.emit("touchStart", e);
  }
  function onTouchMove(event2) {
    const document2 = getDocument();
    const swiper = this;
    const data = swiper.touchEventsData;
    const {
      params,
      touches,
      rtlTranslate: rtl,
      enabled
    } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && event2.pointerType === "mouse") return;
    let e = event2;
    if (e.originalEvent) e = e.originalEvent;
    if (e.type === "pointermove") {
      if (data.touchId !== null) return;
      const id = e.pointerId;
      if (id !== data.pointerId) return;
    }
    let targetTouch;
    if (e.type === "touchmove") {
      targetTouch = [...e.changedTouches].find((t) => t.identifier === data.touchId);
      if (!targetTouch || targetTouch.identifier !== data.touchId) return;
    } else {
      targetTouch = e;
    }
    if (!data.isTouched) {
      if (data.startMoving && data.isScrolling) {
        swiper.emit("touchMoveOpposite", e);
      }
      return;
    }
    const pageX = targetTouch.pageX;
    const pageY = targetTouch.pageY;
    if (e.preventedByNestedSwiper) {
      touches.startX = pageX;
      touches.startY = pageY;
      return;
    }
    if (!swiper.allowTouchMove) {
      if (!e.target.matches(data.focusableElements)) {
        swiper.allowClick = false;
      }
      if (data.isTouched) {
        Object.assign(touches, {
          startX: pageX,
          startY: pageY,
          currentX: pageX,
          currentY: pageY
        });
        data.touchStartTime = now();
      }
      return;
    }
    if (params.touchReleaseOnEdges && !params.loop) {
      if (swiper.isVertical()) {
        if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
          data.isTouched = false;
          data.isMoved = false;
          return;
        }
      } else if (rtl && (pageX > touches.startX && -swiper.translate <= swiper.maxTranslate() || pageX < touches.startX && -swiper.translate >= swiper.minTranslate())) {
        return;
      } else if (!rtl && (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate())) {
        return;
      }
    }
    if (document2.activeElement && document2.activeElement.matches(data.focusableElements) && document2.activeElement !== e.target && e.pointerType !== "mouse") {
      document2.activeElement.blur();
    }
    if (document2.activeElement) {
      if (e.target === document2.activeElement && e.target.matches(data.focusableElements)) {
        data.isMoved = true;
        swiper.allowClick = false;
        return;
      }
    }
    if (data.allowTouchCallbacks) {
      swiper.emit("touchMove", e);
    }
    touches.previousX = touches.currentX;
    touches.previousY = touches.currentY;
    touches.currentX = pageX;
    touches.currentY = pageY;
    const diffX = touches.currentX - touches.startX;
    const diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
    if (typeof data.isScrolling === "undefined") {
      let touchAngle;
      if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
        data.isScrolling = false;
      } else {
        if (diffX * diffX + diffY * diffY >= 25) {
          touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
          data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
      }
    }
    if (data.isScrolling) {
      swiper.emit("touchMoveOpposite", e);
    }
    if (typeof data.startMoving === "undefined") {
      if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
        data.startMoving = true;
      }
    }
    if (data.isScrolling || e.type === "touchmove" && data.preventTouchMoveFromPointerMove) {
      data.isTouched = false;
      return;
    }
    if (!data.startMoving) {
      return;
    }
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) {
      e.preventDefault();
    }
    if (params.touchMoveStopPropagation && !params.nested) {
      e.stopPropagation();
    }
    let diff = swiper.isHorizontal() ? diffX : diffY;
    let touchesDiff = swiper.isHorizontal() ? touches.currentX - touches.previousX : touches.currentY - touches.previousY;
    if (params.oneWayMovement) {
      diff = Math.abs(diff) * (rtl ? 1 : -1);
      touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
    }
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) {
      diff = -diff;
      touchesDiff = -touchesDiff;
    }
    const prevTouchesDirection = swiper.touchesDirection;
    swiper.swipeDirection = diff > 0 ? "prev" : "next";
    swiper.touchesDirection = touchesDiff > 0 ? "prev" : "next";
    const isLoop = swiper.params.loop && !params.cssMode;
    const allowLoopFix = swiper.touchesDirection === "next" && swiper.allowSlideNext || swiper.touchesDirection === "prev" && swiper.allowSlidePrev;
    if (!data.isMoved) {
      if (isLoop && allowLoopFix) {
        swiper.loopFix({
          direction: swiper.swipeDirection
        });
      }
      data.startTranslate = swiper.getTranslate();
      swiper.setTransition(0);
      if (swiper.animating) {
        const evt = new window.CustomEvent("transitionend", {
          bubbles: true,
          cancelable: true,
          detail: {
            bySwiperTouchMove: true
          }
        });
        swiper.wrapperEl.dispatchEvent(evt);
      }
      data.allowMomentumBounce = false;
      if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
        swiper.setGrabCursor(true);
      }
      swiper.emit("sliderFirstMove", e);
    }
    let loopFixed;
    (/* @__PURE__ */ new Date()).getTime();
    if (params._loopSwapReset !== false && data.isMoved && data.allowThresholdMove && prevTouchesDirection !== swiper.touchesDirection && isLoop && allowLoopFix && Math.abs(diff) >= 1) {
      Object.assign(touches, {
        startX: pageX,
        startY: pageY,
        currentX: pageX,
        currentY: pageY,
        startTranslate: data.currentTranslate
      });
      data.loopSwapReset = true;
      data.startTranslate = data.currentTranslate;
      return;
    }
    swiper.emit("sliderMove", e);
    data.isMoved = true;
    data.currentTranslate = diff + data.startTranslate;
    let disableParentSwiper = true;
    let resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) {
      resistanceRatio = 0;
    }
    if (diff > 0) {
      if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate > (params.centeredSlides ? swiper.minTranslate() - swiper.slidesSizesGrid[swiper.activeIndex + 1] - (params.slidesPerView !== "auto" && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.activeIndex + 1] + swiper.params.spaceBetween : 0) - swiper.params.spaceBetween : swiper.minTranslate())) {
        swiper.loopFix({
          direction: "prev",
          setTranslate: true,
          activeSlideIndex: 0
        });
      }
      if (data.currentTranslate > swiper.minTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) {
          data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
        }
      }
    } else if (diff < 0) {
      if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate < (params.centeredSlides ? swiper.maxTranslate() + swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween + (params.slidesPerView !== "auto" && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween : 0) : swiper.maxTranslate())) {
        swiper.loopFix({
          direction: "next",
          setTranslate: true,
          activeSlideIndex: swiper.slides.length - (params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10)))
        });
      }
      if (data.currentTranslate < swiper.maxTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) {
          data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
        }
      }
    }
    if (disableParentSwiper) {
      e.preventedByNestedSwiper = true;
    }
    if (!swiper.allowSlideNext && swiper.swipeDirection === "next" && data.currentTranslate < data.startTranslate) {
      data.currentTranslate = data.startTranslate;
    }
    if (!swiper.allowSlidePrev && swiper.swipeDirection === "prev" && data.currentTranslate > data.startTranslate) {
      data.currentTranslate = data.startTranslate;
    }
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) {
      data.currentTranslate = data.startTranslate;
    }
    if (params.threshold > 0) {
      if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
        if (!data.allowThresholdMove) {
          data.allowThresholdMove = true;
          touches.startX = touches.currentX;
          touches.startY = touches.currentY;
          data.currentTranslate = data.startTranslate;
          touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
          return;
        }
      } else {
        data.currentTranslate = data.startTranslate;
        return;
      }
    }
    if (!params.followFinger || params.cssMode) return;
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode) {
      swiper.freeMode.onTouchMove();
    }
    swiper.updateProgress(data.currentTranslate);
    swiper.setTranslate(data.currentTranslate);
  }
  function onTouchEnd(event2) {
    const swiper = this;
    const data = swiper.touchEventsData;
    let e = event2;
    if (e.originalEvent) e = e.originalEvent;
    let targetTouch;
    const isTouchEvent = e.type === "touchend" || e.type === "touchcancel";
    if (!isTouchEvent) {
      if (data.touchId !== null) return;
      if (e.pointerId !== data.pointerId) return;
      targetTouch = e;
    } else {
      targetTouch = [...e.changedTouches].find((t) => t.identifier === data.touchId);
      if (!targetTouch || targetTouch.identifier !== data.touchId) return;
    }
    if (["pointercancel", "pointerout", "pointerleave", "contextmenu"].includes(e.type)) {
      const proceed = ["pointercancel", "contextmenu"].includes(e.type) && (swiper.browser.isSafari || swiper.browser.isWebView);
      if (!proceed) {
        return;
      }
    }
    data.pointerId = null;
    data.touchId = null;
    const {
      params,
      touches,
      rtlTranslate: rtl,
      slidesGrid,
      enabled
    } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === "mouse") return;
    if (data.allowTouchCallbacks) {
      swiper.emit("touchEnd", e);
    }
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
      if (data.isMoved && params.grabCursor) {
        swiper.setGrabCursor(false);
      }
      data.isMoved = false;
      data.startMoving = false;
      return;
    }
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(false);
    }
    const touchEndTime = now();
    const timeDiff = touchEndTime - data.touchStartTime;
    if (swiper.allowClick) {
      const pathTree = e.path || e.composedPath && e.composedPath();
      swiper.updateClickedSlide(pathTree && pathTree[0] || e.target, pathTree);
      swiper.emit("tap click", e);
      if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
        swiper.emit("doubleTap doubleClick", e);
      }
    }
    data.lastClickTime = now();
    nextTick(() => {
      if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 && !data.loopSwapReset || data.currentTranslate === data.startTranslate && !data.loopSwapReset) {
      data.isTouched = false;
      data.isMoved = false;
      data.startMoving = false;
      return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    let currentPos;
    if (params.followFinger) {
      currentPos = rtl ? swiper.translate : -swiper.translate;
    } else {
      currentPos = -data.currentTranslate;
    }
    if (params.cssMode) {
      return;
    }
    if (params.freeMode && params.freeMode.enabled) {
      swiper.freeMode.onTouchEnd({
        currentPos
      });
      return;
    }
    const swipeToLast = currentPos >= -swiper.maxTranslate() && !swiper.params.loop;
    let stopIndex = 0;
    let groupSize = swiper.slidesSizesGrid[0];
    for (let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
      const increment2 = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
      if (typeof slidesGrid[i + increment2] !== "undefined") {
        if (swipeToLast || currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment2]) {
          stopIndex = i;
          groupSize = slidesGrid[i + increment2] - slidesGrid[i];
        }
      } else if (swipeToLast || currentPos >= slidesGrid[i]) {
        stopIndex = i;
        groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
      }
    }
    let rewindFirstIndex = null;
    let rewindLastIndex = null;
    if (params.rewind) {
      if (swiper.isBeginning) {
        rewindLastIndex = params.virtual && params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
      } else if (swiper.isEnd) {
        rewindFirstIndex = 0;
      }
    }
    const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
      if (!params.longSwipes) {
        swiper.slideTo(swiper.activeIndex);
        return;
      }
      if (swiper.swipeDirection === "next") {
        if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);
        else swiper.slideTo(stopIndex);
      }
      if (swiper.swipeDirection === "prev") {
        if (ratio > 1 - params.longSwipesRatio) {
          swiper.slideTo(stopIndex + increment);
        } else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) {
          swiper.slideTo(rewindLastIndex);
        } else {
          swiper.slideTo(stopIndex);
        }
      }
    } else {
      if (!params.shortSwipes) {
        swiper.slideTo(swiper.activeIndex);
        return;
      }
      const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
      if (!isNavButtonTarget) {
        if (swiper.swipeDirection === "next") {
          swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
        }
        if (swiper.swipeDirection === "prev") {
          swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
        }
      } else if (e.target === swiper.navigation.nextEl) {
        swiper.slideTo(stopIndex + increment);
      } else {
        swiper.slideTo(stopIndex);
      }
    }
  }
  function onResize() {
    const swiper = this;
    const {
      params,
      el
    } = swiper;
    if (el && el.offsetWidth === 0) return;
    if (params.breakpoints) {
      swiper.setBreakpoint();
    }
    const {
      allowSlideNext,
      allowSlidePrev,
      snapGrid
    } = swiper;
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    const isVirtualLoop = isVirtual && params.loop;
    if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides && !isVirtualLoop) {
      swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    } else {
      if (swiper.params.loop && !isVirtual) {
        swiper.slideToLoop(swiper.realIndex, 0, false, true);
      } else {
        swiper.slideTo(swiper.activeIndex, 0, false, true);
      }
    }
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
      clearTimeout(swiper.autoplay.resizeTimeout);
      swiper.autoplay.resizeTimeout = setTimeout(() => {
        if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
          swiper.autoplay.resume();
        }
      }, 500);
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
      swiper.checkOverflow();
    }
  }
  function onClick(e) {
    const swiper = this;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
      if (swiper.params.preventClicks) e.preventDefault();
      if (swiper.params.preventClicksPropagation && swiper.animating) {
        e.stopPropagation();
        e.stopImmediatePropagation();
      }
    }
  }
  function onScroll() {
    const swiper = this;
    const {
      wrapperEl,
      rtlTranslate,
      enabled
    } = swiper;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) {
      swiper.translate = -wrapperEl.scrollLeft;
    } else {
      swiper.translate = -wrapperEl.scrollTop;
    }
    if (swiper.translate === 0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) {
      newProgress = 0;
    } else {
      newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    }
    if (newProgress !== swiper.progress) {
      swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    }
    swiper.emit("setTranslate", swiper.translate, false);
  }
  function onLoad(e) {
    const swiper = this;
    processLazyPreloader(swiper, e.target);
    if (swiper.params.cssMode || swiper.params.slidesPerView !== "auto" && !swiper.params.autoHeight) {
      return;
    }
    swiper.update();
  }
  function onDocumentTouchStart() {
    const swiper = this;
    if (swiper.documentTouchHandlerProceeded) return;
    swiper.documentTouchHandlerProceeded = true;
    if (swiper.params.touchReleaseOnEdges) {
      swiper.el.style.touchAction = "auto";
    }
  }
  var events = (swiper, method) => {
    const document2 = getDocument();
    const {
      params,
      el,
      wrapperEl,
      device
    } = swiper;
    const capture = !!params.nested;
    const domMethod = method === "on" ? "addEventListener" : "removeEventListener";
    const swiperMethod = method;
    if (!el || typeof el === "string") return;
    document2[domMethod]("touchstart", swiper.onDocumentTouchStart, {
      passive: false,
      capture
    });
    el[domMethod]("touchstart", swiper.onTouchStart, {
      passive: false
    });
    el[domMethod]("pointerdown", swiper.onTouchStart, {
      passive: false
    });
    document2[domMethod]("touchmove", swiper.onTouchMove, {
      passive: false,
      capture
    });
    document2[domMethod]("pointermove", swiper.onTouchMove, {
      passive: false,
      capture
    });
    document2[domMethod]("touchend", swiper.onTouchEnd, {
      passive: true
    });
    document2[domMethod]("pointerup", swiper.onTouchEnd, {
      passive: true
    });
    document2[domMethod]("pointercancel", swiper.onTouchEnd, {
      passive: true
    });
    document2[domMethod]("touchcancel", swiper.onTouchEnd, {
      passive: true
    });
    document2[domMethod]("pointerout", swiper.onTouchEnd, {
      passive: true
    });
    document2[domMethod]("pointerleave", swiper.onTouchEnd, {
      passive: true
    });
    document2[domMethod]("contextmenu", swiper.onTouchEnd, {
      passive: true
    });
    if (params.preventClicks || params.preventClicksPropagation) {
      el[domMethod]("click", swiper.onClick, true);
    }
    if (params.cssMode) {
      wrapperEl[domMethod]("scroll", swiper.onScroll);
    }
    if (params.updateOnWindowResize) {
      swiper[swiperMethod](device.ios || device.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", onResize, true);
    } else {
      swiper[swiperMethod]("observerUpdate", onResize, true);
    }
    el[domMethod]("load", swiper.onLoad, {
      capture: true
    });
  };
  function attachEvents() {
    const swiper = this;
    const {
      params
    } = swiper;
    swiper.onTouchStart = onTouchStart.bind(swiper);
    swiper.onTouchMove = onTouchMove.bind(swiper);
    swiper.onTouchEnd = onTouchEnd.bind(swiper);
    swiper.onDocumentTouchStart = onDocumentTouchStart.bind(swiper);
    if (params.cssMode) {
      swiper.onScroll = onScroll.bind(swiper);
    }
    swiper.onClick = onClick.bind(swiper);
    swiper.onLoad = onLoad.bind(swiper);
    events(swiper, "on");
  }
  function detachEvents() {
    const swiper = this;
    events(swiper, "off");
  }
  var events$1 = {
    attachEvents,
    detachEvents
  };
  var isGridEnabled = (swiper, params) => {
    return swiper.grid && params.grid && params.grid.rows > 1;
  };
  function setBreakpoint() {
    const swiper = this;
    const {
      realIndex,
      initialized: initialized2,
      params,
      el
    } = swiper;
    const breakpoints2 = params.breakpoints;
    if (!breakpoints2 || breakpoints2 && Object.keys(breakpoints2).length === 0) return;
    const document2 = getDocument();
    const breakpointsBase = params.breakpointsBase === "window" || !params.breakpointsBase ? params.breakpointsBase : "container";
    const breakpointContainer = ["window", "container"].includes(params.breakpointsBase) || !params.breakpointsBase ? swiper.el : document2.querySelector(params.breakpointsBase);
    const breakpoint = swiper.getBreakpoint(breakpoints2, breakpointsBase, breakpointContainer);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    const breakpointOnlyParams = breakpoint in breakpoints2 ? breakpoints2[breakpoint] : void 0;
    const breakpointParams = breakpointOnlyParams || swiper.originalParams;
    const wasMultiRow = isGridEnabled(swiper, params);
    const isMultiRow = isGridEnabled(swiper, breakpointParams);
    const wasGrabCursor = swiper.params.grabCursor;
    const isGrabCursor = breakpointParams.grabCursor;
    const wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
      el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
      swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
      el.classList.add(`${params.containerModifierClass}grid`);
      if (breakpointParams.grid.fill && breakpointParams.grid.fill === "column" || !breakpointParams.grid.fill && params.grid.fill === "column") {
        el.classList.add(`${params.containerModifierClass}grid-column`);
      }
      swiper.emitContainerClasses();
    }
    if (wasGrabCursor && !isGrabCursor) {
      swiper.unsetGrabCursor();
    } else if (!wasGrabCursor && isGrabCursor) {
      swiper.setGrabCursor();
    }
    ["navigation", "pagination", "scrollbar"].forEach((prop) => {
      if (typeof breakpointParams[prop] === "undefined") return;
      const wasModuleEnabled = params[prop] && params[prop].enabled;
      const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
      if (wasModuleEnabled && !isModuleEnabled) {
        swiper[prop].disable();
      }
      if (!wasModuleEnabled && isModuleEnabled) {
        swiper[prop].enable();
      }
    });
    const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    const wasLoop = params.loop;
    if (directionChanged && initialized2) {
      swiper.changeDirection();
    }
    extend2(swiper.params, breakpointParams);
    const isEnabled = swiper.params.enabled;
    const hasLoop = swiper.params.loop;
    Object.assign(swiper, {
      allowTouchMove: swiper.params.allowTouchMove,
      allowSlideNext: swiper.params.allowSlideNext,
      allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) {
      swiper.disable();
    } else if (!wasEnabled && isEnabled) {
      swiper.enable();
    }
    swiper.currentBreakpoint = breakpoint;
    swiper.emit("_beforeBreakpoint", breakpointParams);
    if (initialized2) {
      if (needsReLoop) {
        swiper.loopDestroy();
        swiper.loopCreate(realIndex);
        swiper.updateSlides();
      } else if (!wasLoop && hasLoop) {
        swiper.loopCreate(realIndex);
        swiper.updateSlides();
      } else if (wasLoop && !hasLoop) {
        swiper.loopDestroy();
      }
    }
    swiper.emit("breakpoint", breakpointParams);
  }
  function getBreakpoint(breakpoints2, base, containerEl) {
    if (base === void 0) {
      base = "window";
    }
    if (!breakpoints2 || base === "container" && !containerEl) return void 0;
    let breakpoint = false;
    const window2 = getWindow();
    const currentHeight = base === "window" ? window2.innerHeight : containerEl.clientHeight;
    const points = Object.keys(breakpoints2).map((point) => {
      if (typeof point === "string" && point.indexOf("@") === 0) {
        const minRatio = parseFloat(point.substr(1));
        const value = currentHeight * minRatio;
        return {
          value,
          point
        };
      }
      return {
        value: point,
        point
      };
    });
    points.sort((a, b) => parseInt(a.value, 10) - parseInt(b.value, 10));
    for (let i = 0; i < points.length; i += 1) {
      const {
        point,
        value
      } = points[i];
      if (base === "window") {
        if (window2.matchMedia(`(min-width: ${value}px)`).matches) {
          breakpoint = point;
        }
      } else if (value <= containerEl.clientWidth) {
        breakpoint = point;
      }
    }
    return breakpoint || "max";
  }
  var breakpoints = {
    setBreakpoint,
    getBreakpoint
  };
  function prepareClasses(entries, prefix) {
    const resultClasses = [];
    entries.forEach((item) => {
      if (typeof item === "object") {
        Object.keys(item).forEach((classNames) => {
          if (item[classNames]) {
            resultClasses.push(prefix + classNames);
          }
        });
      } else if (typeof item === "string") {
        resultClasses.push(prefix + item);
      }
    });
    return resultClasses;
  }
  function addClasses() {
    const swiper = this;
    const {
      classNames,
      params,
      rtl,
      el,
      device
    } = swiper;
    const suffixes = prepareClasses(["initialized", params.direction, {
      "free-mode": swiper.params.freeMode && params.freeMode.enabled
    }, {
      "autoheight": params.autoHeight
    }, {
      "rtl": rtl
    }, {
      "grid": params.grid && params.grid.rows > 1
    }, {
      "grid-column": params.grid && params.grid.rows > 1 && params.grid.fill === "column"
    }, {
      "android": device.android
    }, {
      "ios": device.ios
    }, {
      "css-mode": params.cssMode
    }, {
      "centered": params.cssMode && params.centeredSlides
    }, {
      "watch-progress": params.watchSlidesProgress
    }], params.containerModifierClass);
    classNames.push(...suffixes);
    el.classList.add(...classNames);
    swiper.emitContainerClasses();
  }
  function removeClasses() {
    const swiper = this;
    const {
      el,
      classNames
    } = swiper;
    if (!el || typeof el === "string") return;
    el.classList.remove(...classNames);
    swiper.emitContainerClasses();
  }
  var classes = {
    addClasses,
    removeClasses
  };
  function checkOverflow() {
    const swiper = this;
    const {
      isLocked: wasLocked,
      params
    } = swiper;
    const {
      slidesOffsetBefore
    } = params;
    if (slidesOffsetBefore) {
      const lastSlideIndex = swiper.slides.length - 1;
      const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
      swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else {
      swiper.isLocked = swiper.snapGrid.length === 1;
    }
    if (params.allowSlideNext === true) {
      swiper.allowSlideNext = !swiper.isLocked;
    }
    if (params.allowSlidePrev === true) {
      swiper.allowSlidePrev = !swiper.isLocked;
    }
    if (wasLocked && wasLocked !== swiper.isLocked) {
      swiper.isEnd = false;
    }
    if (wasLocked !== swiper.isLocked) {
      swiper.emit(swiper.isLocked ? "lock" : "unlock");
    }
  }
  var checkOverflow$1 = {
    checkOverflow
  };
  var defaults = {
    init: true,
    direction: "horizontal",
    oneWayMovement: false,
    swiperElementNodeName: "SWIPER-CONTAINER",
    touchEventsTarget: "wrapper",
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    eventsPrefix: "swiper",
    enabled: true,
    focusableElements: "input, select, option, textarea, button, video, label",
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: "slide",
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: void 0,
    breakpointsBase: "window",
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 5,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // loop
    loop: false,
    loopAddBlankSlides: true,
    loopAdditionalSlides: 0,
    loopPreventsSliding: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: "swiper-no-swiping",
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    maxBackfaceHiddenSlides: 10,
    // NS
    containerModifierClass: "swiper-",
    // NEW
    slideClass: "swiper-slide",
    slideBlankClass: "swiper-slide-blank",
    slideActiveClass: "swiper-slide-active",
    slideVisibleClass: "swiper-slide-visible",
    slideFullyVisibleClass: "swiper-slide-fully-visible",
    slideNextClass: "swiper-slide-next",
    slidePrevClass: "swiper-slide-prev",
    wrapperClass: "swiper-wrapper",
    lazyPreloaderClass: "swiper-lazy-preloader",
    lazyPreloadPrevNext: 0,
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
  };
  function moduleExtendParams(params, allModulesParams) {
    return function extendParams(obj) {
      if (obj === void 0) {
        obj = {};
      }
      const moduleParamName = Object.keys(obj)[0];
      const moduleParams = obj[moduleParamName];
      if (typeof moduleParams !== "object" || moduleParams === null) {
        extend2(allModulesParams, obj);
        return;
      }
      if (params[moduleParamName] === true) {
        params[moduleParamName] = {
          enabled: true
        };
      }
      if (moduleParamName === "navigation" && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].prevEl && !params[moduleParamName].nextEl) {
        params[moduleParamName].auto = true;
      }
      if (["pagination", "scrollbar"].indexOf(moduleParamName) >= 0 && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].el) {
        params[moduleParamName].auto = true;
      }
      if (!(moduleParamName in params && "enabled" in moduleParams)) {
        extend2(allModulesParams, obj);
        return;
      }
      if (typeof params[moduleParamName] === "object" && !("enabled" in params[moduleParamName])) {
        params[moduleParamName].enabled = true;
      }
      if (!params[moduleParamName]) params[moduleParamName] = {
        enabled: false
      };
      extend2(allModulesParams, obj);
    };
  }
  var prototypes = {
    eventsEmitter,
    update,
    translate,
    transition,
    slide,
    loop,
    grabCursor,
    events: events$1,
    breakpoints,
    checkOverflow: checkOverflow$1,
    classes
  };
  var extendedDefaults = {};
  var Swiper = class _Swiper {
    constructor() {
      let el;
      let params;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === "Object") {
        params = args[0];
      } else {
        [el, params] = args;
      }
      if (!params) params = {};
      params = extend2({}, params);
      if (el && !params.el) params.el = el;
      const document2 = getDocument();
      if (params.el && typeof params.el === "string" && document2.querySelectorAll(params.el).length > 1) {
        const swipers = [];
        document2.querySelectorAll(params.el).forEach((containerEl) => {
          const newParams = extend2({}, params, {
            el: containerEl
          });
          swipers.push(new _Swiper(newParams));
        });
        return swipers;
      }
      const swiper = this;
      swiper.__swiper__ = true;
      swiper.support = getSupport();
      swiper.device = getDevice({
        userAgent: params.userAgent
      });
      swiper.browser = getBrowser();
      swiper.eventsListeners = {};
      swiper.eventsAnyListeners = [];
      swiper.modules = [...swiper.__modules__];
      if (params.modules && Array.isArray(params.modules)) {
        swiper.modules.push(...params.modules);
      }
      const allModulesParams = {};
      swiper.modules.forEach((mod) => {
        mod({
          params,
          swiper,
          extendParams: moduleExtendParams(params, allModulesParams),
          on: swiper.on.bind(swiper),
          once: swiper.once.bind(swiper),
          off: swiper.off.bind(swiper),
          emit: swiper.emit.bind(swiper)
        });
      });
      const swiperParams = extend2({}, defaults, allModulesParams);
      swiper.params = extend2({}, swiperParams, extendedDefaults, params);
      swiper.originalParams = extend2({}, swiper.params);
      swiper.passedParams = extend2({}, params);
      if (swiper.params && swiper.params.on) {
        Object.keys(swiper.params.on).forEach((eventName) => {
          swiper.on(eventName, swiper.params.on[eventName]);
        });
      }
      if (swiper.params && swiper.params.onAny) {
        swiper.onAny(swiper.params.onAny);
      }
      Object.assign(swiper, {
        enabled: swiper.params.enabled,
        el,
        // Classes
        classNames: [],
        // Slides
        slides: [],
        slidesGrid: [],
        snapGrid: [],
        slidesSizesGrid: [],
        // isDirection
        isHorizontal() {
          return swiper.params.direction === "horizontal";
        },
        isVertical() {
          return swiper.params.direction === "vertical";
        },
        // Indexes
        activeIndex: 0,
        realIndex: 0,
        //
        isBeginning: true,
        isEnd: false,
        // Props
        translate: 0,
        previousTranslate: 0,
        progress: 0,
        velocity: 0,
        animating: false,
        cssOverflowAdjustment() {
          return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
        },
        // Locks
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev,
        // Touch Events
        touchEventsData: {
          isTouched: void 0,
          isMoved: void 0,
          allowTouchCallbacks: void 0,
          touchStartTime: void 0,
          isScrolling: void 0,
          currentTranslate: void 0,
          startTranslate: void 0,
          allowThresholdMove: void 0,
          // Form elements to match
          focusableElements: swiper.params.focusableElements,
          // Last click time
          lastClickTime: 0,
          clickTimeout: void 0,
          // Velocities
          velocities: [],
          allowMomentumBounce: void 0,
          startMoving: void 0,
          pointerId: null,
          touchId: null
        },
        // Clicks
        allowClick: true,
        // Touches
        allowTouchMove: swiper.params.allowTouchMove,
        touches: {
          startX: 0,
          startY: 0,
          currentX: 0,
          currentY: 0,
          diff: 0
        },
        // Images
        imagesToLoad: [],
        imagesLoaded: 0
      });
      swiper.emit("_swiper");
      if (swiper.params.init) {
        swiper.init();
      }
      return swiper;
    }
    getDirectionLabel(property) {
      if (this.isHorizontal()) {
        return property;
      }
      return {
        "width": "height",
        "margin-top": "margin-left",
        "margin-bottom ": "margin-right",
        "margin-left": "margin-top",
        "margin-right": "margin-bottom",
        "padding-left": "padding-top",
        "padding-right": "padding-bottom",
        "marginRight": "marginBottom"
      }[property];
    }
    getSlideIndex(slideEl) {
      const {
        slidesEl,
        params
      } = this;
      const slides = elementChildren(slidesEl, `.${params.slideClass}, swiper-slide`);
      const firstSlideIndex = elementIndex(slides[0]);
      return elementIndex(slideEl) - firstSlideIndex;
    }
    getSlideIndexByData(index) {
      return this.getSlideIndex(this.slides.find((slideEl) => slideEl.getAttribute("data-swiper-slide-index") * 1 === index));
    }
    getSlideIndexWhenGrid(index) {
      if (this.grid && this.params.grid && this.params.grid.rows > 1) {
        if (this.params.grid.fill === "column") {
          index = Math.floor(index / this.params.grid.rows);
        } else if (this.params.grid.fill === "row") {
          index = index % Math.ceil(this.slides.length / this.params.grid.rows);
        }
      }
      return index;
    }
    recalcSlides() {
      const swiper = this;
      const {
        slidesEl,
        params
      } = swiper;
      swiper.slides = elementChildren(slidesEl, `.${params.slideClass}, swiper-slide`);
    }
    enable() {
      const swiper = this;
      if (swiper.enabled) return;
      swiper.enabled = true;
      if (swiper.params.grabCursor) {
        swiper.setGrabCursor();
      }
      swiper.emit("enable");
    }
    disable() {
      const swiper = this;
      if (!swiper.enabled) return;
      swiper.enabled = false;
      if (swiper.params.grabCursor) {
        swiper.unsetGrabCursor();
      }
      swiper.emit("disable");
    }
    setProgress(progress, speed) {
      const swiper = this;
      progress = Math.min(Math.max(progress, 0), 1);
      const min = swiper.minTranslate();
      const max = swiper.maxTranslate();
      const current = (max - min) * progress + min;
      swiper.translateTo(current, typeof speed === "undefined" ? 0 : speed);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
    emitContainerClasses() {
      const swiper = this;
      if (!swiper.params._emitClasses || !swiper.el) return;
      const cls = swiper.el.className.split(" ").filter((className) => {
        return className.indexOf("swiper") === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
      });
      swiper.emit("_containerClasses", cls.join(" "));
    }
    getSlideClasses(slideEl) {
      const swiper = this;
      if (swiper.destroyed) return "";
      return slideEl.className.split(" ").filter((className) => {
        return className.indexOf("swiper-slide") === 0 || className.indexOf(swiper.params.slideClass) === 0;
      }).join(" ");
    }
    emitSlidesClasses() {
      const swiper = this;
      if (!swiper.params._emitClasses || !swiper.el) return;
      const updates = [];
      swiper.slides.forEach((slideEl) => {
        const classNames = swiper.getSlideClasses(slideEl);
        updates.push({
          slideEl,
          classNames
        });
        swiper.emit("_slideClass", slideEl, classNames);
      });
      swiper.emit("_slideClasses", updates);
    }
    slidesPerViewDynamic(view, exact) {
      if (view === void 0) {
        view = "current";
      }
      if (exact === void 0) {
        exact = false;
      }
      const swiper = this;
      const {
        params,
        slides,
        slidesGrid,
        slidesSizesGrid,
        size: swiperSize,
        activeIndex
      } = swiper;
      let spv = 1;
      if (typeof params.slidesPerView === "number") return params.slidesPerView;
      if (params.centeredSlides) {
        let slideSize = slides[activeIndex] ? Math.ceil(slides[activeIndex].swiperSlideSize) : 0;
        let breakLoop;
        for (let i = activeIndex + 1; i < slides.length; i += 1) {
          if (slides[i] && !breakLoop) {
            slideSize += Math.ceil(slides[i].swiperSlideSize);
            spv += 1;
            if (slideSize > swiperSize) breakLoop = true;
          }
        }
        for (let i = activeIndex - 1; i >= 0; i -= 1) {
          if (slides[i] && !breakLoop) {
            slideSize += slides[i].swiperSlideSize;
            spv += 1;
            if (slideSize > swiperSize) breakLoop = true;
          }
        }
      } else {
        if (view === "current") {
          for (let i = activeIndex + 1; i < slides.length; i += 1) {
            const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
            if (slideInView) {
              spv += 1;
            }
          }
        } else {
          for (let i = activeIndex - 1; i >= 0; i -= 1) {
            const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
            if (slideInView) {
              spv += 1;
            }
          }
        }
      }
      return spv;
    }
    update() {
      const swiper = this;
      if (!swiper || swiper.destroyed) return;
      const {
        snapGrid,
        params
      } = swiper;
      if (params.breakpoints) {
        swiper.setBreakpoint();
      }
      [...swiper.el.querySelectorAll('[loading="lazy"]')].forEach((imageEl) => {
        if (imageEl.complete) {
          processLazyPreloader(swiper, imageEl);
        }
      });
      swiper.updateSize();
      swiper.updateSlides();
      swiper.updateProgress();
      swiper.updateSlidesClasses();
      function setTranslate2() {
        const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
        const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
        swiper.setTranslate(newTranslate);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      }
      let translated;
      if (params.freeMode && params.freeMode.enabled && !params.cssMode) {
        setTranslate2();
        if (params.autoHeight) {
          swiper.updateAutoHeight();
        }
      } else {
        if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !params.centeredSlides) {
          const slides = swiper.virtual && params.virtual.enabled ? swiper.virtual.slides : swiper.slides;
          translated = swiper.slideTo(slides.length - 1, 0, false, true);
        } else {
          translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
        }
        if (!translated) {
          setTranslate2();
        }
      }
      if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
        swiper.checkOverflow();
      }
      swiper.emit("update");
    }
    changeDirection(newDirection, needUpdate) {
      if (needUpdate === void 0) {
        needUpdate = true;
      }
      const swiper = this;
      const currentDirection = swiper.params.direction;
      if (!newDirection) {
        newDirection = currentDirection === "horizontal" ? "vertical" : "horizontal";
      }
      if (newDirection === currentDirection || newDirection !== "horizontal" && newDirection !== "vertical") {
        return swiper;
      }
      swiper.el.classList.remove(`${swiper.params.containerModifierClass}${currentDirection}`);
      swiper.el.classList.add(`${swiper.params.containerModifierClass}${newDirection}`);
      swiper.emitContainerClasses();
      swiper.params.direction = newDirection;
      swiper.slides.forEach((slideEl) => {
        if (newDirection === "vertical") {
          slideEl.style.width = "";
        } else {
          slideEl.style.height = "";
        }
      });
      swiper.emit("changeDirection");
      if (needUpdate) swiper.update();
      return swiper;
    }
    changeLanguageDirection(direction) {
      const swiper = this;
      if (swiper.rtl && direction === "rtl" || !swiper.rtl && direction === "ltr") return;
      swiper.rtl = direction === "rtl";
      swiper.rtlTranslate = swiper.params.direction === "horizontal" && swiper.rtl;
      if (swiper.rtl) {
        swiper.el.classList.add(`${swiper.params.containerModifierClass}rtl`);
        swiper.el.dir = "rtl";
      } else {
        swiper.el.classList.remove(`${swiper.params.containerModifierClass}rtl`);
        swiper.el.dir = "ltr";
      }
      swiper.update();
    }
    mount(element) {
      const swiper = this;
      if (swiper.mounted) return true;
      let el = element || swiper.params.el;
      if (typeof el === "string") {
        el = document.querySelector(el);
      }
      if (!el) {
        return false;
      }
      el.swiper = swiper;
      if (el.parentNode && el.parentNode.host && el.parentNode.host.nodeName === swiper.params.swiperElementNodeName.toUpperCase()) {
        swiper.isElement = true;
      }
      const getWrapperSelector = () => {
        return `.${(swiper.params.wrapperClass || "").trim().split(" ").join(".")}`;
      };
      const getWrapper = () => {
        if (el && el.shadowRoot && el.shadowRoot.querySelector) {
          const res = el.shadowRoot.querySelector(getWrapperSelector());
          return res;
        }
        return elementChildren(el, getWrapperSelector())[0];
      };
      let wrapperEl = getWrapper();
      if (!wrapperEl && swiper.params.createElements) {
        wrapperEl = createElement("div", swiper.params.wrapperClass);
        el.append(wrapperEl);
        elementChildren(el, `.${swiper.params.slideClass}`).forEach((slideEl) => {
          wrapperEl.append(slideEl);
        });
      }
      Object.assign(swiper, {
        el,
        wrapperEl,
        slidesEl: swiper.isElement && !el.parentNode.host.slideSlots ? el.parentNode.host : wrapperEl,
        hostEl: swiper.isElement ? el.parentNode.host : el,
        mounted: true,
        // RTL
        rtl: el.dir.toLowerCase() === "rtl" || elementStyle(el, "direction") === "rtl",
        rtlTranslate: swiper.params.direction === "horizontal" && (el.dir.toLowerCase() === "rtl" || elementStyle(el, "direction") === "rtl"),
        wrongRTL: elementStyle(wrapperEl, "display") === "-webkit-box"
      });
      return true;
    }
    init(el) {
      const swiper = this;
      if (swiper.initialized) return swiper;
      const mounted = swiper.mount(el);
      if (mounted === false) return swiper;
      swiper.emit("beforeInit");
      if (swiper.params.breakpoints) {
        swiper.setBreakpoint();
      }
      swiper.addClasses();
      swiper.updateSize();
      swiper.updateSlides();
      if (swiper.params.watchOverflow) {
        swiper.checkOverflow();
      }
      if (swiper.params.grabCursor && swiper.enabled) {
        swiper.setGrabCursor();
      }
      if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
        swiper.slideTo(swiper.params.initialSlide + swiper.virtual.slidesBefore, 0, swiper.params.runCallbacksOnInit, false, true);
      } else {
        swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
      }
      if (swiper.params.loop) {
        swiper.loopCreate(void 0, true);
      }
      swiper.attachEvents();
      const lazyElements = [...swiper.el.querySelectorAll('[loading="lazy"]')];
      if (swiper.isElement) {
        lazyElements.push(...swiper.hostEl.querySelectorAll('[loading="lazy"]'));
      }
      lazyElements.forEach((imageEl) => {
        if (imageEl.complete) {
          processLazyPreloader(swiper, imageEl);
        } else {
          imageEl.addEventListener("load", (e) => {
            processLazyPreloader(swiper, e.target);
          });
        }
      });
      preload(swiper);
      swiper.initialized = true;
      preload(swiper);
      swiper.emit("init");
      swiper.emit("afterInit");
      return swiper;
    }
    destroy(deleteInstance, cleanStyles) {
      if (deleteInstance === void 0) {
        deleteInstance = true;
      }
      if (cleanStyles === void 0) {
        cleanStyles = true;
      }
      const swiper = this;
      const {
        params,
        el,
        wrapperEl,
        slides
      } = swiper;
      if (typeof swiper.params === "undefined" || swiper.destroyed) {
        return null;
      }
      swiper.emit("beforeDestroy");
      swiper.initialized = false;
      swiper.detachEvents();
      if (params.loop) {
        swiper.loopDestroy();
      }
      if (cleanStyles) {
        swiper.removeClasses();
        if (el && typeof el !== "string") {
          el.removeAttribute("style");
        }
        if (wrapperEl) {
          wrapperEl.removeAttribute("style");
        }
        if (slides && slides.length) {
          slides.forEach((slideEl) => {
            slideEl.classList.remove(params.slideVisibleClass, params.slideFullyVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
            slideEl.removeAttribute("style");
            slideEl.removeAttribute("data-swiper-slide-index");
          });
        }
      }
      swiper.emit("destroy");
      Object.keys(swiper.eventsListeners).forEach((eventName) => {
        swiper.off(eventName);
      });
      if (deleteInstance !== false) {
        if (swiper.el && typeof swiper.el !== "string") {
          swiper.el.swiper = null;
        }
        deleteProps(swiper);
      }
      swiper.destroyed = true;
      return null;
    }
    static extendDefaults(newDefaults) {
      extend2(extendedDefaults, newDefaults);
    }
    static get extendedDefaults() {
      return extendedDefaults;
    }
    static get defaults() {
      return defaults;
    }
    static installModule(mod) {
      if (!_Swiper.prototype.__modules__) _Swiper.prototype.__modules__ = [];
      const modules = _Swiper.prototype.__modules__;
      if (typeof mod === "function" && modules.indexOf(mod) < 0) {
        modules.push(mod);
      }
    }
    static use(module) {
      if (Array.isArray(module)) {
        module.forEach((m) => _Swiper.installModule(m));
        return _Swiper;
      }
      _Swiper.installModule(module);
      return _Swiper;
    }
  };
  Object.keys(prototypes).forEach((prototypeGroup) => {
    Object.keys(prototypes[prototypeGroup]).forEach((protoMethod) => {
      Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
    });
  });
  Swiper.use([Resize, Observer]);

  // node_modules/swiper/shared/create-element-if-not-defined.mjs
  function createElementIfNotDefined(swiper, originalParams, params, checkProps) {
    if (swiper.params.createElements) {
      Object.keys(checkProps).forEach((key) => {
        if (!params[key] && params.auto === true) {
          let element = elementChildren(swiper.el, `.${checkProps[key]}`)[0];
          if (!element) {
            element = createElement("div", checkProps[key]);
            element.className = checkProps[key];
            swiper.el.append(element);
          }
          params[key] = element;
          originalParams[key] = element;
        }
      });
    }
    return params;
  }

  // node_modules/swiper/modules/navigation.mjs
  function Navigation(_ref) {
    let {
      swiper,
      extendParams,
      on,
      emit
    } = _ref;
    extendParams({
      navigation: {
        nextEl: null,
        prevEl: null,
        hideOnClick: false,
        disabledClass: "swiper-button-disabled",
        hiddenClass: "swiper-button-hidden",
        lockClass: "swiper-button-lock",
        navigationDisabledClass: "swiper-navigation-disabled"
      }
    });
    swiper.navigation = {
      nextEl: null,
      prevEl: null
    };
    function getEl(el) {
      let res;
      if (el && typeof el === "string" && swiper.isElement) {
        res = swiper.el.querySelector(el) || swiper.hostEl.querySelector(el);
        if (res) return res;
      }
      if (el) {
        if (typeof el === "string") res = [...document.querySelectorAll(el)];
        if (swiper.params.uniqueNavElements && typeof el === "string" && res && res.length > 1 && swiper.el.querySelectorAll(el).length === 1) {
          res = swiper.el.querySelector(el);
        } else if (res && res.length === 1) {
          res = res[0];
        }
      }
      if (el && !res) return el;
      return res;
    }
    function toggleEl(el, disabled) {
      const params = swiper.params.navigation;
      el = makeElementsArray(el);
      el.forEach((subEl) => {
        if (subEl) {
          subEl.classList[disabled ? "add" : "remove"](...params.disabledClass.split(" "));
          if (subEl.tagName === "BUTTON") subEl.disabled = disabled;
          if (swiper.params.watchOverflow && swiper.enabled) {
            subEl.classList[swiper.isLocked ? "add" : "remove"](params.lockClass);
          }
        }
      });
    }
    function update2() {
      const {
        nextEl,
        prevEl
      } = swiper.navigation;
      if (swiper.params.loop) {
        toggleEl(prevEl, false);
        toggleEl(nextEl, false);
        return;
      }
      toggleEl(prevEl, swiper.isBeginning && !swiper.params.rewind);
      toggleEl(nextEl, swiper.isEnd && !swiper.params.rewind);
    }
    function onPrevClick(e) {
      e.preventDefault();
      if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
      swiper.slidePrev();
      emit("navigationPrev");
    }
    function onNextClick(e) {
      e.preventDefault();
      if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
      swiper.slideNext();
      emit("navigationNext");
    }
    function init() {
      const params = swiper.params.navigation;
      swiper.params.navigation = createElementIfNotDefined(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
        nextEl: "swiper-button-next",
        prevEl: "swiper-button-prev"
      });
      if (!(params.nextEl || params.prevEl)) return;
      let nextEl = getEl(params.nextEl);
      let prevEl = getEl(params.prevEl);
      Object.assign(swiper.navigation, {
        nextEl,
        prevEl
      });
      nextEl = makeElementsArray(nextEl);
      prevEl = makeElementsArray(prevEl);
      const initButton = (el, dir) => {
        if (el) {
          el.addEventListener("click", dir === "next" ? onNextClick : onPrevClick);
        }
        if (!swiper.enabled && el) {
          el.classList.add(...params.lockClass.split(" "));
        }
      };
      nextEl.forEach((el) => initButton(el, "next"));
      prevEl.forEach((el) => initButton(el, "prev"));
    }
    function destroy() {
      let {
        nextEl,
        prevEl
      } = swiper.navigation;
      nextEl = makeElementsArray(nextEl);
      prevEl = makeElementsArray(prevEl);
      const destroyButton = (el, dir) => {
        el.removeEventListener("click", dir === "next" ? onNextClick : onPrevClick);
        el.classList.remove(...swiper.params.navigation.disabledClass.split(" "));
      };
      nextEl.forEach((el) => destroyButton(el, "next"));
      prevEl.forEach((el) => destroyButton(el, "prev"));
    }
    on("init", () => {
      if (swiper.params.navigation.enabled === false) {
        disable();
      } else {
        init();
        update2();
      }
    });
    on("toEdge fromEdge lock unlock", () => {
      update2();
    });
    on("destroy", () => {
      destroy();
    });
    on("enable disable", () => {
      let {
        nextEl,
        prevEl
      } = swiper.navigation;
      nextEl = makeElementsArray(nextEl);
      prevEl = makeElementsArray(prevEl);
      if (swiper.enabled) {
        update2();
        return;
      }
      [...nextEl, ...prevEl].filter((el) => !!el).forEach((el) => el.classList.add(swiper.params.navigation.lockClass));
    });
    on("click", (_s, e) => {
      let {
        nextEl,
        prevEl
      } = swiper.navigation;
      nextEl = makeElementsArray(nextEl);
      prevEl = makeElementsArray(prevEl);
      const targetEl = e.target;
      let targetIsButton = prevEl.includes(targetEl) || nextEl.includes(targetEl);
      if (swiper.isElement && !targetIsButton) {
        const path = e.path || e.composedPath && e.composedPath();
        if (path) {
          targetIsButton = path.find((pathEl) => nextEl.includes(pathEl) || prevEl.includes(pathEl));
        }
      }
      if (swiper.params.navigation.hideOnClick && !targetIsButton) {
        if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
        let isHidden;
        if (nextEl.length) {
          isHidden = nextEl[0].classList.contains(swiper.params.navigation.hiddenClass);
        } else if (prevEl.length) {
          isHidden = prevEl[0].classList.contains(swiper.params.navigation.hiddenClass);
        }
        if (isHidden === true) {
          emit("navigationShow");
        } else {
          emit("navigationHide");
        }
        [...nextEl, ...prevEl].filter((el) => !!el).forEach((el) => el.classList.toggle(swiper.params.navigation.hiddenClass));
      }
    });
    const enable = () => {
      swiper.el.classList.remove(...swiper.params.navigation.navigationDisabledClass.split(" "));
      init();
      update2();
    };
    const disable = () => {
      swiper.el.classList.add(...swiper.params.navigation.navigationDisabledClass.split(" "));
      destroy();
    };
    Object.assign(swiper.navigation, {
      enable,
      disable,
      update: update2,
      init,
      destroy
    });
  }

  // node_modules/swiper/shared/classes-to-selector.mjs
  function classesToSelector(classes2) {
    if (classes2 === void 0) {
      classes2 = "";
    }
    return `.${classes2.trim().replace(/([\.:!+\/()[\]])/g, "\\$1").replace(/ /g, ".")}`;
  }

  // node_modules/swiper/modules/pagination.mjs
  function Pagination(_ref) {
    let {
      swiper,
      extendParams,
      on,
      emit
    } = _ref;
    const pfx = "swiper-pagination";
    extendParams({
      pagination: {
        el: null,
        bulletElement: "span",
        clickable: false,
        hideOnClick: false,
        renderBullet: null,
        renderProgressbar: null,
        renderFraction: null,
        renderCustom: null,
        progressbarOpposite: false,
        type: "bullets",
        // 'bullets' or 'progressbar' or 'fraction' or 'custom'
        dynamicBullets: false,
        dynamicMainBullets: 1,
        formatFractionCurrent: (number) => number,
        formatFractionTotal: (number) => number,
        bulletClass: `${pfx}-bullet`,
        bulletActiveClass: `${pfx}-bullet-active`,
        modifierClass: `${pfx}-`,
        currentClass: `${pfx}-current`,
        totalClass: `${pfx}-total`,
        hiddenClass: `${pfx}-hidden`,
        progressbarFillClass: `${pfx}-progressbar-fill`,
        progressbarOppositeClass: `${pfx}-progressbar-opposite`,
        clickableClass: `${pfx}-clickable`,
        lockClass: `${pfx}-lock`,
        horizontalClass: `${pfx}-horizontal`,
        verticalClass: `${pfx}-vertical`,
        paginationDisabledClass: `${pfx}-disabled`
      }
    });
    swiper.pagination = {
      el: null,
      bullets: []
    };
    let bulletSize;
    let dynamicBulletIndex = 0;
    function isPaginationDisabled() {
      return !swiper.params.pagination.el || !swiper.pagination.el || Array.isArray(swiper.pagination.el) && swiper.pagination.el.length === 0;
    }
    function setSideBullets(bulletEl, position) {
      const {
        bulletActiveClass
      } = swiper.params.pagination;
      if (!bulletEl) return;
      bulletEl = bulletEl[`${position === "prev" ? "previous" : "next"}ElementSibling`];
      if (bulletEl) {
        bulletEl.classList.add(`${bulletActiveClass}-${position}`);
        bulletEl = bulletEl[`${position === "prev" ? "previous" : "next"}ElementSibling`];
        if (bulletEl) {
          bulletEl.classList.add(`${bulletActiveClass}-${position}-${position}`);
        }
      }
    }
    function getMoveDirection(prevIndex, nextIndex, length) {
      prevIndex = prevIndex % length;
      nextIndex = nextIndex % length;
      if (nextIndex === prevIndex + 1) {
        return "next";
      } else if (nextIndex === prevIndex - 1) {
        return "previous";
      }
      return;
    }
    function onBulletClick(e) {
      const bulletEl = e.target.closest(classesToSelector(swiper.params.pagination.bulletClass));
      if (!bulletEl) {
        return;
      }
      e.preventDefault();
      const index = elementIndex(bulletEl) * swiper.params.slidesPerGroup;
      if (swiper.params.loop) {
        if (swiper.realIndex === index) return;
        const moveDirection = getMoveDirection(swiper.realIndex, index, swiper.slides.length);
        if (moveDirection === "next") {
          swiper.slideNext();
        } else if (moveDirection === "previous") {
          swiper.slidePrev();
        } else {
          swiper.slideToLoop(index);
        }
      } else {
        swiper.slideTo(index);
      }
    }
    function update2() {
      const rtl = swiper.rtl;
      const params = swiper.params.pagination;
      if (isPaginationDisabled()) return;
      let el = swiper.pagination.el;
      el = makeElementsArray(el);
      let current;
      let previousIndex;
      const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
      const total = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
      if (swiper.params.loop) {
        previousIndex = swiper.previousRealIndex || 0;
        current = swiper.params.slidesPerGroup > 1 ? Math.floor(swiper.realIndex / swiper.params.slidesPerGroup) : swiper.realIndex;
      } else if (typeof swiper.snapIndex !== "undefined") {
        current = swiper.snapIndex;
        previousIndex = swiper.previousSnapIndex;
      } else {
        previousIndex = swiper.previousIndex || 0;
        current = swiper.activeIndex || 0;
      }
      if (params.type === "bullets" && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
        const bullets = swiper.pagination.bullets;
        let firstIndex;
        let lastIndex;
        let midIndex;
        if (params.dynamicBullets) {
          bulletSize = elementOuterSize(bullets[0], swiper.isHorizontal() ? "width" : "height", true);
          el.forEach((subEl) => {
            subEl.style[swiper.isHorizontal() ? "width" : "height"] = `${bulletSize * (params.dynamicMainBullets + 4)}px`;
          });
          if (params.dynamicMainBullets > 1 && previousIndex !== void 0) {
            dynamicBulletIndex += current - (previousIndex || 0);
            if (dynamicBulletIndex > params.dynamicMainBullets - 1) {
              dynamicBulletIndex = params.dynamicMainBullets - 1;
            } else if (dynamicBulletIndex < 0) {
              dynamicBulletIndex = 0;
            }
          }
          firstIndex = Math.max(current - dynamicBulletIndex, 0);
          lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
          midIndex = (lastIndex + firstIndex) / 2;
        }
        bullets.forEach((bulletEl) => {
          const classesToRemove = [...["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map((suffix) => `${params.bulletActiveClass}${suffix}`)].map((s) => typeof s === "string" && s.includes(" ") ? s.split(" ") : s).flat();
          bulletEl.classList.remove(...classesToRemove);
        });
        if (el.length > 1) {
          bullets.forEach((bullet) => {
            const bulletIndex = elementIndex(bullet);
            if (bulletIndex === current) {
              bullet.classList.add(...params.bulletActiveClass.split(" "));
            } else if (swiper.isElement) {
              bullet.setAttribute("part", "bullet");
            }
            if (params.dynamicBullets) {
              if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
                bullet.classList.add(...`${params.bulletActiveClass}-main`.split(" "));
              }
              if (bulletIndex === firstIndex) {
                setSideBullets(bullet, "prev");
              }
              if (bulletIndex === lastIndex) {
                setSideBullets(bullet, "next");
              }
            }
          });
        } else {
          const bullet = bullets[current];
          if (bullet) {
            bullet.classList.add(...params.bulletActiveClass.split(" "));
          }
          if (swiper.isElement) {
            bullets.forEach((bulletEl, bulletIndex) => {
              bulletEl.setAttribute("part", bulletIndex === current ? "bullet-active" : "bullet");
            });
          }
          if (params.dynamicBullets) {
            const firstDisplayedBullet = bullets[firstIndex];
            const lastDisplayedBullet = bullets[lastIndex];
            for (let i = firstIndex; i <= lastIndex; i += 1) {
              if (bullets[i]) {
                bullets[i].classList.add(...`${params.bulletActiveClass}-main`.split(" "));
              }
            }
            setSideBullets(firstDisplayedBullet, "prev");
            setSideBullets(lastDisplayedBullet, "next");
          }
        }
        if (params.dynamicBullets) {
          const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
          const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
          const offsetProp = rtl ? "right" : "left";
          bullets.forEach((bullet) => {
            bullet.style[swiper.isHorizontal() ? offsetProp : "top"] = `${bulletsOffset}px`;
          });
        }
      }
      el.forEach((subEl, subElIndex) => {
        if (params.type === "fraction") {
          subEl.querySelectorAll(classesToSelector(params.currentClass)).forEach((fractionEl) => {
            fractionEl.textContent = params.formatFractionCurrent(current + 1);
          });
          subEl.querySelectorAll(classesToSelector(params.totalClass)).forEach((totalEl) => {
            totalEl.textContent = params.formatFractionTotal(total);
          });
        }
        if (params.type === "progressbar") {
          let progressbarDirection;
          if (params.progressbarOpposite) {
            progressbarDirection = swiper.isHorizontal() ? "vertical" : "horizontal";
          } else {
            progressbarDirection = swiper.isHorizontal() ? "horizontal" : "vertical";
          }
          const scale = (current + 1) / total;
          let scaleX = 1;
          let scaleY = 1;
          if (progressbarDirection === "horizontal") {
            scaleX = scale;
          } else {
            scaleY = scale;
          }
          subEl.querySelectorAll(classesToSelector(params.progressbarFillClass)).forEach((progressEl) => {
            progressEl.style.transform = `translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`;
            progressEl.style.transitionDuration = `${swiper.params.speed}ms`;
          });
        }
        if (params.type === "custom" && params.renderCustom) {
          setInnerHTML(subEl, params.renderCustom(swiper, current + 1, total));
          if (subElIndex === 0) emit("paginationRender", subEl);
        } else {
          if (subElIndex === 0) emit("paginationRender", subEl);
          emit("paginationUpdate", subEl);
        }
        if (swiper.params.watchOverflow && swiper.enabled) {
          subEl.classList[swiper.isLocked ? "add" : "remove"](params.lockClass);
        }
      });
    }
    function render() {
      const params = swiper.params.pagination;
      if (isPaginationDisabled()) return;
      const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.grid && swiper.params.grid.rows > 1 ? swiper.slides.length / Math.ceil(swiper.params.grid.rows) : swiper.slides.length;
      let el = swiper.pagination.el;
      el = makeElementsArray(el);
      let paginationHTML = "";
      if (params.type === "bullets") {
        let numberOfBullets = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        if (swiper.params.freeMode && swiper.params.freeMode.enabled && numberOfBullets > slidesLength) {
          numberOfBullets = slidesLength;
        }
        for (let i = 0; i < numberOfBullets; i += 1) {
          if (params.renderBullet) {
            paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
          } else {
            paginationHTML += `<${params.bulletElement} ${swiper.isElement ? 'part="bullet"' : ""} class="${params.bulletClass}"></${params.bulletElement}>`;
          }
        }
      }
      if (params.type === "fraction") {
        if (params.renderFraction) {
          paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
        } else {
          paginationHTML = `<span class="${params.currentClass}"></span> / <span class="${params.totalClass}"></span>`;
        }
      }
      if (params.type === "progressbar") {
        if (params.renderProgressbar) {
          paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
        } else {
          paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
        }
      }
      swiper.pagination.bullets = [];
      el.forEach((subEl) => {
        if (params.type !== "custom") {
          setInnerHTML(subEl, paginationHTML || "");
        }
        if (params.type === "bullets") {
          swiper.pagination.bullets.push(...subEl.querySelectorAll(classesToSelector(params.bulletClass)));
        }
      });
      if (params.type !== "custom") {
        emit("paginationRender", el[0]);
      }
    }
    function init() {
      swiper.params.pagination = createElementIfNotDefined(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
        el: "swiper-pagination"
      });
      const params = swiper.params.pagination;
      if (!params.el) return;
      let el;
      if (typeof params.el === "string" && swiper.isElement) {
        el = swiper.el.querySelector(params.el);
      }
      if (!el && typeof params.el === "string") {
        el = [...document.querySelectorAll(params.el)];
      }
      if (!el) {
        el = params.el;
      }
      if (!el || el.length === 0) return;
      if (swiper.params.uniqueNavElements && typeof params.el === "string" && Array.isArray(el) && el.length > 1) {
        el = [...swiper.el.querySelectorAll(params.el)];
        if (el.length > 1) {
          el = el.find((subEl) => {
            if (elementParents(subEl, ".swiper")[0] !== swiper.el) return false;
            return true;
          });
        }
      }
      if (Array.isArray(el) && el.length === 1) el = el[0];
      Object.assign(swiper.pagination, {
        el
      });
      el = makeElementsArray(el);
      el.forEach((subEl) => {
        if (params.type === "bullets" && params.clickable) {
          subEl.classList.add(...(params.clickableClass || "").split(" "));
        }
        subEl.classList.add(params.modifierClass + params.type);
        subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        if (params.type === "bullets" && params.dynamicBullets) {
          subEl.classList.add(`${params.modifierClass}${params.type}-dynamic`);
          dynamicBulletIndex = 0;
          if (params.dynamicMainBullets < 1) {
            params.dynamicMainBullets = 1;
          }
        }
        if (params.type === "progressbar" && params.progressbarOpposite) {
          subEl.classList.add(params.progressbarOppositeClass);
        }
        if (params.clickable) {
          subEl.addEventListener("click", onBulletClick);
        }
        if (!swiper.enabled) {
          subEl.classList.add(params.lockClass);
        }
      });
    }
    function destroy() {
      const params = swiper.params.pagination;
      if (isPaginationDisabled()) return;
      let el = swiper.pagination.el;
      if (el) {
        el = makeElementsArray(el);
        el.forEach((subEl) => {
          subEl.classList.remove(params.hiddenClass);
          subEl.classList.remove(params.modifierClass + params.type);
          subEl.classList.remove(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
          if (params.clickable) {
            subEl.classList.remove(...(params.clickableClass || "").split(" "));
            subEl.removeEventListener("click", onBulletClick);
          }
        });
      }
      if (swiper.pagination.bullets) swiper.pagination.bullets.forEach((subEl) => subEl.classList.remove(...params.bulletActiveClass.split(" ")));
    }
    on("changeDirection", () => {
      if (!swiper.pagination || !swiper.pagination.el) return;
      const params = swiper.params.pagination;
      let {
        el
      } = swiper.pagination;
      el = makeElementsArray(el);
      el.forEach((subEl) => {
        subEl.classList.remove(params.horizontalClass, params.verticalClass);
        subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
      });
    });
    on("init", () => {
      if (swiper.params.pagination.enabled === false) {
        disable();
      } else {
        init();
        render();
        update2();
      }
    });
    on("activeIndexChange", () => {
      if (typeof swiper.snapIndex === "undefined") {
        update2();
      }
    });
    on("snapIndexChange", () => {
      update2();
    });
    on("snapGridLengthChange", () => {
      render();
      update2();
    });
    on("destroy", () => {
      destroy();
    });
    on("enable disable", () => {
      let {
        el
      } = swiper.pagination;
      if (el) {
        el = makeElementsArray(el);
        el.forEach((subEl) => subEl.classList[swiper.enabled ? "remove" : "add"](swiper.params.pagination.lockClass));
      }
    });
    on("lock unlock", () => {
      update2();
    });
    on("click", (_s, e) => {
      const targetEl = e.target;
      const el = makeElementsArray(swiper.pagination.el);
      if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && el && el.length > 0 && !targetEl.classList.contains(swiper.params.pagination.bulletClass)) {
        if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
        const isHidden = el[0].classList.contains(swiper.params.pagination.hiddenClass);
        if (isHidden === true) {
          emit("paginationShow");
        } else {
          emit("paginationHide");
        }
        el.forEach((subEl) => subEl.classList.toggle(swiper.params.pagination.hiddenClass));
      }
    });
    const enable = () => {
      swiper.el.classList.remove(swiper.params.pagination.paginationDisabledClass);
      let {
        el
      } = swiper.pagination;
      if (el) {
        el = makeElementsArray(el);
        el.forEach((subEl) => subEl.classList.remove(swiper.params.pagination.paginationDisabledClass));
      }
      init();
      render();
      update2();
    };
    const disable = () => {
      swiper.el.classList.add(swiper.params.pagination.paginationDisabledClass);
      let {
        el
      } = swiper.pagination;
      if (el) {
        el = makeElementsArray(el);
        el.forEach((subEl) => subEl.classList.add(swiper.params.pagination.paginationDisabledClass));
      }
      destroy();
    };
    Object.assign(swiper.pagination, {
      enable,
      disable,
      render,
      update: update2,
      init,
      destroy
    });
  }

  // node_modules/swiper/modules/autoplay.mjs
  function Autoplay(_ref) {
    let {
      swiper,
      extendParams,
      on,
      emit,
      params
    } = _ref;
    swiper.autoplay = {
      running: false,
      paused: false,
      timeLeft: 0
    };
    extendParams({
      autoplay: {
        enabled: false,
        delay: 3e3,
        waitForTransition: true,
        disableOnInteraction: false,
        stopOnLastSlide: false,
        reverseDirection: false,
        pauseOnMouseEnter: false
      }
    });
    let timeout;
    let raf;
    let autoplayDelayTotal = params && params.autoplay ? params.autoplay.delay : 3e3;
    let autoplayDelayCurrent = params && params.autoplay ? params.autoplay.delay : 3e3;
    let autoplayTimeLeft;
    let autoplayStartTime = (/* @__PURE__ */ new Date()).getTime();
    let wasPaused;
    let isTouched;
    let pausedByTouch;
    let touchStartTimeout;
    let slideChanged;
    let pausedByInteraction;
    let pausedByPointerEnter;
    function onTransitionEnd(e) {
      if (!swiper || swiper.destroyed || !swiper.wrapperEl) return;
      if (e.target !== swiper.wrapperEl) return;
      swiper.wrapperEl.removeEventListener("transitionend", onTransitionEnd);
      if (pausedByPointerEnter || e.detail && e.detail.bySwiperTouchMove) {
        return;
      }
      resume();
    }
    const calcTimeLeft = () => {
      if (swiper.destroyed || !swiper.autoplay.running) return;
      if (swiper.autoplay.paused) {
        wasPaused = true;
      } else if (wasPaused) {
        autoplayDelayCurrent = autoplayTimeLeft;
        wasPaused = false;
      }
      const timeLeft = swiper.autoplay.paused ? autoplayTimeLeft : autoplayStartTime + autoplayDelayCurrent - (/* @__PURE__ */ new Date()).getTime();
      swiper.autoplay.timeLeft = timeLeft;
      emit("autoplayTimeLeft", timeLeft, timeLeft / autoplayDelayTotal);
      raf = requestAnimationFrame(() => {
        calcTimeLeft();
      });
    };
    const getSlideDelay = () => {
      let activeSlideEl;
      if (swiper.virtual && swiper.params.virtual.enabled) {
        activeSlideEl = swiper.slides.find((slideEl) => slideEl.classList.contains("swiper-slide-active"));
      } else {
        activeSlideEl = swiper.slides[swiper.activeIndex];
      }
      if (!activeSlideEl) return void 0;
      const currentSlideDelay = parseInt(activeSlideEl.getAttribute("data-swiper-autoplay"), 10);
      return currentSlideDelay;
    };
    const run = (delayForce) => {
      if (swiper.destroyed || !swiper.autoplay.running) return;
      cancelAnimationFrame(raf);
      calcTimeLeft();
      let delay = typeof delayForce === "undefined" ? swiper.params.autoplay.delay : delayForce;
      autoplayDelayTotal = swiper.params.autoplay.delay;
      autoplayDelayCurrent = swiper.params.autoplay.delay;
      const currentSlideDelay = getSlideDelay();
      if (!Number.isNaN(currentSlideDelay) && currentSlideDelay > 0 && typeof delayForce === "undefined") {
        delay = currentSlideDelay;
        autoplayDelayTotal = currentSlideDelay;
        autoplayDelayCurrent = currentSlideDelay;
      }
      autoplayTimeLeft = delay;
      const speed = swiper.params.speed;
      const proceed = () => {
        if (!swiper || swiper.destroyed) return;
        if (swiper.params.autoplay.reverseDirection) {
          if (!swiper.isBeginning || swiper.params.loop || swiper.params.rewind) {
            swiper.slidePrev(speed, true, true);
            emit("autoplay");
          } else if (!swiper.params.autoplay.stopOnLastSlide) {
            swiper.slideTo(swiper.slides.length - 1, speed, true, true);
            emit("autoplay");
          }
        } else {
          if (!swiper.isEnd || swiper.params.loop || swiper.params.rewind) {
            swiper.slideNext(speed, true, true);
            emit("autoplay");
          } else if (!swiper.params.autoplay.stopOnLastSlide) {
            swiper.slideTo(0, speed, true, true);
            emit("autoplay");
          }
        }
        if (swiper.params.cssMode) {
          autoplayStartTime = (/* @__PURE__ */ new Date()).getTime();
          requestAnimationFrame(() => {
            run();
          });
        }
      };
      if (delay > 0) {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          proceed();
        }, delay);
      } else {
        requestAnimationFrame(() => {
          proceed();
        });
      }
      return delay;
    };
    const start = () => {
      autoplayStartTime = (/* @__PURE__ */ new Date()).getTime();
      swiper.autoplay.running = true;
      run();
      emit("autoplayStart");
    };
    const stop = () => {
      swiper.autoplay.running = false;
      clearTimeout(timeout);
      cancelAnimationFrame(raf);
      emit("autoplayStop");
    };
    const pause = (internal, reset) => {
      if (swiper.destroyed || !swiper.autoplay.running) return;
      clearTimeout(timeout);
      if (!internal) {
        pausedByInteraction = true;
      }
      const proceed = () => {
        emit("autoplayPause");
        if (swiper.params.autoplay.waitForTransition) {
          swiper.wrapperEl.addEventListener("transitionend", onTransitionEnd);
        } else {
          resume();
        }
      };
      swiper.autoplay.paused = true;
      if (reset) {
        if (slideChanged) {
          autoplayTimeLeft = swiper.params.autoplay.delay;
        }
        slideChanged = false;
        proceed();
        return;
      }
      const delay = autoplayTimeLeft || swiper.params.autoplay.delay;
      autoplayTimeLeft = delay - ((/* @__PURE__ */ new Date()).getTime() - autoplayStartTime);
      if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop) return;
      if (autoplayTimeLeft < 0) autoplayTimeLeft = 0;
      proceed();
    };
    const resume = () => {
      if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop || swiper.destroyed || !swiper.autoplay.running) return;
      autoplayStartTime = (/* @__PURE__ */ new Date()).getTime();
      if (pausedByInteraction) {
        pausedByInteraction = false;
        run(autoplayTimeLeft);
      } else {
        run();
      }
      swiper.autoplay.paused = false;
      emit("autoplayResume");
    };
    const onVisibilityChange = () => {
      if (swiper.destroyed || !swiper.autoplay.running) return;
      const document2 = getDocument();
      if (document2.visibilityState === "hidden") {
        pausedByInteraction = true;
        pause(true);
      }
      if (document2.visibilityState === "visible") {
        resume();
      }
    };
    const onPointerEnter = (e) => {
      if (e.pointerType !== "mouse") return;
      pausedByInteraction = true;
      pausedByPointerEnter = true;
      if (swiper.animating || swiper.autoplay.paused) return;
      pause(true);
    };
    const onPointerLeave = (e) => {
      if (e.pointerType !== "mouse") return;
      pausedByPointerEnter = false;
      if (swiper.autoplay.paused) {
        resume();
      }
    };
    const attachMouseEvents = () => {
      if (swiper.params.autoplay.pauseOnMouseEnter) {
        swiper.el.addEventListener("pointerenter", onPointerEnter);
        swiper.el.addEventListener("pointerleave", onPointerLeave);
      }
    };
    const detachMouseEvents = () => {
      if (swiper.el && typeof swiper.el !== "string") {
        swiper.el.removeEventListener("pointerenter", onPointerEnter);
        swiper.el.removeEventListener("pointerleave", onPointerLeave);
      }
    };
    const attachDocumentEvents = () => {
      const document2 = getDocument();
      document2.addEventListener("visibilitychange", onVisibilityChange);
    };
    const detachDocumentEvents = () => {
      const document2 = getDocument();
      document2.removeEventListener("visibilitychange", onVisibilityChange);
    };
    on("init", () => {
      if (swiper.params.autoplay.enabled) {
        attachMouseEvents();
        attachDocumentEvents();
        start();
      }
    });
    on("destroy", () => {
      detachMouseEvents();
      detachDocumentEvents();
      if (swiper.autoplay.running) {
        stop();
      }
    });
    on("_freeModeStaticRelease", () => {
      if (pausedByTouch || pausedByInteraction) {
        resume();
      }
    });
    on("_freeModeNoMomentumRelease", () => {
      if (!swiper.params.autoplay.disableOnInteraction) {
        pause(true, true);
      } else {
        stop();
      }
    });
    on("beforeTransitionStart", (_s, speed, internal) => {
      if (swiper.destroyed || !swiper.autoplay.running) return;
      if (internal || !swiper.params.autoplay.disableOnInteraction) {
        pause(true, true);
      } else {
        stop();
      }
    });
    on("sliderFirstMove", () => {
      if (swiper.destroyed || !swiper.autoplay.running) return;
      if (swiper.params.autoplay.disableOnInteraction) {
        stop();
        return;
      }
      isTouched = true;
      pausedByTouch = false;
      pausedByInteraction = false;
      touchStartTimeout = setTimeout(() => {
        pausedByInteraction = true;
        pausedByTouch = true;
        pause(true);
      }, 200);
    });
    on("touchEnd", () => {
      if (swiper.destroyed || !swiper.autoplay.running || !isTouched) return;
      clearTimeout(touchStartTimeout);
      clearTimeout(timeout);
      if (swiper.params.autoplay.disableOnInteraction) {
        pausedByTouch = false;
        isTouched = false;
        return;
      }
      if (pausedByTouch && swiper.params.cssMode) resume();
      pausedByTouch = false;
      isTouched = false;
    });
    on("slideChange", () => {
      if (swiper.destroyed || !swiper.autoplay.running) return;
      slideChanged = true;
    });
    Object.assign(swiper.autoplay, {
      start,
      stop,
      pause,
      resume
    });
  }

  // node_modules/swiper/modules/thumbs.mjs
  function Thumb(_ref) {
    let {
      swiper,
      extendParams,
      on
    } = _ref;
    extendParams({
      thumbs: {
        swiper: null,
        multipleActiveThumbs: true,
        autoScrollOffset: 0,
        slideThumbActiveClass: "swiper-slide-thumb-active",
        thumbsContainerClass: "swiper-thumbs"
      }
    });
    let initialized2 = false;
    let swiperCreated = false;
    swiper.thumbs = {
      swiper: null
    };
    function onThumbClick() {
      const thumbsSwiper = swiper.thumbs.swiper;
      if (!thumbsSwiper || thumbsSwiper.destroyed) return;
      const clickedIndex = thumbsSwiper.clickedIndex;
      const clickedSlide = thumbsSwiper.clickedSlide;
      if (clickedSlide && clickedSlide.classList.contains(swiper.params.thumbs.slideThumbActiveClass)) return;
      if (typeof clickedIndex === "undefined" || clickedIndex === null) return;
      let slideToIndex;
      if (thumbsSwiper.params.loop) {
        slideToIndex = parseInt(thumbsSwiper.clickedSlide.getAttribute("data-swiper-slide-index"), 10);
      } else {
        slideToIndex = clickedIndex;
      }
      if (swiper.params.loop) {
        swiper.slideToLoop(slideToIndex);
      } else {
        swiper.slideTo(slideToIndex);
      }
    }
    function init() {
      const {
        thumbs: thumbsParams
      } = swiper.params;
      if (initialized2) return false;
      initialized2 = true;
      const SwiperClass = swiper.constructor;
      if (thumbsParams.swiper instanceof SwiperClass) {
        if (thumbsParams.swiper.destroyed) {
          initialized2 = false;
          return false;
        }
        swiper.thumbs.swiper = thumbsParams.swiper;
        Object.assign(swiper.thumbs.swiper.originalParams, {
          watchSlidesProgress: true,
          slideToClickedSlide: false
        });
        Object.assign(swiper.thumbs.swiper.params, {
          watchSlidesProgress: true,
          slideToClickedSlide: false
        });
        swiper.thumbs.swiper.update();
      } else if (isObject2(thumbsParams.swiper)) {
        const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
        Object.assign(thumbsSwiperParams, {
          watchSlidesProgress: true,
          slideToClickedSlide: false
        });
        swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
        swiperCreated = true;
      }
      swiper.thumbs.swiper.el.classList.add(swiper.params.thumbs.thumbsContainerClass);
      swiper.thumbs.swiper.on("tap", onThumbClick);
      return true;
    }
    function update2(initial) {
      const thumbsSwiper = swiper.thumbs.swiper;
      if (!thumbsSwiper || thumbsSwiper.destroyed) return;
      const slidesPerView = thumbsSwiper.params.slidesPerView === "auto" ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
      let thumbsToActivate = 1;
      const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
      if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) {
        thumbsToActivate = swiper.params.slidesPerView;
      }
      if (!swiper.params.thumbs.multipleActiveThumbs) {
        thumbsToActivate = 1;
      }
      thumbsToActivate = Math.floor(thumbsToActivate);
      thumbsSwiper.slides.forEach((slideEl) => slideEl.classList.remove(thumbActiveClass));
      if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) {
        for (let i = 0; i < thumbsToActivate; i += 1) {
          elementChildren(thumbsSwiper.slidesEl, `[data-swiper-slide-index="${swiper.realIndex + i}"]`).forEach((slideEl) => {
            slideEl.classList.add(thumbActiveClass);
          });
        }
      } else {
        for (let i = 0; i < thumbsToActivate; i += 1) {
          if (thumbsSwiper.slides[swiper.realIndex + i]) {
            thumbsSwiper.slides[swiper.realIndex + i].classList.add(thumbActiveClass);
          }
        }
      }
      const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
      const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
      if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
        const currentThumbsIndex = thumbsSwiper.activeIndex;
        let newThumbsIndex;
        let direction;
        if (thumbsSwiper.params.loop) {
          const newThumbsSlide = thumbsSwiper.slides.find((slideEl) => slideEl.getAttribute("data-swiper-slide-index") === `${swiper.realIndex}`);
          newThumbsIndex = thumbsSwiper.slides.indexOf(newThumbsSlide);
          direction = swiper.activeIndex > swiper.previousIndex ? "next" : "prev";
        } else {
          newThumbsIndex = swiper.realIndex;
          direction = newThumbsIndex > swiper.previousIndex ? "next" : "prev";
        }
        if (useOffset) {
          newThumbsIndex += direction === "next" ? autoScrollOffset : -1 * autoScrollOffset;
        }
        if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
          if (thumbsSwiper.params.centeredSlides) {
            if (newThumbsIndex > currentThumbsIndex) {
              newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
            } else {
              newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
            }
          } else if (newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup === 1) ;
          thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : void 0);
        }
      }
    }
    on("beforeInit", () => {
      const {
        thumbs
      } = swiper.params;
      if (!thumbs || !thumbs.swiper) return;
      if (typeof thumbs.swiper === "string" || thumbs.swiper instanceof HTMLElement) {
        const document2 = getDocument();
        const getThumbsElementAndInit = () => {
          const thumbsElement = typeof thumbs.swiper === "string" ? document2.querySelector(thumbs.swiper) : thumbs.swiper;
          if (thumbsElement && thumbsElement.swiper) {
            thumbs.swiper = thumbsElement.swiper;
            init();
            update2(true);
          } else if (thumbsElement) {
            const eventName = `${swiper.params.eventsPrefix}init`;
            const onThumbsSwiper = (e) => {
              thumbs.swiper = e.detail[0];
              thumbsElement.removeEventListener(eventName, onThumbsSwiper);
              init();
              update2(true);
              thumbs.swiper.update();
              swiper.update();
            };
            thumbsElement.addEventListener(eventName, onThumbsSwiper);
          }
          return thumbsElement;
        };
        const watchForThumbsToAppear = () => {
          if (swiper.destroyed) return;
          const thumbsElement = getThumbsElementAndInit();
          if (!thumbsElement) {
            requestAnimationFrame(watchForThumbsToAppear);
          }
        };
        requestAnimationFrame(watchForThumbsToAppear);
      } else {
        init();
        update2(true);
      }
    });
    on("slideChange update resize observerUpdate", () => {
      update2();
    });
    on("setTransition", (_s, duration) => {
      const thumbsSwiper = swiper.thumbs.swiper;
      if (!thumbsSwiper || thumbsSwiper.destroyed) return;
      thumbsSwiper.setTransition(duration);
    });
    on("beforeDestroy", () => {
      const thumbsSwiper = swiper.thumbs.swiper;
      if (!thumbsSwiper || thumbsSwiper.destroyed) return;
      if (swiperCreated) {
        thumbsSwiper.destroy();
      }
    });
    Object.assign(swiper.thumbs, {
      init,
      update: update2
    });
  }

  // node_modules/swiper/shared/effect-init.mjs
  function effectInit(params) {
    const {
      effect,
      swiper,
      on,
      setTranslate: setTranslate2,
      setTransition: setTransition2,
      overwriteParams,
      perspective,
      recreateShadows,
      getEffectParams
    } = params;
    on("beforeInit", () => {
      if (swiper.params.effect !== effect) return;
      swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);
      if (perspective && perspective()) {
        swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
      }
      const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
      Object.assign(swiper.params, overwriteParamsResult);
      Object.assign(swiper.originalParams, overwriteParamsResult);
    });
    on("setTranslate _virtualUpdated", () => {
      if (swiper.params.effect !== effect) return;
      setTranslate2();
    });
    on("setTransition", (_s, duration) => {
      if (swiper.params.effect !== effect) return;
      setTransition2(duration);
    });
    on("transitionEnd", () => {
      if (swiper.params.effect !== effect) return;
      if (recreateShadows) {
        if (!getEffectParams || !getEffectParams().slideShadows) return;
        swiper.slides.forEach((slideEl) => {
          slideEl.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((shadowEl) => shadowEl.remove());
        });
        recreateShadows();
      }
    });
    let requireUpdateOnVirtual;
    on("virtualUpdate", () => {
      if (swiper.params.effect !== effect) return;
      if (!swiper.slides.length) {
        requireUpdateOnVirtual = true;
      }
      requestAnimationFrame(() => {
        if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
          setTranslate2();
          requireUpdateOnVirtual = false;
        }
      });
    });
  }

  // node_modules/swiper/shared/effect-target.mjs
  function effectTarget(effectParams, slideEl) {
    const transformEl = getSlideTransformEl(slideEl);
    if (transformEl !== slideEl) {
      transformEl.style.backfaceVisibility = "hidden";
      transformEl.style["-webkit-backface-visibility"] = "hidden";
    }
    return transformEl;
  }

  // node_modules/swiper/shared/effect-virtual-transition-end.mjs
  function effectVirtualTransitionEnd(_ref) {
    let {
      swiper,
      duration,
      transformElements,
      allSlides
    } = _ref;
    const {
      activeIndex
    } = swiper;
    const getSlide = (el) => {
      if (!el.parentElement) {
        const slide2 = swiper.slides.find((slideEl) => slideEl.shadowRoot && slideEl.shadowRoot === el.parentNode);
        return slide2;
      }
      return el.parentElement;
    };
    if (swiper.params.virtualTranslate && duration !== 0) {
      let eventTriggered = false;
      let transitionEndTarget;
      if (allSlides) {
        transitionEndTarget = transformElements;
      } else {
        transitionEndTarget = transformElements.filter((transformEl) => {
          const el = transformEl.classList.contains("swiper-slide-transform") ? getSlide(transformEl) : transformEl;
          return swiper.getSlideIndex(el) === activeIndex;
        });
      }
      transitionEndTarget.forEach((el) => {
        elementTransitionEnd(el, () => {
          if (eventTriggered) return;
          if (!swiper || swiper.destroyed) return;
          eventTriggered = true;
          swiper.animating = false;
          const evt = new window.CustomEvent("transitionend", {
            bubbles: true,
            cancelable: true
          });
          swiper.wrapperEl.dispatchEvent(evt);
        });
      });
    }
  }

  // node_modules/swiper/modules/effect-fade.mjs
  function EffectFade(_ref) {
    let {
      swiper,
      extendParams,
      on
    } = _ref;
    extendParams({
      fadeEffect: {
        crossFade: false
      }
    });
    const setTranslate2 = () => {
      const {
        slides
      } = swiper;
      const params = swiper.params.fadeEffect;
      for (let i = 0; i < slides.length; i += 1) {
        const slideEl = swiper.slides[i];
        const offset = slideEl.swiperSlideOffset;
        let tx = -offset;
        if (!swiper.params.virtualTranslate) tx -= swiper.translate;
        let ty = 0;
        if (!swiper.isHorizontal()) {
          ty = tx;
          tx = 0;
        }
        const slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(slideEl.progress), 0) : 1 + Math.min(Math.max(slideEl.progress, -1), 0);
        const targetEl = effectTarget(params, slideEl);
        targetEl.style.opacity = slideOpacity;
        targetEl.style.transform = `translate3d(${tx}px, ${ty}px, 0px)`;
      }
    };
    const setTransition2 = (duration) => {
      const transformElements = swiper.slides.map((slideEl) => getSlideTransformEl(slideEl));
      transformElements.forEach((el) => {
        el.style.transitionDuration = `${duration}ms`;
      });
      effectVirtualTransitionEnd({
        swiper,
        duration,
        transformElements,
        allSlides: true
      });
    };
    effectInit({
      effect: "fade",
      swiper,
      on,
      setTranslate: setTranslate2,
      setTransition: setTransition2,
      overwriteParams: () => ({
        slidesPerView: 1,
        slidesPerGroup: 1,
        watchSlidesProgress: true,
        spaceBetween: 0,
        virtualTranslate: !swiper.params.cssMode
      })
    });
  }

  // src/js/modules/vendors/swiper-wrapper.js
  function initSwiper(containerSelector, options = {}) {
    const container = document.querySelector(containerSelector);
    if (!container) {
      console.warn(`Swiper container not found: ${containerSelector}`);
      return null;
    }
    const defaultModules = [Navigation, Pagination, Autoplay];
    const additionalModules = Array.isArray(options.modules) ? options.modules : [];
    const mergedModules = [.../* @__PURE__ */ new Set([...defaultModules, ...additionalModules])];
    const swiperOptions = {
      ...options,
      modules: mergedModules
    };
    return new Swiper(containerSelector, swiperOptions);
  }

  // src/js/modules/components/announcement-bar-swiper.js
  var ANNOUNCEMENT_MOTION_DURATION = 400;
  var ANNOUNCEMENT_MOTION_DELAY = 400;
  var ANNOUNCEMENT_SHIFT_PX = 16;
  var ANNOUNCEMENT_RVP_BASE = 1440;
  var ANNOUNCEMENT_RVS_BASE = 390;
  function rv(valuePx, baseWidth) {
    const scaled = valuePx / baseWidth * window.innerWidth;
    return valuePx < 0 ? Math.max(valuePx, scaled) : Math.min(valuePx, scaled);
  }
  function getAnnouncementShiftPx() {
    const baseWidth = window.innerWidth <= BREAKPOINT_SP ? ANNOUNCEMENT_RVS_BASE : ANNOUNCEMENT_RVP_BASE;
    return rv(ANNOUNCEMENT_SHIFT_PX, baseWidth);
  }
  function prefersReducedMotion() {
    return window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches ?? false;
  }
  function readMotionFromElement(item) {
    const style = getComputedStyle(item);
    const opacity = Number.parseFloat(style.opacity) || 0;
    let x = 0;
    const transform = style.transform;
    if (transform && transform !== "none") {
      const matrixMatch = transform.match(/matrix\(([^)]+)\)/);
      if (matrixMatch) {
        const parts = matrixMatch[1].split(",").map((value) => Number.parseFloat(value.trim()));
        x = parts[4] || 0;
      }
    }
    return { opacity, x };
  }
  function applyMotionState(item, state) {
    item.style.opacity = String(state.opacity);
    item.style.transform = `translateX(${state.x}px)`;
  }
  function getTargetMotionState(slide2, shiftPx) {
    if (slide2.classList.contains("swiper-slide-active")) {
      return { opacity: 1, x: 0 };
    }
    if (slide2.classList.contains("swiper-slide-prev")) {
      return { opacity: 0, x: -shiftPx };
    }
    if (slide2.classList.contains("swiper-slide-next")) {
      return { opacity: 0, x: shiftPx };
    }
    return { opacity: 0, x: 0 };
  }
  function syncAnnouncementItemMotion(container) {
    const shiftPx = getAnnouncementShiftPx();
    const reducedMotion = prefersReducedMotion();
    container.querySelectorAll(".swiper-slide").forEach((slide2) => {
      const item = slide2.querySelector(".s-announcement-bar__item");
      if (!item) {
        return;
      }
      const from = readMotionFromElement(item);
      const to = getTargetMotionState(slide2, shiftPx);
      const isActive = slide2.classList.contains("swiper-slide-active");
      item.getAnimations().forEach((animation2) => animation2.cancel());
      applyMotionState(item, from);
      if (reducedMotion || Math.abs(from.opacity - to.opacity) < 1e-3 && Math.abs(from.x - to.x) < 0.1) {
        applyMotionState(item, to);
        return;
      }
      const animation = item.animate(
        [
          { opacity: from.opacity, transform: `translateX(${from.x}px)` },
          { opacity: to.opacity, transform: `translateX(${to.x}px)` }
        ],
        {
          duration: ANNOUNCEMENT_MOTION_DURATION,
          delay: isActive ? ANNOUNCEMENT_MOTION_DELAY : 0,
          easing: "ease-in-out",
          fill: "forwards"
        }
      );
      animation.finished.then(() => {
        applyMotionState(item, to);
      }).catch(() => {
      });
    });
  }
  function initAnnouncementBarSwipers(root = document) {
    const containers = root.querySelectorAll(".js-announcement-bar__swiper");
    if (!containers.length) {
      return;
    }
    containers.forEach((container) => {
      if (container.dataset.swiperInitialized === "true") {
        return;
      }
      if (!container.id) {
        return;
      }
      const slideSpeed = Number.parseInt(container.dataset.slideSpeed, 10);
      const autoplayDelay = Number.isFinite(slideSpeed) ? slideSpeed : 3e3;
      const swiperOptions = {
        modules: [EffectFade, Autoplay],
        slidesPerView: 1,
        loop: true,
        effect: "fade",
        fadeEffect: {
          crossFade: true
        }
      };
      if (autoplayDelay > 0) {
        swiperOptions.autoplay = {
          delay: autoplayDelay,
          disableOnInteraction: false
        };
      }
      const swiper = initSwiper(`#${container.id}`, swiperOptions);
      if (swiper) {
        syncAnnouncementItemMotion(container);
        swiper.on("slideChangeTransitionStart", () => {
          syncAnnouncementItemMotion(container);
        });
      }
      container.dataset.swiperInitialized = "true";
    });
  }

  // src/js/modules/components/main-visual-swiper.js
  var MAIN_VISUAL_SWIPER_SPEED = 800;
  var MAIN_VISUAL_ZOOM_DURATION = 6800;
  var MAIN_VISUAL_ZOOM_SCALE = 1.1111;
  function prefersReducedMotion2() {
    return window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches ?? false;
  }
  function getVideoResumeKey(video) {
    return video.currentSrc || video.getAttribute("src") || video.querySelector("source")?.src || "";
  }
  function getVideoResumeStore(container) {
    if (!container._mainVisualVideoPositions) {
      container._mainVisualVideoPositions = /* @__PURE__ */ new Map();
    }
    return container._mainVisualVideoPositions;
  }
  function syncMainVisualVideos(container, swiper = null) {
    const slides = swiper?.slides ?? container.querySelectorAll(".swiper-slide");
    const resumeStore = getVideoResumeStore(container);
    slides.forEach((slide2) => {
      const video = slide2.querySelector(".js-main-visual__video");
      if (!video) {
        return;
      }
      const isActive = swiper ? slide2.classList.contains("swiper-slide-active") : true;
      const useVideoDuration = slide2.dataset.useVideoDuration === "true";
      const resumeKey = getVideoResumeKey(video);
      if (isActive) {
        if (useVideoDuration) {
          video.currentTime = 0;
          if (resumeKey) {
            resumeStore.delete(resumeKey);
          }
        } else if (resumeKey && resumeStore.has(resumeKey)) {
          video.currentTime = resumeStore.get(resumeKey);
        }
        video.play().catch(() => {
        });
        return;
      }
      video.pause();
      if (useVideoDuration) {
        video.currentTime = 0;
        if (resumeKey) {
          resumeStore.delete(resumeKey);
        }
        return;
      }
      if (resumeKey) {
        resumeStore.set(resumeKey, video.currentTime);
      }
    });
  }
  function readTransformScale(element) {
    const transform = getComputedStyle(element).transform;
    if (!transform || transform === "none") {
      return 1;
    }
    const matrix3dMatch = transform.match(/matrix3d\(([^)]+)\)/);
    if (matrix3dMatch) {
      const parts = matrix3dMatch[1].split(",").map((value) => Number.parseFloat(value.trim()));
      return Math.abs(parts[0]) || 1;
    }
    const matrixMatch = transform.match(/matrix\(([^)]+)\)/);
    if (matrixMatch) {
      const parts = matrixMatch[1].split(",").map((value) => Number.parseFloat(value.trim()));
      return Math.abs(parts[0]) || 1;
    }
    return 1;
  }
  function freezeInactiveMainVisualZooms(container, swiper = null) {
    const slides = swiper?.slides ?? container.querySelectorAll(".swiper-slide");
    slides.forEach((slide2) => {
      const visual = slide2.querySelector(".s-main-visual__visual.is-zoom");
      if (!visual) {
        return;
      }
      const isActive = swiper ? slide2.classList.contains("swiper-slide-active") : true;
      if (isActive) {
        return;
      }
      const currentScale = readTransformScale(visual);
      visual.getAnimations().forEach((animation) => animation.cancel());
      visual.style.transform = `scale(${currentScale})`;
    });
  }
  function prepareActiveMainVisualZoom(container, swiper = null) {
    const slides = swiper?.slides ?? container.querySelectorAll(".swiper-slide");
    slides.forEach((slide2) => {
      const visual = slide2.querySelector(".s-main-visual__visual.is-zoom");
      if (!visual) {
        return;
      }
      const isActive = swiper ? slide2.classList.contains("swiper-slide-active") : true;
      if (!isActive) {
        return;
      }
      visual.getAnimations().forEach((animation) => animation.cancel());
      visual.style.transform = "scale(1)";
    });
  }
  function startActiveMainVisualZoom(container, swiper = null) {
    const slides = swiper?.slides ?? container.querySelectorAll(".swiper-slide");
    slides.forEach((slide2) => {
      const visual = slide2.querySelector(".s-main-visual__visual.is-zoom");
      if (!visual) {
        return;
      }
      const isActive = swiper ? slide2.classList.contains("swiper-slide-active") : true;
      if (!isActive) {
        return;
      }
      visual.getAnimations().forEach((animation2) => animation2.cancel());
      if (prefersReducedMotion2()) {
        visual.style.transform = `scale(${MAIN_VISUAL_ZOOM_SCALE})`;
        return;
      }
      visual.style.transform = "scale(1)";
      const animation = visual.animate(
        [{ transform: "scale(1)" }, { transform: `scale(${MAIN_VISUAL_ZOOM_SCALE})` }],
        {
          duration: MAIN_VISUAL_ZOOM_DURATION,
          easing: "linear",
          fill: "forwards"
        }
      );
      animation.finished.then(() => {
        visual.style.transform = `scale(${MAIN_VISUAL_ZOOM_SCALE})`;
      }).catch(() => {
      });
    });
  }
  function syncMainVisualZoom(container, swiper = null) {
    freezeInactiveMainVisualZooms(container, swiper);
    startActiveMainVisualZoom(container, swiper);
  }
  function getVideoDurationMs(video) {
    const durationMs = Math.round(video.duration * 1e3);
    if (!Number.isFinite(durationMs) || durationMs <= 0) {
      return null;
    }
    return durationMs;
  }
  function getVideoSlideAutoplayDelayMs(durationMs, transitionMs = MAIN_VISUAL_SWIPER_SPEED) {
    return Math.max(durationMs - transitionMs, 0);
  }
  function waitForVideoMetadata(video) {
    if (video.readyState >= HTMLMediaElement.HAVE_METADATA) {
      return Promise.resolve(getVideoDurationMs(video));
    }
    return new Promise((resolve) => {
      const finish = () => {
        video.removeEventListener("loadedmetadata", onLoaded);
        video.removeEventListener("error", onError);
        resolve(getVideoDurationMs(video));
      };
      const onLoaded = () => finish();
      const onError = () => resolve(null);
      video.addEventListener("loadedmetadata", onLoaded, { once: true });
      video.addEventListener("error", onError, { once: true });
    });
  }
  async function applyVideoSlideAutoplayDelays(container) {
    const slides = container.querySelectorAll(".swiper-slide");
    const tasks = [];
    slides.forEach((slide2) => {
      if (slide2.dataset.useVideoDuration !== "true") {
        return;
      }
      const video = slide2.querySelector(".js-main-visual__video");
      if (!video) {
        return;
      }
      tasks.push(
        waitForVideoMetadata(video).then((durationMs) => {
          if (durationMs === null) {
            return;
          }
          slide2.setAttribute("data-swiper-autoplay", String(getVideoSlideAutoplayDelayMs(durationMs)));
        })
      );
    });
    await Promise.all(tasks);
  }
  function syncVideoSlideAutoplayDelays(swiper) {
    swiper.slides.forEach((slide2) => {
      if (slide2.dataset.useVideoDuration !== "true") {
        return;
      }
      const video = slide2.querySelector(".js-main-visual__video");
      if (!video) {
        return;
      }
      const durationMs = getVideoDurationMs(video);
      if (durationMs === null) {
        return;
      }
      slide2.setAttribute(
        "data-swiper-autoplay",
        String(getVideoSlideAutoplayDelayMs(durationMs, swiper.params.speed))
      );
    });
  }
  function restartAutoplayIfDurationSlide(swiper) {
    if (!swiper.autoplay?.running) {
      return;
    }
    const activeSlide = swiper.slides[swiper.activeIndex];
    if (activeSlide?.dataset.useVideoDuration !== "true") {
      return;
    }
    swiper.autoplay.stop();
    swiper.autoplay.start();
  }
  async function initMainVisualSwiper(container) {
    if (container.dataset.swiperInitialized === "true") {
      return;
    }
    if (!container.id) {
      return;
    }
    const slideCount = container.querySelectorAll(".swiper-slide").length;
    if (slideCount <= 1) {
      syncMainVisualVideos(container);
      syncMainVisualZoom(container);
      container.dataset.swiperInitialized = "true";
      return;
    }
    const autoplayEnabled = container.dataset.autoplay === "true";
    const slideSpeed = Number.parseInt(container.dataset.slideSpeed, 10);
    const autoplayDelay = autoplayEnabled && Number.isFinite(slideSpeed) ? slideSpeed : autoplayEnabled ? 5e3 : 0;
    if (autoplayEnabled && autoplayDelay > 0) {
      const hasDurationSlides = container.querySelector('[data-use-video-duration="true"]');
      if (hasDurationSlides) {
        await applyVideoSlideAutoplayDelays(container);
      }
    }
    const swiperOptions = {
      modules: [EffectFade, Autoplay],
      slidesPerView: 1,
      loop: true,
      effect: "fade",
      fadeEffect: {
        crossFade: true
      },
      speed: MAIN_VISUAL_SWIPER_SPEED,
      // フェード中に指へ追従すると切替後のズーム開始と競合しやすいため無効化
      followFinger: false
    };
    if (autoplayEnabled && autoplayDelay > 0) {
      swiperOptions.autoplay = {
        delay: autoplayDelay,
        disableOnInteraction: false
      };
    }
    const swiper = initSwiper(`#${container.id}`, swiperOptions);
    if (swiper) {
      if (autoplayEnabled && autoplayDelay > 0) {
        syncVideoSlideAutoplayDelays(swiper);
      }
      syncMainVisualVideos(container, swiper);
      syncMainVisualZoom(container, swiper);
      restartAutoplayIfDurationSlide(swiper);
      swiper.on("slideChangeTransitionStart", () => {
        freezeInactiveMainVisualZooms(container, swiper);
        prepareActiveMainVisualZoom(container, swiper);
      });
      swiper.on("slideChangeTransitionEnd", () => {
        startActiveMainVisualZoom(container, swiper);
        syncMainVisualVideos(container, swiper);
        restartAutoplayIfDurationSlide(swiper);
      });
    }
    container.dataset.swiperInitialized = "true";
  }
  function initMainVisualSwipers(root = document) {
    const containers = root.querySelectorAll(".js-main-visual__swiper");
    if (!containers.length) {
      return;
    }
    containers.forEach((container) => {
      initMainVisualSwiper(container).catch(() => {
      });
    });
  }

  // src/js/modules/helpers/ajax.js
  async function fetchGet(url, options = {}) {
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          ...options.headers
        },
        ...options
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("Fetch GET error:", error);
      throw error;
    }
  }

  // src/js/modules/helpers/ranking-item.js
  function normalizeRankingItem(item, fallbackRank) {
    const rank = Number.parseInt(String(item.rank ?? fallbackRank), 10);
    const productId = item.product_id ?? item.id ?? "";
    return {
      rank: Number.isFinite(rank) && rank >= 1 ? rank : fallbackRank,
      productId: productId === "" || productId === null || productId === void 0 ? "" : String(productId),
      title: item.product_display_name ?? item.display_name ?? item.product_title ?? item.title ?? "",
      handle: item.product_handle ?? item.handle ?? "",
      image: item.product_image ?? item.image ?? ""
    };
  }

  // src/js/modules/components/product-carousel-swiper.js
  var CARD_SLIDER_SELECTOR = ".js-card-slider__swiper";
  function initProductCarouselSwiper(container) {
    if (!container?.id) {
      return;
    }
    const existingInstance = container.swiper;
    if (existingInstance) {
      existingInstance.destroy(true, true);
    }
    const slider = container.closest(".c-card-slider");
    const prevEl = slider?.querySelector(".c-card-slider__nav--prev");
    const nextEl = slider?.querySelector(".c-card-slider__nav--next");
    initSwiper(`#${container.id}`, {
      modules: [],
      slidesPerView: "auto",
      slidesPerGroup: 1,
      watchOverflow: true,
      spaceBetween: 0,
      pagination: false,
      autoplay: false,
      breakpoints: {
        [MIN_WIDTH_ABOVE_TB]: {
          slidesPerView: 5,
          slidesPerGroup: 1,
          spaceBetween: 0
        }
      },
      navigation: prevEl && nextEl ? {
        prevEl,
        nextEl,
        disabledClass: "is-disabled"
      } : false
    });
    container.dataset.swiperInitialized = "true";
  }
  function initCardSliderSwipers(root = document) {
    const containers = root.querySelectorAll(CARD_SLIDER_SELECTOR);
    if (!containers.length) {
      return;
    }
    containers.forEach(initProductCarouselSwiper);
  }
  var initPopularRankingSwipers = initCardSliderSwipers;

  // src/js/constants/ranking.js
  var RANKING_API_PATH = "/apps/nishikiya/ranking";
  var RANKING_FETCH_ENABLED = true;

  // src/js/modules/components/popular-ranking.js
  var DEFAULT_IMAGE_SIZES = "(max-width: 839px) calc((110 / 390) * 100vw), 178px";
  var RANKING_BADGE_ICONS = {
    1: `<svg xmlns="http://www.w3.org/2000/svg" width="42" height="34" viewBox="0 0 42 34" fill="none"><path d="M20.739 1.10815L10.7392 12.2909L0.738708 6.7002V33.1082H40.7387V6.69884L30.7389 12.2902L20.739 1.10815Z" fill="#967F4A" stroke="white" stroke-width="1.47742"/></svg>`,
    2: `<svg xmlns="http://www.w3.org/2000/svg" width="42" height="34" viewBox="0 0 42 34" fill="none"><path d="M20.739 1.10815L10.7392 12.2909L0.738708 6.7002V33.1082H40.7387V6.69884L30.7389 12.2902L20.739 1.10815Z" fill="#808080" stroke="white" stroke-width="1.47742"/></svg>`,
    3: `<svg xmlns="http://www.w3.org/2000/svg" width="42" height="34" viewBox="0 0 42 34" fill="none"><path d="M20.739 1.10815L10.7392 12.2909L0.738708 6.7002V33.1082H40.7387V6.69884L30.7389 12.2902L20.739 1.10815Z" fill="#9D6743" stroke="white" stroke-width="1.47742"/></svg>`,
    default: `<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none"><path d="M17.536 35.0364C27.201 35.0364 35.036 27.2014 35.036 17.5364C35.036 7.87139 27.201 0.036377 17.536 0.036377C7.87103 0.036377 0.0360107 7.87139 0.0360107 17.5364C0.0360107 27.2014 7.87103 35.0364 17.536 35.0364Z" fill="#D9D9D9"/><path d="M17.5364 34.3999C26.8499 34.3999 34.4 26.8498 34.4 17.5362C34.4 8.22271 26.8499 0.672607 17.5364 0.672607C8.22284 0.672607 0.672729 8.22271 0.672729 17.5362C0.672729 26.8498 8.22284 34.3999 17.5364 34.3999Z" stroke="white" stroke-width="1.34545"/></svg>`
  };
  function initPopularRankingSections(root = document) {
    const sections = root.querySelectorAll(".js-popular-ranking");
    sections.forEach((section) => {
      if (section.dataset.popularRankingLoading === "true") {
        return;
      }
      if (!RANKING_FETCH_ENABLED) {
        initPopularRankingSwipers(section);
        return;
      }
      loadPopularRanking(section);
    });
  }
  async function loadPopularRanking(section) {
    if (section.dataset.popularRankingLoaded === "true") {
      return;
    }
    const list = section.querySelector(".c-card-slider__list");
    if (!list) {
      return;
    }
    section.dataset.popularRankingLoading = "true";
    const params = new URLSearchParams({
      limit: section.dataset.limit || "5",
      months_ago: section.dataset.monthsAgo || "0"
    });
    if (section.dataset.collectionId) {
      params.set("collection_id", section.dataset.collectionId);
    }
    try {
      const json = await fetchGet(`${RANKING_API_PATH}?${params.toString()}`);
      const items = json?.success ? json.data?.ranking ?? [] : [];
      if (!section.isConnected) {
        return;
      }
      if (!items.length) {
        section.hidden = true;
        return;
      }
      const imageSizes = getImageSizes(section);
      const maxRank = getMaxRank(section);
      const collectionHandle = section.dataset.collectionHandle || "";
      list.innerHTML = items.map(
        (item, index) => renderRankingItem(item, index + 1, imageSizes, maxRank, collectionHandle)
      ).join("");
      section.classList.add("is-loaded");
      section.dataset.popularRankingLoaded = "true";
      initPopularRankingSwipers(section);
    } catch (error) {
      console.error("Popular ranking fetch error:", error);
      if (section.isConnected) {
        section.hidden = true;
      }
    } finally {
      delete section.dataset.popularRankingLoading;
    }
  }
  function buildProductUrl(productHandle, collectionHandle = "") {
    if (!productHandle) {
      return "#";
    }
    if (collectionHandle) {
      return `/collections/${collectionHandle}/products/${productHandle}`;
    }
    return `/products/${productHandle}`;
  }
  function renderRankingItem(item, fallbackRank, imageSizes, maxRank, collectionHandle = "") {
    const normalized = normalizeRankingItem(item, fallbackRank);
    const title = escapeHtml2(normalized.title);
    const handle = escapeHtml2(normalized.handle);
    const collectionHandleEscaped = escapeHtml2(collectionHandle);
    const productUrl = buildProductUrl(handle, collectionHandleEscaped);
    const imageUrl = normalized.image ? escapeHtml2(normalized.image) : "";
    const imageAlt = title;
    const badgeRank = clampRank(normalized.rank, maxRank);
    const mediaMarkup = imageUrl ? `<div class="c-card-item__media-primary">
        <div class="c-picture">
          <div class="c-picture__content">
            <img
              class="c-picture__image"
              src="${imageUrl}"
              alt="${imageAlt}"
              width="200"
              height="200"
              loading="lazy"
              sizes="${escapeHtml2(imageSizes)}"
            >
          </div>
        </div>
      </div>` : `<div class="c-card-item__media-primary">
        <div class="c-picture">
          <div class="c-picture__content">
            <span class="c-card-item__skeleton-item c-card-item__skeleton-item--image" aria-hidden="true"></span>
          </div>
        </div>
      </div>`;
    return `<li class="c-card-slider__item swiper-slide">
    <div class="c-card-item c-card-item--ranking">
      <a class="c-card-item__link" href="${productUrl}">
        <div class="c-card-item__badge">
          ${renderRankingBadge(badgeRank, maxRank)}
        </div>
        <div class="c-card-item__body">
          <div class="c-card-item__media">
            ${mediaMarkup}
          </div>
          <div class="c-card-item__content">
            <p class="c-card-item__title">${title}</p>
          </div>
        </div>
      </a>
    </div>
  </li>`;
  }
  function renderRankingBadge(rank, maxRank = 10) {
    const badgeRank = clampRank(rank, maxRank);
    const icon = badgeRank <= 3 ? RANKING_BADGE_ICONS[badgeRank] : RANKING_BADGE_ICONS.default;
    return `<div class="c-ranking-badge is-number-${badgeRank}">
    <span class="c-ranking-badge__icon u-icon" aria-hidden="true">${icon}</span>
    <span class="c-ranking-badge__number u-font--lato">${badgeRank}</span>
  </div>`;
  }
  function getMaxRank(section) {
    const value = Number.parseInt(section.dataset.limit || "10", 10);
    if (!Number.isFinite(value) || value < 1) {
      return 10;
    }
    return value;
  }
  function clampRank(rank, maxRank = 10) {
    const value = Number.parseInt(String(rank), 10);
    if (!Number.isFinite(value) || value < 1) {
      return 1;
    }
    if (value > maxRank) {
      return maxRank;
    }
    return value;
  }
  function getImageSizes(section) {
    const script = section.querySelector("[data-popular-ranking-image-sizes]");
    if (!script) {
      return DEFAULT_IMAGE_SIZES;
    }
    try {
      const parsed = JSON.parse(script.textContent);
      if (typeof parsed === "string" && parsed.length > 0) {
        return parsed;
      }
    } catch (error) {
      console.warn("Popular ranking image sizes parse error:", error);
    }
    return DEFAULT_IMAGE_SIZES;
  }
  function escapeHtml2(text) {
    return String(text).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
  }

  // src/js/modules/helpers/card-price.js
  function formatPriceAmount(amount) {
    if (amount === null || amount === void 0 || Number.isNaN(Number(amount))) {
      return "";
    }
    return Math.floor(Number(amount)).toLocaleString("ja-JP");
  }
  function readNumber(value) {
    if (value === null || value === void 0 || value === "") {
      return null;
    }
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }
  function getCardPriceMeta(item) {
    const priceMin = readNumber(item.price_min ?? item.product_price_min) ?? readNumber(item.price ?? item.product_price);
    const priceMax = readNumber(item.price_max ?? item.product_price_max) ?? priceMin;
    let priceVaries = item.price_varies === true || item.product_price_varies === true;
    if (!priceVaries && priceMin !== null && priceMax !== null && priceMin !== priceMax) {
      priceVaries = true;
    }
    const compareMinRaw = item.compare_at_price_min ?? item.product_compare_at_price_min ?? item.compare_at_price ?? item.product_compare_at_price;
    const compareMin = readNumber(compareMinRaw);
    const isOnSale = compareMin !== null && priceMin !== null && compareMin > priceMin;
    const available = item.available ?? item.product_available;
    return {
      priceAmount: priceMin !== null ? formatPriceAmount(priceMin) : "",
      compareAtAmount: isOnSale && compareMin !== null ? formatPriceAmount(compareMin) : "",
      showPriceRange: priceVaries && priceMin !== null && priceMax !== null && priceMin !== priceMax,
      isOnSale,
      isSoldOut: available === false
    };
  }
  function renderCardPriceHtml(meta) {
    if (!meta?.priceAmount) {
      return "";
    }
    let rootClass = "c-card-price";
    if (meta.isOnSale) {
      rootClass += " c-card-price--on-sale";
    }
    if (meta.isSoldOut) {
      rootClass += " c-card-price--sold-out";
    }
    const compareHtml = meta.isOnSale && meta.compareAtAmount ? `<span class="c-card-price__compare u-font--lato"><span class="visually-hidden">\u901A\u5E38\u4FA1\u683C</span>${meta.compareAtAmount}<span class="c-card-price__compare-unit">\u5186</span></span>` : "";
    const priceLabel = meta.isSoldOut ? "\u58F2\u308A\u5207\u308C" : meta.isOnSale ? "\u30BB\u30FC\u30EB\u4FA1\u683C" : meta.showPriceRange ? "\u6700\u4F4E\u4FA1\u683C" : "\u4FA1\u683C";
    const rangeHtml = meta.showPriceRange ? '<span class="c-card-price__range" aria-hidden="true">\u301C</span>' : "";
    return `<div class="${rootClass}">` + compareHtml + `<div class="c-card-price__main"><span class="c-card-price__value u-font--lato"><span class="visually-hidden">${priceLabel}</span>` + meta.priceAmount + `</span><span class="c-card-price__suffix"><span class="c-card-price__unit">\u5186</span>` + rangeHtml + `<span class="c-card-price__tax">\u7A0E\u8FBC</span></span></div></div>`;
  }

  // src/js/modules/components/ranking-page.js
  var DEFAULT_IMAGE_SIZES2 = "(max-width: 839px) calc((100vw - 48px - 24px) / 2), calc((min(100vw, 950px) - 128px) / 5)";
  var RANKING_BADGE_ICONS2 = {
    1: `<svg xmlns="http://www.w3.org/2000/svg" width="42" height="34" viewBox="0 0 42 34" fill="none"><path d="M20.739 1.10815L10.7392 12.2909L0.738708 6.7002V33.1082H40.7387V6.69884L30.7389 12.2902L20.739 1.10815Z" fill="#967F4A" stroke="white" stroke-width="1.47742"/></svg>`,
    2: `<svg xmlns="http://www.w3.org/2000/svg" width="42" height="34" viewBox="0 0 42 34" fill="none"><path d="M20.739 1.10815L10.7392 12.2909L0.738708 6.7002V33.1082H40.7387V6.69884L30.7389 12.2902L20.739 1.10815Z" fill="#808080" stroke="white" stroke-width="1.47742"/></svg>`,
    3: `<svg xmlns="http://www.w3.org/2000/svg" width="42" height="34" viewBox="0 0 42 34" fill="none"><path d="M20.739 1.10815L10.7392 12.2909L0.738708 6.7002V33.1082H40.7387V6.69884L30.7389 12.2902L20.739 1.10815Z" fill="#9D6743" stroke="white" stroke-width="1.47742"/></svg>`,
    default: `<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none"><path d="M17.536 35.0364C27.201 35.0364 35.036 27.2014 35.036 17.5364C35.036 7.87139 27.201 0.036377 17.536 0.036377C7.87103 0.036377 0.0360107 7.87139 0.0360107 17.5364C0.0360107 27.2014 7.87103 35.0364 17.536 35.0364Z" fill="#D9D9D9"/><path d="M17.5364 34.3999C26.8499 34.3999 34.4 26.8498 34.4 17.5362C34.4 8.22271 26.8499 0.672607 17.5364 0.672607C8.22284 0.672607 0.672729 8.22271 0.672729 17.5362C0.672729 26.8498 8.22284 34.3999 17.5364 34.3999Z" stroke="white" stroke-width="1.34545"/></svg>`
  };
  function initRankingPageCategories(root = document) {
    if (!RANKING_FETCH_ENABLED) {
      return;
    }
    const categories = root.querySelectorAll(".js-ranking-category");
    categories.forEach((category) => {
      if (category.dataset.rankingCategoryLoading === "true") {
        return;
      }
      loadRankingCategory(category);
    });
  }
  async function loadRankingCategory(category) {
    if (category.dataset.rankingCategoryLoaded === "true") {
      return;
    }
    const grid = category.querySelector(".js-ranking-category__grid");
    if (!grid) {
      return;
    }
    category.dataset.rankingCategoryLoading = "true";
    const params = new URLSearchParams({
      limit: category.dataset.limit || "10",
      months_ago: category.dataset.monthsAgo || "0"
    });
    if (category.dataset.collectionId) {
      params.set("collection_id", category.dataset.collectionId);
    }
    try {
      const json = await fetchGet(`${RANKING_API_PATH}?${params.toString()}`);
      if (!category.isConnected) {
        return;
      }
      if (!json?.success) {
        showRankingCategoryStatus(category, "error");
        return;
      }
      const items = json.data?.ranking ?? [];
      if (!items.length) {
        showRankingCategoryStatus(category, "empty");
        return;
      }
      const imageSizes = getImageSizes2(category);
      const maxRank = getMaxRank2(category);
      const collectionHandle = category.dataset.collectionHandle || "";
      grid.hidden = false;
      grid.innerHTML = items.map(
        (item, index) => renderRankingGridItem(item, index + 1, imageSizes, maxRank, collectionHandle)
      ).join("");
      hideRankingCategoryStatus(category);
      category.classList.add("is-loaded");
      category.dataset.rankingCategoryLoaded = "true";
    } catch (error) {
      console.error("Ranking page fetch error:", error);
      if (category.isConnected) {
        showRankingCategoryStatus(category, "error");
      }
    } finally {
      delete category.dataset.rankingCategoryLoading;
    }
  }
  function showRankingCategoryStatus(category, type) {
    const grid = category.querySelector(".js-ranking-category__grid");
    const emptyEl = category.querySelector(".js-ranking-category__empty");
    const errorEl = category.querySelector(".js-ranking-category__error");
    if (grid) {
      grid.innerHTML = "";
      grid.hidden = true;
    }
    if (emptyEl) {
      emptyEl.hidden = type !== "empty";
    }
    if (errorEl) {
      errorEl.hidden = type !== "error";
    }
    category.classList.add("is-loaded");
    category.dataset.rankingCategoryLoaded = "true";
  }
  function hideRankingCategoryStatus(category) {
    const emptyEl = category.querySelector(".js-ranking-category__empty");
    const errorEl = category.querySelector(".js-ranking-category__error");
    if (emptyEl) {
      emptyEl.hidden = true;
    }
    if (errorEl) {
      errorEl.hidden = true;
    }
  }
  function buildProductUrl2(productHandle, collectionHandle = "") {
    if (!productHandle) {
      return "#";
    }
    if (collectionHandle) {
      return `/collections/${collectionHandle}/products/${productHandle}`;
    }
    return `/products/${productHandle}`;
  }
  function renderRankingGridItem(item, fallbackRank, imageSizes, maxRank, collectionHandle = "") {
    const normalized = normalizeRankingItem(item, fallbackRank);
    const title = escapeHtml3(normalized.title);
    const handle = escapeHtml3(normalized.handle);
    const collectionHandleEscaped = escapeHtml3(collectionHandle);
    const productUrl = buildProductUrl2(handle, collectionHandleEscaped);
    const imageUrl = normalized.image ? escapeHtml3(normalized.image) : "";
    const imageAlt = title;
    const badgeRank = clampRank2(normalized.rank, maxRank);
    const priceHtml = renderCardPriceHtml(getCardPriceMeta(item));
    const mediaMarkup = imageUrl ? `<div class="c-card-item__media-primary">
        <div class="c-picture">
          <div class="c-picture__content">
            <img
              class="c-picture__image"
              src="${imageUrl}"
              alt="${imageAlt}"
              width="200"
              height="200"
              loading="lazy"
              sizes="${escapeHtml3(imageSizes)}"
            >
          </div>
        </div>
      </div>` : `<div class="c-card-item__media-primary">
        <div class="c-picture">
          <div class="c-picture__content">
            <span class="c-card-item__skeleton-item c-card-item__skeleton-item--image" aria-hidden="true"></span>
          </div>
        </div>
      </div>`;
    return `<li class="s-ranking__grid-item">
    <div class="c-card-item c-card-item--ranking">
      <a class="c-card-item__link" href="${productUrl}">
        <div class="c-card-item__badge">
          ${renderRankingBadge2(badgeRank)}
        </div>
        <div class="c-card-item__body">
          <div class="c-card-item__media">
            ${mediaMarkup}
          </div>
          <div class="c-card-item__content">
            <p class="c-card-item__title">${title}</p>
            ${priceHtml}
          </div>
        </div>
      </a>
    </div>
  </li>`;
  }
  function renderRankingBadge2(rank) {
    const badgeRank = clampRank2(rank);
    const icon = badgeRank <= 3 ? RANKING_BADGE_ICONS2[badgeRank] : RANKING_BADGE_ICONS2.default;
    return `<div class="c-ranking-badge is-number-${badgeRank}">
    <span class="c-ranking-badge__icon u-icon" aria-hidden="true">${icon}</span>
    <span class="c-ranking-badge__number u-font--lato">${badgeRank}</span>
  </div>`;
  }
  function getMaxRank2(category) {
    const value = Number.parseInt(category.dataset.limit || "10", 10);
    if (!Number.isFinite(value) || value < 1) {
      return 10;
    }
    return value;
  }
  function clampRank2(rank, maxRank = 10) {
    const value = Number.parseInt(String(rank), 10);
    if (!Number.isFinite(value) || value < 1) {
      return 1;
    }
    if (value > maxRank) {
      return maxRank;
    }
    return value;
  }
  function getImageSizes2(category) {
    const script = category.querySelector("[data-ranking-category-image-sizes]");
    if (!script) {
      return DEFAULT_IMAGE_SIZES2;
    }
    try {
      const parsed = JSON.parse(script.textContent);
      if (typeof parsed === "string" && parsed.length > 0) {
        return parsed;
      }
    } catch (error) {
      console.warn("Ranking page image sizes parse error:", error);
    }
    return DEFAULT_IMAGE_SIZES2;
  }
  function escapeHtml3(text) {
    return String(text).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
  }

  // src/js/modules/components/collection-category-swiper.js
  function getActiveSlideIndex(container) {
    const slides = container.querySelectorAll(".swiper-slide");
    for (let index = 0; index < slides.length; index += 1) {
      if (slides[index].querySelector(".is-active")) {
        return index;
      }
    }
    return 0;
  }
  function initCollectionCategorySwipers(root = document) {
    const containers = root.querySelectorAll(".js-collection-category__swiper");
    if (!containers.length) {
      return;
    }
    containers.forEach((container) => {
      if (!container.id) {
        return;
      }
      const existingInstance = container.swiper;
      if (existingInstance) {
        existingInstance.destroy(true, true);
      }
      const component = container.closest(".js-collection-category");
      const prevEl = component?.querySelector(".js-collection-category__button--prev");
      const nextEl = component?.querySelector(".js-collection-category__button--next");
      const activeIndex = getActiveSlideIndex(container);
      initSwiper(`#${container.id}`, {
        modules: [],
        slidesPerView: "auto",
        watchOverflow: true,
        initialSlide: activeIndex,
        pagination: false,
        autoplay: false,
        navigation: {
          prevEl: prevEl || void 0,
          nextEl: nextEl || void 0
        },
        on: {
          init(swiper) {
            if (activeIndex > 0) {
              swiper.slideTo(activeIndex, 0);
            }
          }
        }
      });
      container.dataset.swiperInitialized = "true";
    });
  }

  // src/js/modules/components/collection-slider-swiper.js
  function initCollectionSliderSwipers(root = document) {
    const containers = root.querySelectorAll(".js-collection-slider__swiper");
    if (!containers.length) {
      return;
    }
    containers.forEach((container) => {
      if (container.dataset.swiperInitialized === "true") {
        return;
      }
      if (!container.id) {
        return;
      }
      const slideCount = container.querySelectorAll(".swiper-slide").length;
      if (slideCount <= 1) {
        container.dataset.swiperInitialized = "true";
        return;
      }
      const autoplayEnabled = container.dataset.autoplay === "true";
      const slideSpeed = Number.parseInt(container.dataset.slideSpeed, 10);
      const autoplayDelay = autoplayEnabled && Number.isFinite(slideSpeed) ? slideSpeed : autoplayEnabled ? 5e3 : 0;
      const swiperOptions = {
        modules: [],
        slidesPerView: 1,
        loop: true,
        speed: 600,
        pagination: {
          el: container.querySelector(".s-collection-slider__pagination"),
          clickable: true
        }
      };
      if (autoplayEnabled && autoplayDelay > 0) {
        swiperOptions.autoplay = {
          delay: autoplayDelay,
          disableOnInteraction: false
        };
      }
      initSwiper(`#${container.id}`, swiperOptions);
      container.dataset.swiperInitialized = "true";
    });
  }

  // src/js/modules/components/customer-reviews-swiper.js
  var TABLET_MEDIA_QUERY = window.matchMedia(mediaQueryTb);
  function initCustomerReviewsSwipers(root = document) {
    const containers = root.querySelectorAll(".js-customer-reviews__swiper");
    if (!containers.length) {
      return;
    }
    containers.forEach((container) => {
      if (!container.id) {
        return;
      }
      const setup = () => {
        const existingInstance = container.swiper;
        if (TABLET_MEDIA_QUERY.matches) {
          if (existingInstance) {
            return;
          }
          initSwiper(`#${container.id}`, {
            modules: [],
            slidesPerView: "auto",
            watchOverflow: true
          });
          container.dataset.swiperInitialized = "true";
          return;
        }
        if (existingInstance) {
          existingInstance.destroy(true, true);
          delete container.dataset.swiperInitialized;
        }
      };
      setup();
      if (container.dataset.customerReviewsSwiperBound !== "true") {
        TABLET_MEDIA_QUERY.addEventListener("change", setup);
        container.dataset.customerReviewsSwiperBound = "true";
      }
    });
  }

  // src/js/modules/components/column-ranking-swiper.js
  var SP_MEDIA_QUERY = window.matchMedia(mediaQuerySp);
  function initColumnRankingSwipers(root = document) {
    const containers = root.querySelectorAll(".js-column-ranking__swiper");
    if (!containers.length) {
      return;
    }
    containers.forEach((container) => {
      if (!container.id) {
        return;
      }
      const setup = () => {
        const existingInstance = container.swiper;
        if (SP_MEDIA_QUERY.matches) {
          if (existingInstance) {
            existingInstance.update();
            return;
          }
          initSwiper(`#${container.id}`, {
            modules: [],
            slidesPerView: "auto",
            slidesPerGroup: 1,
            watchOverflow: true,
            spaceBetween: 0,
            pagination: false,
            autoplay: false
          });
          container.dataset.swiperInitialized = "true";
          return;
        }
        if (existingInstance) {
          existingInstance.destroy(true, true);
          delete container.dataset.swiperInitialized;
        }
      };
      setup();
      if (container.dataset.columnRankingSwiperBound !== "true") {
        SP_MEDIA_QUERY.addEventListener("change", setup);
        container.dataset.columnRankingSwiperBound = "true";
      }
    });
  }

  // src/js/modules/components/column-related-swiper.js
  var COLUMN_RELATED_SWIPER_SELECTOR = ".js-column-related__swiper";
  function initColumnRelatedSwipers(root = document) {
    const containers = root.querySelectorAll(COLUMN_RELATED_SWIPER_SELECTOR);
    if (!containers.length) {
      return;
    }
    containers.forEach((container) => {
      if (!container.id) {
        return;
      }
      const existingInstance = container.swiper;
      if (existingInstance) {
        existingInstance.destroy(true, true);
      }
      const slider = container.closest(".c-card-slider");
      const prevEl = slider?.querySelector(".c-card-slider__nav--prev");
      const nextEl = slider?.querySelector(".c-card-slider__nav--next");
      initSwiper(`#${container.id}`, {
        modules: [],
        slidesPerView: "auto",
        slidesPerGroup: 1,
        watchOverflow: true,
        spaceBetween: 0,
        pagination: false,
        autoplay: false,
        breakpoints: {
          [MIN_WIDTH_ABOVE_TB]: {
            slidesPerView: 3,
            slidesPerGroup: 1,
            spaceBetween: 0
          }
        },
        navigation: prevEl && nextEl ? {
          prevEl,
          nextEl,
          disabledClass: "is-disabled"
        } : false
      });
      container.dataset.swiperInitialized = "true";
    });
  }

  // src/js/modules/components/column-tags-swiper.js
  function getActiveSlideIndex2(container) {
    const slides = container.querySelectorAll(".swiper-slide");
    for (let index = 0; index < slides.length; index += 1) {
      if (slides[index].querySelector(".is-active")) {
        return index;
      }
    }
    return 0;
  }
  function initColumnTagsSwipers(root = document) {
    const containers = root.querySelectorAll(".js-column-tags__swiper");
    if (!containers.length) {
      return;
    }
    containers.forEach((container) => {
      if (!container.id) {
        return;
      }
      const existingInstance = container.swiper;
      if (existingInstance) {
        existingInstance.destroy(true, true);
      }
      const activeIndex = getActiveSlideIndex2(container);
      initSwiper(`#${container.id}`, {
        modules: [],
        slidesPerView: "auto",
        spaceBetween: 0,
        watchOverflow: true,
        initialSlide: activeIndex,
        pagination: false,
        autoplay: false,
        on: {
          init(swiper) {
            if (activeIndex > 0) {
              swiper.slideTo(activeIndex, 0);
            }
          }
        }
      });
      container.dataset.swiperInitialized = "true";
    });
  }

  // src/js/modules/components/product-media-swiper.js
  function initProductMediaSwipers(root = document) {
    const galleries = root.querySelectorAll(".js-product-media");
    if (!galleries.length) {
      return;
    }
    galleries.forEach((gallery) => {
      if (gallery.dataset.swiperInitialized === "true") {
        return;
      }
      const mainEl = gallery.querySelector(".js-product-media__main");
      if (!mainEl || !mainEl.id) {
        return;
      }
      const thumbsEl = gallery.querySelector(".js-product-media__thumbs");
      let thumbsInstance = null;
      if (thumbsEl && thumbsEl.id) {
        thumbsInstance = initSwiper(`#${thumbsEl.id}`, {
          modules: [],
          slidesPerView: "auto",
          spaceBetween: 6,
          // SP
          watchOverflow: true,
          slideToClickedSlide: true,
          breakpoints: {
            [MIN_WIDTH_ABOVE_SP]: {
              spaceBetween: 8
              // PC / TB
            }
          }
        });
      }
      const mainOptions = {
        modules: [Thumb],
        slidesPerView: 1,
        speed: 400,
        watchOverflow: true,
        navigation: {
          prevEl: gallery.querySelector(".js-product-media__prev"),
          nextEl: gallery.querySelector(".js-product-media__next")
        }
      };
      if (thumbsInstance) {
        mainOptions.thumbs = { swiper: thumbsInstance };
      }
      const mainInstance = initSwiper(`#${mainEl.id}`, mainOptions);
      setupZoom(gallery, mainInstance);
      gallery.dataset.swiperInitialized = "true";
    });
  }
  function setupZoom(gallery, mainInstance) {
    const zoomButton = gallery.querySelector(".js-product-media__zoom");
    if (!zoomButton || !mainInstance) {
      return;
    }
    const sectionId = gallery.dataset.section;
    zoomButton.addEventListener("click", () => {
      const modal = document.getElementById(`ProductModal-${sectionId}`);
      if (!modal || typeof modal.show !== "function") {
        return;
      }
      const activeSlide = mainInstance.slides[mainInstance.activeIndex];
      const mediaId = activeSlide ? activeSlide.dataset.mediaId : null;
      if (mediaId) {
        zoomButton.setAttribute("data-media-id", mediaId);
      }
      modal.show(zoomButton);
    });
  }

  // src/js/modules/components/product-sheet.js
  var OPEN_CLASS2 = "is-product-sheet-open";
  var sheetAbort = null;
  var lastFocusTrigger2 = null;
  function getSheetRoot(trigger) {
    const sectionRoot = trigger.closest("product-info, .s-product");
    return sectionRoot?.querySelector(".js-product-sheet") ?? null;
  }
  function closeProductSheet(sheetRoot) {
    if (!sheetRoot) {
      return;
    }
    sheetRoot.classList.remove(OPEN_CLASS2);
    sheetRoot.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove(OPEN_CLASS2);
    sheetRoot.querySelectorAll(".js-product-sheet__content").forEach((panel) => {
      panel.hidden = true;
    });
    if (lastFocusTrigger2 && document.body.contains(lastFocusTrigger2)) {
      lastFocusTrigger2.focus({ preventScroll: true });
    }
    lastFocusTrigger2 = null;
  }
  function openProductSheet(sheetRoot, trigger, panelId) {
    if (!sheetRoot || !panelId) {
      return;
    }
    document.querySelectorAll(".js-product-sheet.is-product-sheet-open").forEach((other) => {
      if (other !== sheetRoot) {
        closeProductSheet(other);
      }
    });
    const panel = sheetRoot.querySelector(`[data-product-sheet-panel="${panelId}"]`);
    if (!panel) {
      return;
    }
    const titleEl = sheetRoot.querySelector(".js-product-sheet__title");
    const panelTitle = panel.dataset.productSheetTitle ?? "";
    const dialog = sheetRoot.querySelector(".js-product-sheet__panel");
    lastFocusTrigger2 = trigger ?? null;
    sheetRoot.classList.add(OPEN_CLASS2);
    sheetRoot.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add(OPEN_CLASS2);
    sheetRoot.querySelectorAll(".js-product-sheet__content").forEach((item) => {
      item.hidden = item !== panel;
    });
    if (titleEl) {
      titleEl.textContent = panelTitle;
      const innerTitle = panel.querySelector('[id^="ProductSheetWrappingTitle-"]');
      if (panelTitle === "" && innerTitle) {
        dialog?.setAttribute("aria-labelledby", innerTitle.id);
      } else {
        dialog?.setAttribute("aria-labelledby", titleEl.id);
      }
    }
    trigger?.setAttribute("aria-expanded", "true");
    dialog?.focus({ preventScroll: true });
  }
  function bindProductSheetChrome(sheetRoot, signal) {
    sheetRoot.querySelector(".js-product-sheet__backdrop")?.addEventListener(
      "click",
      () => {
        closeProductSheet(sheetRoot);
      },
      { signal }
    );
    sheetRoot.querySelectorAll(".js-product-sheet__close").forEach((btn) => {
      btn.addEventListener(
        "click",
        () => {
          closeProductSheet(sheetRoot);
        },
        { signal }
      );
    });
  }
  function initProductSheets() {
    sheetAbort?.abort();
    sheetAbort = new AbortController();
    const { signal } = sheetAbort;
    document.querySelectorAll(".js-product-sheet").forEach((sheetRoot) => {
      sheetRoot.classList.remove(OPEN_CLASS2);
      sheetRoot.setAttribute("aria-hidden", "true");
      bindProductSheetChrome(sheetRoot, signal);
    });
    document.documentElement.classList.remove(OPEN_CLASS2);
    document.addEventListener(
      "click",
      (e) => {
        const trigger = e.target.closest("[data-js-product-sheet-target]");
        if (!trigger || trigger.disabled || trigger.closest(".visually-hidden")) {
          return;
        }
        const panelId = trigger.dataset.jsProductSheetTarget;
        if (!panelId || !/^[a-z0-9_-]+$/.test(panelId)) {
          return;
        }
        const sheetRoot = getSheetRoot(trigger);
        if (!sheetRoot) {
          return;
        }
        e.preventDefault();
        const isOpen = sheetRoot.classList.contains(OPEN_CLASS2);
        const activePanel = sheetRoot.querySelector(".js-product-sheet__content:not([hidden])");
        const isSamePanel = isOpen && activePanel?.dataset.productSheetPanel === panelId;
        if (isSamePanel) {
          closeProductSheet(sheetRoot);
          trigger.setAttribute("aria-expanded", "false");
          return;
        }
        document.querySelectorAll("[data-js-product-sheet-target]").forEach((btn) => {
          btn.setAttribute("aria-expanded", "false");
        });
        openProductSheet(sheetRoot, trigger, panelId);
      },
      { signal }
    );
    document.addEventListener(
      "keydown",
      (e) => {
        if (e.key !== "Escape") {
          return;
        }
        const openSheet = document.querySelector(".js-product-sheet.is-product-sheet-open");
        if (!openSheet) {
          return;
        }
        closeProductSheet(openSheet);
        document.querySelectorAll("[data-js-product-sheet-target]").forEach((btn) => {
          btn.setAttribute("aria-expanded", "false");
        });
      },
      { signal }
    );
  }

  // src/js/modules/components/product-nekopos.js
  var VARIANT_CHANGE_EVENT = globalThis.PUB_SUB_EVENTS?.variantChange ?? "variant-change";
  var variantChangeUnsubscriber = null;
  function readVariantWeightGrams(variant, nekoposRoot) {
    if (variant) {
      const parsed = Number(variant.weight);
      if (Number.isFinite(parsed)) {
        return parsed;
      }
    }
    const fallback = Number.parseFloat(nekoposRoot?.dataset.variantWeightG);
    return Number.isFinite(fallback) ? fallback : 0;
  }
  function isNekoposEligible(variant, maxWeightG, nekoposRoot) {
    const weightG = readVariantWeightGrams(variant, nekoposRoot);
    return weightG < maxWeightG;
  }
  function getSelectedVariant(productInfo) {
    const raw = productInfo.querySelector("variant-selects [data-selected-variant]")?.textContent?.trim();
    if (!raw) {
      return null;
    }
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }
  function findProductInfo(sectionId) {
    if (!sectionId) {
      return null;
    }
    return document.querySelector(`product-info[data-section="${sectionId}"]`) ?? document.getElementById(`MainProduct-${sectionId}`);
  }
  function updateNekoposVisibility(productInfo, variant) {
    const nekoposRoot = productInfo.querySelector(".js-product-nekopos");
    if (!nekoposRoot) {
      return;
    }
    const maxWeightG = Number.parseFloat(nekoposRoot.dataset.nekoposMaxWeightG) || 1e3;
    const resolvedVariant = variant ?? getSelectedVariant(productInfo);
    const eligible = isNekoposEligible(resolvedVariant, maxWeightG, nekoposRoot);
    if (resolvedVariant && Number.isFinite(Number(resolvedVariant.weight))) {
      nekoposRoot.dataset.variantWeightG = String(readVariantWeightGrams(resolvedVariant, nekoposRoot));
    }
    nekoposRoot.classList.toggle("visually-hidden", !eligible);
    const trigger = nekoposRoot.querySelector('[data-js-product-sheet-target="nekopos"]');
    if (trigger) {
      trigger.disabled = !eligible;
      if (!eligible) {
        trigger.setAttribute("aria-expanded", "false");
      }
    }
    if (!eligible) {
      const sheetRoot = productInfo.querySelector(".js-product-sheet");
      const activePanel = sheetRoot?.querySelector(".js-product-sheet__content:not([hidden])");
      if (activePanel?.dataset.productSheetPanel === "nekopos") {
        closeProductSheet(sheetRoot);
      }
    }
  }
  function syncProductInfoNekopos(productInfo) {
    updateNekoposVisibility(productInfo, getSelectedVariant(productInfo));
  }
  function bindVariantChangeSync() {
    const subscribeFn = globalThis.subscribe;
    if (variantChangeUnsubscriber || typeof subscribeFn !== "function") {
      return;
    }
    variantChangeUnsubscriber = subscribeFn(VARIANT_CHANGE_EVENT, (event2) => {
      const sectionId = event2?.data?.sectionId;
      const variant = event2?.data?.variant;
      const productInfo = findProductInfo(sectionId);
      if (!productInfo) {
        return;
      }
      updateNekoposVisibility(productInfo, variant);
    });
  }
  function initProductNekopos(scope = document) {
    bindVariantChangeSync();
    scope.querySelectorAll("product-info").forEach((productInfo) => {
      if (!productInfo.querySelector(".js-product-nekopos")) {
        return;
      }
      syncProductInfoNekopos(productInfo);
    });
  }

  // src/js/modules/components/product-content-navi.js
  var NAV_SELECTOR = ".js-product-content-navi";
  var LINK_SELECTOR = 'a.js-product-content-navi-link[href^="#"]';
  var CONTENT_ROOT_SELECTOR = ".js-product-content";
  var FAQ_BODY_SELECTOR = ".js-product-content-faq-body";
  var PAIR_REBUILD_DEBOUNCE_MS = 80;
  var ACTIVE_LINE_BOUNDARY_EPSILON_PX = 4;
  var CLICK_RESYNC_DELAY_MS = 550;
  var dispose = null;
  function isParticipatingInLayout(el) {
    if (!el || !(el instanceof Element)) {
      return false;
    }
    if (el.hasAttribute("hidden")) {
      return false;
    }
    if (typeof el.checkVisibility === "function") {
      return el.checkVisibility({ checkOpacity: false, checkVisibilityCSS: true });
    }
    const style = window.getComputedStyle(el);
    if (style.display === "none" || style.visibility === "hidden") {
      return false;
    }
    const { width, height } = el.getBoundingClientRect();
    return width > 0 || height > 0;
  }
  function getActiveLineY() {
    return window.innerWidth <= BREAKPOINT_TB ? readProductContentAnchorOffsetPx() : readProductContentNaviHeightPx();
  }
  function faqBodyHasContent(faqBody) {
    if (!faqBody) {
      return false;
    }
    const childElements = [...faqBody.children].filter((child) => isParticipatingInLayout(child));
    if (childElements.length > 0) {
      return true;
    }
    return faqBody.textContent.replace(/\s+/g, "").length > 0 && isParticipatingInLayout(faqBody);
  }
  function syncFaqVisibility(contentRoot, nav) {
    const faqSection = contentRoot.querySelector("#s-product__content-faq");
    const faqLink = nav.querySelector('[href="#s-product__content-faq"]');
    const faqBody = contentRoot.querySelector(FAQ_BODY_SELECTOR);
    if (!faqSection || !faqLink || !faqBody) {
      return;
    }
    const hasContent = faqBodyHasContent(faqBody);
    faqSection.hidden = !hasContent;
    faqLink.hidden = !hasContent;
  }
  function buildLinkSectionPairs(anchorLinks) {
    const pairs = [];
    for (const link of anchorLinks) {
      if (!isParticipatingInLayout(link)) {
        continue;
      }
      const href = link.getAttribute("href");
      const id = href?.startsWith("#") ? decodeURIComponent(href.slice(1)) : "";
      const section = id ? document.getElementById(id) : null;
      if (section && isParticipatingInLayout(section)) {
        pairs.push({ link, section });
      }
    }
    return pairs;
  }
  function getSectionRects(pairs) {
    return pairs.map(({ section }) => section.getBoundingClientRect());
  }
  function resolveActivePairIndex(pairs, lineY) {
    if (pairs.length === 0) {
      return null;
    }
    const rects = getSectionRects(pairs);
    const firstTop = rects[0].top;
    const lastBottom = rects[rects.length - 1].bottom;
    if (firstTop > lineY + ACTIVE_LINE_BOUNDARY_EPSILON_PX) {
      return null;
    }
    if (lastBottom <= lineY) {
      return pairs.length - 1;
    }
    for (let i = 0; i < pairs.length; i++) {
      const rect = rects[i];
      if (rect.top <= lineY + ACTIVE_LINE_BOUNDARY_EPSILON_PX && rect.bottom > lineY) {
        if (i + 1 < pairs.length) {
          const nextTop = rects[i + 1].top;
          if (nextTop > lineY && nextTop - lineY <= ACTIVE_LINE_BOUNDARY_EPSILON_PX) {
            return i + 1;
          }
        }
        return i;
      }
    }
    for (let i = 0; i < pairs.length - 1; i++) {
      const currentBottom = rects[i].bottom;
      const nextTop = rects[i + 1].top;
      if (currentBottom <= lineY && nextTop > lineY) {
        const distToNext = nextTop - lineY;
        const distFromPrev = lineY - currentBottom;
        return distToNext <= distFromPrev ? i + 1 : i;
      }
    }
    let index = 0;
    for (let i = 0; i < pairs.length; i++) {
      if (rects[i].top <= lineY + ACTIVE_LINE_BOUNDARY_EPSILON_PX) {
        index = i;
      }
    }
    return index;
  }
  function clearActiveOnAllLinks(anchorLinks) {
    anchorLinks.forEach((link) => link.classList.remove("is-active"));
  }
  function applyActiveClass(anchorLinks, pairs, activeIndex) {
    clearActiveOnAllLinks(anchorLinks);
    if (activeIndex === null) {
      return;
    }
    pairs[activeIndex]?.link.classList.add("is-active");
  }
  function syncSpyUi(anchorLinks, pairs) {
    const activeIndex = resolveActivePairIndex(pairs, getActiveLineY());
    applyActiveClass(anchorLinks, pairs, activeIndex);
  }
  function initProductContentNaviScrollSpy() {
    dispose?.();
    dispose = null;
    const nav = document.querySelector(NAV_SELECTOR);
    const contentRoot = document.querySelector(CONTENT_ROOT_SELECTOR);
    if (!nav || !contentRoot) {
      return;
    }
    const anchorLinks = [...nav.querySelectorAll(LINK_SELECTOR)];
    const state = { pairs: [] };
    const ac = new AbortController();
    const { signal } = ac;
    let rafId = 0;
    let debounceTimerId = 0;
    let mutationObserver = null;
    const rebuildAndSync = () => {
      syncFaqVisibility(contentRoot, nav);
      state.pairs = buildLinkSectionPairs(anchorLinks);
      syncSpyUi(anchorLinks, state.pairs);
    };
    const scheduleSync = () => {
      if (rafId) {
        return;
      }
      rafId = requestAnimationFrame(() => {
        rafId = 0;
        syncSpyUi(anchorLinks, state.pairs);
      });
    };
    const schedulePairRebuild = () => {
      if (debounceTimerId) {
        clearTimeout(debounceTimerId);
      }
      debounceTimerId = setTimeout(() => {
        debounceTimerId = 0;
        rebuildAndSync();
      }, PAIR_REBUILD_DEBOUNCE_MS);
    };
    if (typeof MutationObserver !== "undefined") {
      mutationObserver = new MutationObserver(schedulePairRebuild);
      mutationObserver.observe(contentRoot, { childList: true, subtree: true, attributes: true, attributeFilter: ["hidden", "style", "class"] });
    }
    let clickResyncTimerId = 0;
    let pendingClickLink = null;
    const syncSpyUiAfterClick = () => {
      const lineY = getActiveLineY();
      let activeIndex = resolveActivePairIndex(state.pairs, lineY);
      if (activeIndex === null && pendingClickLink) {
        const clickedPairIndex = state.pairs.findIndex(({ link }) => link === pendingClickLink);
        if (clickedPairIndex >= 0) {
          const { top } = state.pairs[clickedPairIndex].section.getBoundingClientRect();
          if (top <= lineY + ACTIVE_LINE_BOUNDARY_EPSILON_PX) {
            activeIndex = clickedPairIndex;
          }
        }
      }
      applyActiveClass(anchorLinks, state.pairs, activeIndex);
      pendingClickLink = null;
    };
    const scheduleClickResync = (clickedLink) => {
      pendingClickLink = clickedLink;
      if (clickResyncTimerId) {
        clearTimeout(clickResyncTimerId);
      }
      clickResyncTimerId = setTimeout(() => {
        clickResyncTimerId = 0;
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            syncSpyUiAfterClick();
          });
        });
      }, CLICK_RESYNC_DELAY_MS);
    };
    nav.addEventListener(
      "click",
      (event2) => {
        const link = event2.target.closest(LINK_SELECTOR);
        if (!link || !anchorLinks.includes(link)) {
          return;
        }
        clearActiveOnAllLinks(anchorLinks);
        link.classList.add("is-active");
        scheduleClickResync(link);
      },
      { signal }
    );
    rebuildAndSync();
    window.addEventListener("scroll", scheduleSync, { passive: true, signal });
    window.addEventListener("resize", schedulePairRebuild, { signal });
    dispose = () => {
      ac.abort();
      mutationObserver?.disconnect();
      if (debounceTimerId) {
        clearTimeout(debounceTimerId);
      }
      if (clickResyncTimerId) {
        clearTimeout(clickResyncTimerId);
      }
    };
  }

  // src/js/modules/components/sticky-buy.js
  var BAR_SELECTOR = ".js-sticky-buy";
  var RESIZE_DEBOUNCE_MS = 100;
  function updateBarHeight(bar) {
    if (!bar) {
      return;
    }
    const height = Math.ceil(bar.getBoundingClientRect().height);
    document.documentElement.style.setProperty("--sticky-buy-height", `${height}px`);
  }
  function normalizeQuantityValue(referenceInput, rawValue) {
    const min = parseInt(referenceInput.min, 10) || parseInt(referenceInput.dataset.min, 10) || 1;
    const max = referenceInput.max ? parseInt(referenceInput.max, 10) : null;
    const step = parseInt(referenceInput.step, 10) || 1;
    let value = parseInt(String(rawValue), 10);
    if (!Number.isFinite(value)) {
      value = min;
    }
    value = Math.max(min, value);
    if (max !== null) {
      value = Math.min(max, value);
    }
    if (step > 1) {
      const offset = value - min;
      value = min + Math.round(offset / step) * step;
      if (max !== null) {
        value = Math.min(value, max);
      }
    }
    return String(value);
  }
  function syncStickyInputAttributes(mainInput, stickyInput) {
    stickyInput.min = mainInput.min;
    stickyInput.step = mainInput.step;
    stickyInput.disabled = mainInput.disabled;
    if (mainInput.max) {
      stickyInput.max = mainInput.max;
    } else {
      stickyInput.removeAttribute("max");
    }
  }
  function syncQuantityDisplay(productInfo, sectionId, bar) {
    const mainInput = productInfo.querySelector(`#Quantity-${sectionId}`);
    const stickyInput = bar.querySelector(".js-sticky-buy__qty-input");
    if (!mainInput || !stickyInput) {
      return;
    }
    syncStickyInputAttributes(mainInput, stickyInput);
    if (stickyInput === document.activeElement) {
      return;
    }
    stickyInput.value = mainInput.value;
  }
  function syncMainFromSticky(productInfo, sectionId, bar) {
    const mainInput = productInfo.querySelector(`#Quantity-${sectionId}`);
    const stickyInput = bar.querySelector(".js-sticky-buy__qty-input");
    if (!mainInput || !stickyInput || stickyInput.disabled) {
      return;
    }
    const normalized = normalizeQuantityValue(mainInput, stickyInput.value);
    stickyInput.value = normalized;
    if (mainInput.value !== normalized) {
      mainInput.value = normalized;
      mainInput.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }
  function isDisplayNone(element) {
    return getComputedStyle(element).display === "none";
  }
  function syncSubmitState(productInfo, sectionId, bar) {
    const mainSubmit = productInfo.querySelector(`#ProductSubmitButton-${sectionId}`);
    const cartBtn = bar.querySelector(".js-sticky-buy__cart");
    const labelEl = bar.querySelector(".js-sticky-buy__cart-label");
    if (!mainSubmit || !cartBtn) {
      return;
    }
    const wasBuyHidden = cartBtn.classList.contains("is-buy-hidden");
    const isBuyHidden = isDisplayNone(mainSubmit);
    cartBtn.classList.toggle("is-buy-hidden", isBuyHidden);
    if (wasBuyHidden !== isBuyHidden) {
      updateBarHeight(bar);
    }
    cartBtn.disabled = mainSubmit.disabled;
    cartBtn.classList.toggle("is-disabled", mainSubmit.disabled);
    cartBtn.classList.toggle("loading", mainSubmit.classList.contains("loading"));
    const spinner = cartBtn.querySelector(".loading__spinner");
    if (mainSubmit.classList.contains("loading")) {
      spinner?.classList.remove("hidden");
    } else {
      spinner?.classList.add("hidden");
    }
    const ariaDisabled = mainSubmit.getAttribute("aria-disabled");
    if (ariaDisabled) {
      cartBtn.setAttribute("aria-disabled", ariaDisabled);
    } else {
      cartBtn.removeAttribute("aria-disabled");
    }
    const mainLabel = mainSubmit.querySelector("span:first-child");
    if (labelEl && mainLabel) {
      labelEl.textContent = mainLabel.textContent.trim();
    }
    const ariaLabel = mainLabel?.textContent?.trim();
    if (ariaLabel) {
      cartBtn.setAttribute("aria-label", ariaLabel);
    }
  }
  function bindStickyBuy(bar) {
    if (bar.dataset.stickyBuyBound === "true") {
      return;
    }
    const sectionId = bar.dataset.sectionId;
    const productInfo = bar.closest("product-info");
    if (!sectionId || !productInfo) {
      return;
    }
    bar.dataset.stickyBuyBound = "true";
    const getMainQtyButtons = () => {
      const quantityForm = productInfo.querySelector(`#Quantity-Form-${sectionId}`);
      return {
        minus: quantityForm?.querySelector('button[name="minus"]') ?? null,
        plus: quantityForm?.querySelector('button[name="plus"]') ?? null,
        input: productInfo.querySelector(`#Quantity-${sectionId}`) ?? null
      };
    };
    const onQtyMinus = () => {
      getMainQtyButtons().minus?.click();
      syncQuantityDisplay(productInfo, sectionId, bar);
    };
    const onQtyPlus = () => {
      getMainQtyButtons().plus?.click();
      syncQuantityDisplay(productInfo, sectionId, bar);
    };
    const onMainQtyChange = (event2) => {
      if (event2.target.id !== `Quantity-${sectionId}`) {
        return;
      }
      syncQuantityDisplay(productInfo, sectionId, bar);
    };
    const onStickyQtyCommit = () => {
      syncMainFromSticky(productInfo, sectionId, bar);
    };
    const onCartClick = () => {
      syncMainFromSticky(productInfo, sectionId, bar);
      const mainSubmit2 = productInfo.querySelector(`#ProductSubmitButton-${sectionId}`);
      if (mainSubmit2 && !mainSubmit2.disabled && !isDisplayNone(mainSubmit2)) {
        mainSubmit2.click();
      }
    };
    bar.querySelector(".js-sticky-buy__qty-minus")?.addEventListener("click", onQtyMinus);
    bar.querySelector(".js-sticky-buy__qty-plus")?.addEventListener("click", onQtyPlus);
    productInfo.addEventListener("input", onMainQtyChange);
    productInfo.addEventListener("change", onMainQtyChange);
    const stickyInput = bar.querySelector(".js-sticky-buy__qty-input");
    stickyInput?.addEventListener("change", onStickyQtyCommit);
    stickyInput?.addEventListener("blur", onStickyQtyCommit);
    bar.querySelector(".js-sticky-buy__cart")?.addEventListener("click", onCartClick);
    const mainSubmit = productInfo.querySelector(`#ProductSubmitButton-${sectionId}`);
    if (mainSubmit) {
      const observer = new MutationObserver(() => {
        syncSubmitState(productInfo, sectionId, bar);
        syncQuantityDisplay(productInfo, sectionId, bar);
      });
      observer.observe(mainSubmit, {
        attributes: true,
        attributeFilter: ["disabled", "aria-disabled", "class", "style"],
        childList: true,
        subtree: true
      });
    }
    productInfo.addEventListener("product-info:loaded", () => {
      syncQuantityDisplay(productInfo, sectionId, bar);
      syncSubmitState(productInfo, sectionId, bar);
      updateBarHeight(bar);
    });
    syncQuantityDisplay(productInfo, sectionId, bar);
    syncSubmitState(productInfo, sectionId, bar);
    updateBarHeight(bar);
  }
  var resizeTimerId = 0;
  function updateAllBarHeights(root = document) {
    root.querySelectorAll(BAR_SELECTOR).forEach((bar) => {
      updateBarHeight(bar);
    });
  }
  var resizeListenerBound = false;
  function bindResizeListener() {
    if (resizeListenerBound) {
      return;
    }
    resizeListenerBound = true;
    window.addEventListener("resize", () => {
      if (resizeTimerId) {
        window.clearTimeout(resizeTimerId);
      }
      resizeTimerId = window.setTimeout(() => {
        updateAllBarHeights();
      }, RESIZE_DEBOUNCE_MS);
    });
  }
  function initStickyBuy(root = document) {
    root.querySelectorAll(BAR_SELECTOR).forEach((bar) => {
      bindStickyBuy(bar);
    });
    bindResizeListener();
  }
  function onStickyBuyUpdated(root = document) {
    root.querySelectorAll(BAR_SELECTOR).forEach((bar) => {
      bar.dataset.stickyBuyBound = "false";
      bindStickyBuy(bar);
    });
    updateAllBarHeights(root);
  }

  // src/js/modules/components/card-form.js
  var CART_SELECTOR = ".c-card-form__cart";
  var SUBMIT_SELECTOR = ".c-card-form__submit";
  var bindings = /* @__PURE__ */ new WeakMap();
  var treeObserverBound = false;
  function isDisplayNone2(element) {
    return getComputedStyle(element).display === "none";
  }
  function collectCarts(node, callback) {
    if (!(node instanceof Element)) {
      return;
    }
    if (node.matches(CART_SELECTOR)) {
      callback(node);
    }
    node.querySelectorAll(CART_SELECTOR).forEach(callback);
  }
  function unbindCardForm(cart) {
    const binding = bindings.get(cart);
    if (!binding) {
      return;
    }
    binding.disconnect();
    bindings.delete(cart);
    delete cart.dataset.buyHiddenBound;
  }
  function bindCardForm(cart) {
    if (bindings.has(cart) || cart.dataset.buyHiddenBound === "true") {
      return;
    }
    cart.dataset.buyHiddenBound = "true";
    let submitObserver = null;
    let observedSubmit = null;
    const sync = () => {
      const submit = cart.querySelector(SUBMIT_SELECTOR);
      if (submit !== observedSubmit) {
        submitObserver?.disconnect();
        observedSubmit = submit || null;
        submitObserver = null;
        if (submit) {
          submitObserver = new MutationObserver(sync);
          submitObserver.observe(submit, {
            attributes: true,
            attributeFilter: ["class", "style"]
          });
        }
      }
      if (!submit) {
        cart.classList.remove("is-buy-hidden");
        return;
      }
      cart.classList.toggle("is-buy-hidden", isDisplayNone2(submit));
    };
    const cartObserver = new MutationObserver(sync);
    cartObserver.observe(cart, { childList: true, subtree: true });
    bindings.set(cart, {
      disconnect: () => {
        submitObserver?.disconnect();
        cartObserver.disconnect();
      }
    });
    sync();
  }
  function bindTreeObserver() {
    if (treeObserverBound || !document.body) {
      return;
    }
    treeObserverBound = true;
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => {
          collectCarts(node, bindCardForm);
        });
        mutation.removedNodes.forEach((node) => {
          collectCarts(node, unbindCardForm);
        });
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
  function initCardForm(root = document) {
    if (root === document) {
      document.querySelectorAll(CART_SELECTOR).forEach(bindCardForm);
    } else if (root instanceof Element) {
      collectCarts(root, bindCardForm);
    }
    bindTreeObserver();
  }

  // src/js/modules/components/facets-drawer/url.js
  var ALLERGEN_FILTER_PARAM = "filter.p.m.custom.allergens_absent";
  function hasUrlFilters() {
    return [...new URLSearchParams(window.location.search).keys()].some((key) => key.startsWith("filter."));
  }
  function getFacetsSectionId() {
    return document.getElementById("product-grid")?.dataset.id || document.getElementById("main-collection-filters")?.dataset.id || document.getElementById("main-search-filters")?.dataset.id || null;
  }
  function buildSectionUrl(sectionId, { excludeFilterParams = [], excludeAllFilters = false } = {}) {
    const currentUrl = new URL(window.location.href);
    const params = new URLSearchParams();
    params.set("section_id", sectionId);
    currentUrl.searchParams.forEach((value, key) => {
      if (excludeAllFilters && key.startsWith("filter.")) {
        return;
      }
      if (excludeFilterParams.includes(key)) {
        return;
      }
      params.append(key, value);
    });
    return `${currentUrl.pathname}?${params.toString()}`;
  }
  function buildHydrateSectionUrls(sectionId) {
    const urls = [buildSectionUrl(sectionId, { excludeFilterParams: [ALLERGEN_FILTER_PARAM] })];
    if (hasUrlFilters()) {
      urls.push(buildSectionUrl(sectionId, { excludeAllFilters: true }));
    }
    return [...new Set(urls)];
  }
  function buildFilterRemoveUrl(paramName) {
    const currentUrl = new URL(window.location.href);
    const params = new URLSearchParams();
    currentUrl.searchParams.forEach((value, key) => {
      if (key !== paramName) {
        params.append(key, value);
      }
    });
    const query = params.toString();
    return `${currentUrl.pathname}${query ? `?${query}` : ""}`;
  }
  function buildAllFiltersRemoveUrl() {
    const currentUrl = new URL(window.location.href);
    const params = new URLSearchParams();
    currentUrl.searchParams.forEach((value, key) => {
      if (!key.startsWith("filter.")) {
        params.append(key, value);
      }
    });
    const query = params.toString();
    return `${currentUrl.pathname}${query ? `?${query}` : ""}`;
  }

  // src/js/modules/components/facets-drawer/clear.js
  function getSectionParamName(section) {
    return section.querySelector("[data-filter-grid]")?.dataset.filterGrid || section.querySelector("input.mobile-facets__checkbox")?.name || null;
  }
  function applyUrlFiltersToDrawer(wrapper) {
    const currentUrl = new URL(window.location.href);
    const filterKeys = /* @__PURE__ */ new Set();
    currentUrl.searchParams.forEach((_, key) => {
      if (key.startsWith("filter.")) {
        filterKeys.add(key);
      }
    });
    filterKeys.forEach((key) => {
      currentUrl.searchParams.getAll(key).forEach((value) => {
        const selector = `input.mobile-facets__checkbox[name="${CSS.escape(key)}"][value="${CSS.escape(value)}"]`;
        const input = wrapper.querySelector(selector);
        if (input) {
          input.checked = true;
        }
      });
    });
  }
  function syncDrawerClearLinks(wrapper) {
    wrapper.querySelectorAll(".js-filter__section").forEach((section) => {
      const paramName = getSectionParamName(section);
      if (!paramName) {
        return;
      }
      const clearLink = section.querySelector("facet-remove a");
      if (clearLink) {
        clearLink.href = buildFilterRemoveUrl(paramName);
      }
    });
    const footerClearLink = document.querySelector(".c-facets-drawer__footer-clear a");
    if (footerClearLink) {
      footerClearLink.href = buildAllFiltersRemoveUrl();
    }
  }
  function syncDrawerClearVisibility(wrapper) {
    let anyChecked = false;
    wrapper.querySelectorAll(".js-filter__section").forEach((section) => {
      const sectionChecked = section.querySelectorAll("input.mobile-facets__checkbox:checked").length;
      anyChecked = anyChecked || sectionChecked > 0;
      const clearHost = section.querySelector(".c-filter-allergen__clear, .c-filter-list__clear, .c-filter-chip__clear");
      if (clearHost) {
        clearHost.classList.toggle("hidden", sectionChecked === 0);
      }
    });
    const footerClear = document.querySelector(".c-facets-drawer__footer-clear");
    if (footerClear) {
      footerClear.classList.toggle("hidden", !anyChecked);
    }
  }

  // src/js/modules/components/facets-drawer/ui.js
  function closeFacetsDrawer(trigger) {
    const summary = trigger.closest("menu-drawer")?.querySelector("details summary");
    if (!summary) {
      return;
    }
    summary.click();
  }
  function initFacetsDrawerClose(root = document) {
    root.querySelectorAll(".js-facets-drawer-close").forEach((button) => {
      if (button.dataset.facetsDrawerCloseBound === "true") {
        return;
      }
      button.dataset.facetsDrawerCloseBound = "true";
      button.addEventListener("click", () => closeFacetsDrawer(button));
    });
  }
  function syncDrawerProductCountFromGrid() {
    const target = document.getElementById("ProductCountDrawer");
    if (!target) {
      return;
    }
    const gridContainer = document.getElementById("ProductGridContainer");
    const dataCount = gridContainer?.dataset.productsCount;
    if (dataCount !== void 0 && dataCount !== "") {
      target.textContent = dataCount;
      return;
    }
    const source = document.getElementById("ProductCount") || document.getElementById("ProductCountDesktop");
    if (source) {
      const countMatch = source.textContent.match(/\d+/);
      if (countMatch) {
        target.textContent = countMatch[0];
        return;
      }
    }
    if (gridContainer?.querySelector(".collection--empty")) {
      target.textContent = "0";
    }
  }
  function syncFacetsDrawerSortFieldText(select) {
    const textEl = select.closest(".js-facets-drawer__sort-field")?.querySelector(".js-facets-drawer__sort-field-text");
    if (!textEl) {
      return;
    }
    const option = select.options[select.selectedIndex];
    textEl.textContent = option?.text?.trim() ?? "";
  }
  function initFacetsDrawerSortFieldText(root = document) {
    root.querySelectorAll(".js-facets-drawer__sort-field-select").forEach((select) => {
      syncFacetsDrawerSortFieldText(select);
      if (select.dataset.facetsDrawerSortTextBound === "true") {
        return;
      }
      select.dataset.facetsDrawerSortTextBound = "true";
      select.addEventListener("change", () => syncFacetsDrawerSortFieldText(select));
    });
  }
  function initFacetsSelectAll(root = document) {
    root.querySelectorAll(".js-facets-select-all").forEach((button) => {
      if (button.dataset.facetsSelectAllBound === "true") {
        return;
      }
      button.dataset.facetsSelectAllBound = "true";
      button.addEventListener("click", () => {
        const param = button.dataset.filterSection;
        const grid = param ? root.querySelector(`[data-filter-grid="${param}"]`) : button.closest(".js-filter-allergen")?.querySelector("[data-filter-grid]");
        if (!grid) {
          return;
        }
        grid.querySelectorAll("input.mobile-facets__checkbox:not(:disabled)").forEach((input) => {
          if (!input.checked) {
            input.checked = true;
            input.dispatchEvent(new Event("input", { bubbles: true }));
          }
        });
      });
    });
  }
  function initFacetsDrawerAccordions(root = document) {
    const wrapper = root.id === "FacetsWrapperMobile" ? root : root.getElementById?.("FacetsWrapperMobile") ?? (root === document ? document.getElementById("FacetsWrapperMobile") : null);
    if (!wrapper) {
      return;
    }
    initAccordions(".js-accordion", wrapper);
  }

  // src/js/modules/components/facets-drawer/hydrate.js
  var HYDRATE_LOADING_MARKUP = '<div class="c-facets-drawer__empty-state js-facets-drawer__hydrate" data-section-id="{{sectionId}}"><p class="c-facets-drawer__empty">\u7D5E\u308A\u8FBC\u307F\u6761\u4EF6\u3092\u8AAD\u307F\u8FBC\u307F\u4E2D\u2026</p></div>';
  var HYDRATE_EMPTY_MARKUP = '<p class="c-facets-drawer__empty">\u7D5E\u308A\u8FBC\u307F\u6761\u4EF6\u306B\u4E00\u81F4\u3059\u308B\u5546\u54C1\u304C\u3042\u308A\u307E\u305B\u3093\u3002</p>';
  function createHydrateLoadingMarkup(sectionId) {
    return HYDRATE_LOADING_MARKUP.replace("{{sectionId}}", sectionId);
  }
  async function fetchHydratedDrawerMarkup(sectionId) {
    for (const url of buildHydrateSectionUrls(sectionId)) {
      const response = await fetch(url);
      if (!response.ok) {
        continue;
      }
      const parsedHTML = new DOMParser().parseFromString(await response.text(), "text/html");
      const fetchedWrapper = parsedHTML.getElementById("FacetsWrapperMobile");
      if (fetchedWrapper?.querySelector(".js-filter")) {
        return fetchedWrapper.innerHTML;
      }
    }
    return null;
  }
  function ensureFacetsDrawerHydration(root = document) {
    if (!hasUrlFilters()) {
      return;
    }
    const wrapper = document.getElementById("FacetsWrapperMobile");
    if (!wrapper || wrapper.querySelector(".js-filter")) {
      return;
    }
    if (!wrapper.querySelector(".js-facets-drawer__hydrate")) {
      const sectionId = getFacetsSectionId();
      if (!sectionId) {
        return;
      }
      wrapper.innerHTML = createHydrateLoadingMarkup(sectionId);
    }
    hydrateFacetsDrawerFilters(root);
  }
  async function hydrateFacetsDrawerFilters(root = document) {
    const hydrateTarget = root.querySelector(".js-facets-drawer__hydrate");
    if (!hydrateTarget || hydrateTarget.dataset.hydrated === "true") {
      return;
    }
    const sectionId = hydrateTarget.dataset.sectionId;
    const wrapper = document.getElementById("FacetsWrapperMobile");
    if (!sectionId || !wrapper) {
      return;
    }
    hydrateTarget.dataset.hydrated = "true";
    try {
      const fetchedMarkup = await fetchHydratedDrawerMarkup(sectionId);
      if (!fetchedMarkup) {
        hydrateTarget.innerHTML = HYDRATE_EMPTY_MARKUP;
        return;
      }
      wrapper.innerHTML = fetchedMarkup;
      wrapper.dataset.facetsHydrated = "true";
      applyUrlFiltersToDrawer(wrapper);
      syncDrawerClearLinks(wrapper);
      syncDrawerClearVisibility(wrapper);
      syncDrawerProductCountFromGrid();
      initFacetsDrawerClose(wrapper);
      initFacetsDrawerSortFieldText(wrapper);
      initFacetsSelectAll(wrapper);
      initFacetsDrawerAccordions(wrapper);
    } catch {
      hydrateTarget.innerHTML = HYDRATE_EMPTY_MARKUP;
    }
  }
  function syncHydratedDrawerState() {
    const wrapper = document.getElementById("FacetsWrapperMobile");
    if (!wrapper || wrapper.dataset.facetsHydrated !== "true") {
      return;
    }
    syncDrawerClearLinks(wrapper);
    syncDrawerClearVisibility(wrapper);
    syncDrawerProductCountFromGrid();
  }

  // src/js/modules/components/facets-drawer/index.js
  function initFacetsDrawer(root = document) {
    initFacetsDrawerClose(root);
    initFacetsDrawerSortFieldText(root);
    initFacetsSelectAll(root);
    ensureFacetsDrawerHydration(root);
    syncHydratedDrawerState();
    initFacetsDrawerAccordions(root);
  }
  function onFacetsDrawerUpdated() {
    initFacetsDrawerClose(document);
    initFacetsDrawerSortFieldText(document);
    initFacetsSelectAll(document);
    ensureFacetsDrawerHydration(document);
    syncHydratedDrawerState();
    initFacetsDrawerAccordions(document);
  }

  // src/js/modules/components/newsletter-customer-post.js
  var PROMO_FORM_PREFIX = "SiteMenuPromoNewsletter-";
  function prefersReducedMotion3() {
    return window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches ?? false;
  }
  function scrollToFeedback(el) {
    const behavior = prefersReducedMotion3() ? "auto" : "smooth";
    el.scrollIntoView({ behavior, block: "center", inline: "nearest" });
  }
  function tryFocusFeedback(el) {
    if (typeof el.focus !== "function") {
      return;
    }
    if (!el.hasAttribute("tabindex")) {
      return;
    }
    try {
      el.focus({ preventScroll: true });
    } catch {
      el.focus();
    }
  }
  function decodeHashFragment(rawHash) {
    if (!rawHash) {
      return "";
    }
    try {
      return decodeURIComponent(rawHash);
    } catch {
      return rawHash;
    }
  }
  function promoSuffixLooksMalformed(suffix) {
    return !suffix || suffix.includes("{{") || suffix.includes("}}") || suffix.includes("sm.id");
  }
  function resolvePostedFeedbackEl() {
    const rawHash = location.hash.replace(/^#/, "");
    const hash = decodeHashFragment(rawHash);
    const posted = new URLSearchParams(location.search).get("customer_posted") === "true";
    if (hash.startsWith(PROMO_FORM_PREFIX)) {
      const suffix = hash.slice(PROMO_FORM_PREFIX.length);
      if (!promoSuffixLooksMalformed(suffix)) {
        const successId = `SiteMenuPromoNewsletterSuccess-${suffix}`;
        const errorId = `SiteMenuPromoNewsletterError-${suffix}`;
        const found = document.getElementById(successId) || document.getElementById(errorId);
        if (found) {
          return found;
        }
      }
    }
    if (hash === "ContactFooter") {
      const found = document.getElementById("ContactFooter-success") || document.getElementById("ContactFooter-error");
      if (found) {
        return found;
      }
    }
    if (!posted && !hash) {
      return null;
    }
    return document.querySelector('.js-drawer [id^="SiteMenuPromoNewsletterSuccess-"]') || document.querySelector('[id^="SiteMenuPromoNewsletterSuccess-"]') || document.getElementById("ContactFooter-success") || document.querySelector('.js-drawer [id^="SiteMenuPromoNewsletterError-"]') || document.querySelector('[id^="SiteMenuPromoNewsletterError-"]') || document.getElementById("ContactFooter-error");
  }
  function initNewsletterCustomerPostedHandling() {
    const el = resolvePostedFeedbackEl();
    if (!el || !document.body.contains(el)) {
      return;
    }
    const drawerRoot = el.closest(".js-drawer");
    const reveal = () => {
      scrollToFeedback(el);
      tryFocusFeedback(el);
    };
    if (drawerRoot) {
      openDrawerProgrammatically(drawerRoot);
      const delayMs = prefersReducedMotion3() ? 0 : 320;
      window.setTimeout(reveal, delayMs);
      return;
    }
    window.requestAnimationFrame(reveal);
  }

  // src/js/modules/components/header-navi-scroll.js
  var PINNED_TOP_EPSILON = 1;
  var RESIZE_DEBOUNCE_MS2 = 150;
  var DIRECTION_THRESHOLD_PX = 12;
  var FORCE_SHOW_TOP_PX = 8;
  var ROOT_HIDDEN_CLASS = "is-header-navi-hidden";
  var METRIC_VARS = [
    "--header-content-height",
    "--header-navi-height",
    "--header-sticky-offset"
  ];
  var detachHeaderNaviScroll = null;
  function bindHeaderNaviScroll() {
    detachHeaderNaviScroll?.();
    detachHeaderNaviScroll = null;
    const nav = document.querySelector(".js-header__navi");
    const wrapper = nav?.closest(".js-header");
    const content = wrapper?.querySelector(".s-header__content");
    if (!nav || !wrapper || !content) {
      return;
    }
    const mq = window.matchMedia(mediaQueryTb);
    const root = document.documentElement;
    let lastScrollY = window.scrollY;
    let wasPinned = false;
    let contentHeight = 0;
    let navFullHeight = 0;
    let stickyOffsetShown = 0;
    let naviHidden = false;
    let directionDelta = 0;
    let lastStickyOffsetPx = -1;
    let ticking = false;
    let resizeTimerId2 = 0;
    const isPinned = () => wrapper.getBoundingClientRect().top <= PINNED_TOP_EPSILON;
    const measureStickyOffsetPx = () => Math.max(
      content.getBoundingClientRect().bottom,
      nav.getBoundingClientRect().bottom
    );
    const measureHeights = () => {
      contentHeight = content.offsetHeight;
      navFullHeight = Math.max(1, nav.scrollHeight, nav.offsetHeight);
    };
    const refreshStickyOffsetShown = () => {
      if (!mq.matches) {
        return;
      }
      stickyOffsetShown = isPinned() && !naviHidden ? measureStickyOffsetPx() : contentHeight + navFullHeight;
    };
    const applyStickyOffset = () => {
      if (!mq.matches) {
        return;
      }
      const next = Math.max(
        0,
        Math.round(naviHidden ? contentHeight : stickyOffsetShown)
      );
      if (next === lastStickyOffsetPx) {
        return;
      }
      lastStickyOffsetPx = next;
      root.style.setProperty("--header-sticky-offset", `${next}px`);
    };
    const applyLayoutMetrics = () => {
      if (!mq.matches) {
        return;
      }
      root.style.setProperty("--header-content-height", `${Math.round(contentHeight)}px`);
      root.style.setProperty("--header-navi-height", `${Math.round(navFullHeight)}px`);
    };
    const clearMetrics = () => {
      for (const name of METRIC_VARS) {
        root.style.removeProperty(name);
      }
      root.classList.remove(ROOT_HIDDEN_CLASS);
      naviHidden = false;
      directionDelta = 0;
      lastStickyOffsetPx = -1;
    };
    const syncMetrics = ({ forceStickyOffset = false } = {}) => {
      if (!mq.matches) {
        return;
      }
      measureHeights();
      applyLayoutMetrics();
      refreshStickyOffsetShown();
      if (forceStickyOffset) {
        lastStickyOffsetPx = -1;
      }
      applyStickyOffset();
    };
    const setNaviHidden = (hidden) => {
      if (!mq.matches) {
        return;
      }
      if (naviHidden === hidden) {
        applyStickyOffset();
        return;
      }
      naviHidden = hidden;
      root.classList.toggle(ROOT_HIDDEN_CLASS, hidden);
      directionDelta = 0;
      applyStickyOffset();
    };
    const showNaviAndSync = () => {
      setNaviHidden(false);
      syncMetrics({ forceStickyOffset: true });
    };
    const accumulateDirection = (dy) => {
      if (dy === 0) {
        return;
      }
      if (directionDelta !== 0 && Math.sign(dy) !== Math.sign(directionDelta)) {
        directionDelta = 0;
      }
      directionDelta += dy;
      if (directionDelta >= DIRECTION_THRESHOLD_PX) {
        setNaviHidden(true);
      } else if (directionDelta <= -DIRECTION_THRESHOLD_PX) {
        setNaviHidden(false);
      }
    };
    const onUnpinnedOrTop = (pinned) => {
      wasPinned = pinned;
      directionDelta = 0;
      showNaviAndSync();
    };
    const onPinStart = () => {
      measureHeights();
      setNaviHidden(false);
      refreshStickyOffsetShown();
      lastStickyOffsetPx = -1;
      applyStickyOffset();
      wasPinned = true;
      directionDelta = 0;
    };
    const onPinnedScroll = (dy) => {
      accumulateDirection(dy);
      wasPinned = true;
    };
    const update2 = () => {
      const y = window.scrollY;
      const dy = y - lastScrollY;
      lastScrollY = y;
      if (!mq.matches) {
        wasPinned = false;
        clearMetrics();
        return;
      }
      const pinned = isPinned();
      if (!pinned || y <= FORCE_SHOW_TOP_PX) {
        onUnpinnedOrTop(pinned);
        return;
      }
      if (!wasPinned) {
        onPinStart();
        return;
      }
      onPinnedScroll(dy);
    };
    const onScroll2 = () => {
      if (ticking) {
        return;
      }
      ticking = true;
      requestAnimationFrame(() => {
        update2();
        ticking = false;
      });
    };
    const scheduleMeasure = () => {
      if (resizeTimerId2) {
        clearTimeout(resizeTimerId2);
      }
      resizeTimerId2 = setTimeout(() => {
        resizeTimerId2 = 0;
        syncMetrics({ forceStickyOffset: true });
      }, RESIZE_DEBOUNCE_MS2);
    };
    const onMqChange = () => {
      lastScrollY = window.scrollY;
      wasPinned = false;
      directionDelta = 0;
      if (!mq.matches) {
        clearMetrics();
        return;
      }
      showNaviAndSync();
      update2();
    };
    window.addEventListener("scroll", onScroll2, { passive: true });
    window.addEventListener("resize", scheduleMeasure, { passive: true });
    mq.addEventListener("change", onMqChange);
    showNaviAndSync();
    lastScrollY = window.scrollY;
    update2();
    detachHeaderNaviScroll = () => {
      window.removeEventListener("scroll", onScroll2);
      window.removeEventListener("resize", scheduleMeasure);
      mq.removeEventListener("change", onMqChange);
      if (resizeTimerId2) {
        clearTimeout(resizeTimerId2);
      }
      clearMetrics();
    };
  }
  function initHeaderNaviScroll() {
    bindHeaderNaviScroll();
  }

  // src/js/modules/components/share-button.js
  var OPEN_CLASS3 = "is-share-open";
  var shareAbort = null;
  function closeSharePopover(wrap) {
    if (!wrap) {
      return;
    }
    const button = wrap.querySelector(".js-share-button");
    const popover = wrap.querySelector(".js-share-button-popover");
    wrap.classList.remove(OPEN_CLASS3);
    button?.setAttribute("aria-expanded", "false");
    popover?.setAttribute("hidden", "");
  }
  function closeAllSharePopovers(exceptWrap = null) {
    document.querySelectorAll(".js-share-button-wrap.is-share-open").forEach((wrap) => {
      if (wrap !== exceptWrap) {
        closeSharePopover(wrap);
      }
    });
  }
  function openSharePopover(wrap, button) {
    const popover = wrap.querySelector(".js-share-button-popover");
    if (!popover) {
      return;
    }
    closeAllSharePopovers(wrap);
    wrap.classList.add(OPEN_CLASS3);
    button.setAttribute("aria-expanded", "true");
    popover.removeAttribute("hidden");
  }
  function toggleSharePopover(wrap, button) {
    if (wrap.classList.contains(OPEN_CLASS3)) {
      closeSharePopover(wrap);
      return;
    }
    openSharePopover(wrap, button);
  }
  function initShareButtons() {
    shareAbort?.abort();
    shareAbort = new AbortController();
    const { signal } = shareAbort;
    document.addEventListener(
      "click",
      (event2) => {
        const button = event2.target.closest(".js-share-button");
        if (button) {
          event2.preventDefault();
          event2.stopPropagation();
          const wrap = button.closest(".js-share-button-wrap");
          if (wrap) {
            toggleSharePopover(wrap, button);
          }
          return;
        }
        if (!event2.target.closest(".js-share-button-wrap")) {
          closeAllSharePopovers();
        }
      },
      { signal }
    );
    document.addEventListener(
      "keydown",
      (event2) => {
        if (event2.key === "Escape") {
          closeAllSharePopovers();
        }
      },
      { signal }
    );
  }

  // src/js/modules/components/message-card.js
  var LEGACY_STORAGE_KEY = "nishikiya_message_card";
  var ATTR_ID = "\u30E1\u30C3\u30BB\u30FC\u30B8\u30AB\u30FC\u30C9ID";
  var ATTR_IMAGE = "\u30E1\u30C3\u30BB\u30FC\u30B8\u30AB\u30FC\u30C9\u753B\u50CFURL";
  var ATTR_QUANTITY = "\u30E1\u30C3\u30BB\u30FC\u30B8\u30AB\u30FC\u30C9\u679A\u6570";
  var URL_PARAM_ID = "card_number";
  var URL_PARAM_IMAGE = "card_image";
  var DEFAULT_QUANTITY = "1";
  function clearLegacyStorage() {
    try {
      localStorage.removeItem(LEGACY_STORAGE_KEY);
    } catch {
    }
  }
  function getCartUpdateUrl() {
    const baseUrl = window.routes?.cart_update_url;
    if (!baseUrl) {
      return "/cart/update.js";
    }
    return baseUrl.endsWith(".js") ? baseUrl : `${baseUrl.replace(/\/?$/, "")}.js`;
  }
  async function updateCartAttributes(attributes) {
    const response = await fetch(getCartUpdateUrl(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({ attributes })
    });
    if (!response.ok) {
      throw new Error(`Cart update failed: ${response.status}`);
    }
    return response.json();
  }
  function normalizeQuantity(quantity) {
    const parsed = Number.parseInt(String(quantity ?? ""), 10);
    if (!Number.isFinite(parsed) || parsed < 1) {
      return DEFAULT_QUANTITY;
    }
    if (parsed > 20) {
      return "20";
    }
    return String(parsed);
  }
  function buildAttributes({ cardId = "", cardImage = "", quantity = DEFAULT_QUANTITY } = {}) {
    return {
      [ATTR_ID]: cardId || "",
      [ATTR_IMAGE]: cardImage || "",
      [ATTR_QUANTITY]: normalizeQuantity(quantity)
    };
  }
  function buildClearedAttributes() {
    return {
      [ATTR_ID]: "",
      [ATTR_IMAGE]: "",
      [ATTR_QUANTITY]: ""
    };
  }
  function getAttributeFields(root) {
    return root.querySelectorAll(
      "[data-message-card-id], [data-message-card-quantity], [data-message-card-image]"
    );
  }
  function setFieldsDisabled(root, disabled) {
    getAttributeFields(root).forEach((element) => {
      element.disabled = disabled;
    });
  }
  function getFieldValues(root) {
    const idInput = root.querySelector("[data-message-card-id]");
    const imageInput = root.querySelector("[data-message-card-image]");
    const quantitySelect = root.querySelector("[data-message-card-quantity]");
    return {
      cardId: idInput?.value?.trim() || "",
      cardImage: imageInput?.value?.trim() || "",
      quantity: normalizeQuantity(quantitySelect?.value)
    };
  }
  function setFieldValues(root, { cardId = "", cardImage = "", quantity = DEFAULT_QUANTITY } = {}) {
    const idInput = root.querySelector("[data-message-card-id]");
    const imageInput = root.querySelector("[data-message-card-image]");
    const quantitySelect = root.querySelector("[data-message-card-quantity]");
    const normalizedQuantity = normalizeQuantity(quantity);
    if (idInput) {
      idInput.value = cardId;
    }
    if (imageInput) {
      imageInput.value = cardImage;
    }
    if (quantitySelect) {
      quantitySelect.value = normalizedQuantity;
    }
    root.dataset.messageCardIdValue = cardId;
    root.dataset.messageCardImageValue = cardImage;
    root.dataset.messageCardQuantityValue = normalizedQuantity;
    updatePreviewImage(root, cardImage);
  }
  function updatePreviewImage(root, cardImage) {
    const figure = root.querySelector("[data-message-card-preview]");
    const img = root.querySelector("[data-message-card-preview-image]");
    if (!figure || !img) {
      return;
    }
    if (cardImage) {
      img.src = cardImage;
      figure.hidden = false;
    } else {
      img.removeAttribute("src");
      figure.hidden = true;
    }
  }
  function setAccordionActive(root, isActive) {
    const accordion = root.querySelector("[data-message-card-accordion]");
    const trigger = accordion?.querySelector("[data-message-card-option]");
    const content = accordion?.querySelector(".js-accordion__content");
    if (!accordion || !trigger || !content) {
      return;
    }
    accordion.classList.toggle("is-active", isActive);
    trigger.setAttribute("aria-expanded", isActive ? "true" : "false");
    if (isActive) {
      content.style.maxHeight = `${content.scrollHeight}px`;
    } else {
      content.style.maxHeight = null;
    }
  }
  function readUrlParams() {
    const params = new URLSearchParams(window.location.search);
    const cardId = params.get(URL_PARAM_ID)?.trim() || "";
    const cardImage = params.get(URL_PARAM_IMAGE)?.trim() || "";
    if (!cardId && !cardImage) {
      return null;
    }
    return { cardId, cardImage };
  }
  function cleanUrlParams() {
    const url = new URL(window.location.href);
    let changed = false;
    [URL_PARAM_ID, URL_PARAM_IMAGE].forEach((key) => {
      if (url.searchParams.has(key)) {
        url.searchParams.delete(key);
        changed = true;
      }
    });
    if (changed) {
      window.history.replaceState({}, "", url.pathname + url.search + url.hash);
    }
  }
  function clearCartItemsLoadingState() {
    document.getElementById("main-cart-items")?.classList.remove("cart__items--disabled");
  }
  async function persistMessageCard(root, data) {
    const values = {
      cardId: data.cardId ?? getFieldValues(root).cardId,
      cardImage: data.cardImage ?? getFieldValues(root).cardImage,
      quantity: normalizeQuantity(data.quantity ?? getFieldValues(root).quantity)
    };
    setFieldsDisabled(root, false);
    setFieldValues(root, values);
    await updateCartAttributes(buildAttributes(values));
    clearCartItemsLoadingState();
    if (values.cardId) {
      setAccordionActive(root, true);
    }
    refreshAccordionHeights(root, "[data-message-card-accordion]");
  }
  async function clearMessageCard(root) {
    const previous = getFieldValues(root);
    try {
      await updateCartAttributes(buildClearedAttributes());
      setFieldValues(root, {
        cardId: "",
        cardImage: "",
        quantity: DEFAULT_QUANTITY
      });
      clearCartItemsLoadingState();
    } catch (error) {
      setFieldValues(root, previous);
      throw error;
    }
  }
  function debounce(fn, wait) {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => fn(...args), wait);
    };
  }
  async function syncOnInit(root) {
    clearLegacyStorage();
    const urlData = readUrlParams();
    if (urlData) {
      cleanUrlParams();
      await persistMessageCard(root, {
        ...urlData,
        quantity: getFieldValues(root).quantity
      });
      return;
    }
    const values = getFieldValues(root);
    if (values.cardId || values.cardImage) {
      setFieldsDisabled(root, false);
      return;
    }
    setFieldsDisabled(root, true);
  }
  function isMessageCardOpen(root) {
    return Boolean(
      root.querySelector("[data-message-card-accordion]")?.classList.contains("is-active")
    );
  }
  function validateMessageCardForCheckout(root) {
    if (!isMessageCardOpen(root)) {
      return true;
    }
    const idInput = root.querySelector("[data-message-card-id]");
    if (!idInput || idInput.disabled) {
      return true;
    }
    if (idInput.value.trim()) {
      return true;
    }
    setAccordionActive(root, true);
    setFieldsDisabled(root, false);
    idInput.focus();
    idInput.scrollIntoView({ block: "center", behavior: "smooth" });
    window.alert("\u30E1\u30C3\u30BB\u30FC\u30B8\u30AB\u30FC\u30C9\u306E\u30AB\u30FC\u30C9ID\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002");
    return false;
  }
  function bindCheckoutValidation(root) {
    const form = document.getElementById("cart");
    const checkoutButton = document.getElementById("checkout");
    const onCheckoutAttempt = (event2) => {
      if (validateMessageCardForCheckout(root)) {
        return;
      }
      event2.preventDefault();
      event2.stopImmediatePropagation();
    };
    checkoutButton?.addEventListener("click", onCheckoutAttempt);
    form?.addEventListener("submit", onCheckoutAttempt);
  }
  function bindMessageCard(root) {
    if (root.dataset.messageCardInitialized === "true") {
      return;
    }
    root.dataset.messageCardInitialized = "true";
    const accordion = root.querySelector("[data-message-card-accordion]");
    if (accordion) {
      initAccordion(accordion);
    }
    const isInitiallyActive = accordion?.classList.contains("is-active");
    setFieldsDisabled(root, !isInitiallyActive);
    const option = accordion?.querySelector("[data-message-card-option]");
    option?.addEventListener("click", () => {
      window.requestAnimationFrame(async () => {
        const isActive = accordion.classList.contains("is-active");
        if (!isActive) {
          try {
            await clearMessageCard(root);
            setFieldsDisabled(root, true);
          } catch (error) {
            console.error("Message card clear failed:", error);
            setAccordionActive(root, true);
            setFieldsDisabled(root, false);
          }
          return;
        }
        setFieldsDisabled(root, false);
        const values = getFieldValues(root);
        setFieldValues(root, {
          ...values,
          quantity: normalizeQuantity(values.quantity)
        });
      });
    });
    const saveFields = async () => {
      try {
        const values = getFieldValues(root);
        if (!values.cardId && !values.cardImage) {
          return;
        }
        await persistMessageCard(root, values);
      } catch (error) {
        console.error("Message card update failed:", error);
      }
    };
    const debouncedSave = debounce(saveFields, 400);
    root.querySelector("[data-message-card-id]")?.addEventListener("input", debouncedSave);
    root.querySelector("[data-message-card-id]")?.addEventListener("change", debouncedSave);
    root.querySelector("[data-message-card-quantity]")?.addEventListener("change", saveFields);
    const previewImage = root.querySelector("[data-message-card-preview-image]");
    previewImage?.addEventListener("load", () => {
      refreshAccordionHeights(root, "[data-message-card-accordion]");
    });
    bindCheckoutValidation(root);
    syncOnInit(root).catch((error) => {
      console.error("Message card init failed:", error);
    });
  }
  function initMessageCards(root = document) {
    root.querySelectorAll("[data-message-card]").forEach((element) => {
      bindMessageCard(element);
    });
  }

  // src/js/modules/components/shopping-bag.js
  function getCartUpdateUrl2() {
    const baseUrl = window.routes?.cart_update_url;
    if (!baseUrl) {
      return "/cart/update.js";
    }
    return baseUrl.endsWith(".js") ? baseUrl : `${baseUrl.replace(/\/?$/, "")}.js`;
  }
  function getCartItemsElement(root) {
    return root.closest("cart-items");
  }
  function getSectionsPayload(cartItems) {
    if (!cartItems?.getSectionsToRender) {
      return [];
    }
    return cartItems.getSectionsToRender().map((section) => section.section);
  }
  function buildUpdates(root) {
    const updates = {};
    root.querySelectorAll("[data-shopping-bag-quantity]").forEach((input) => {
      const variantId = input.dataset.quantityVariantId;
      const quantity = parseInt(input.value, 10);
      if (variantId && quantity > 0) {
        updates[variantId] = 0;
      }
    });
    return updates;
  }
  function setCartLoading(isLoading) {
    const mainCartItems = document.getElementById("main-cart-items");
    mainCartItems?.classList.toggle("cart__items--disabled", isLoading);
  }
  async function clearShoppingBag(root) {
    const updates = buildUpdates(root);
    if (Object.keys(updates).length === 0) {
      return;
    }
    const cartItems = getCartItemsElement(root);
    const body = JSON.stringify({
      updates,
      sections: getSectionsPayload(cartItems),
      sections_url: window.location.pathname
    });
    setCartLoading(true);
    try {
      const response = await fetch(getCartUpdateUrl2(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body
      });
      if (!response.ok) {
        throw new Error(`Cart update failed: ${response.status}`);
      }
      const parsedState = await response.json();
      if (cartItems?.applyAjaxCartParsedState) {
        cartItems.applyAjaxCartParsedState(parsedState, {
          line: null,
          quantity: 0,
          event: null,
          variantId: null,
          eventTargetPerfName: "clear",
          name: ""
        });
      }
      if (typeof globalThis.publish === "function") {
        globalThis.publish("cart-update", {
          source: "cart-items",
          cartData: parsedState
        });
      }
    } finally {
      setCartLoading(false);
    }
  }
  function bindShoppingBag(root) {
    if (root.dataset.shoppingBagInitialized === "true") {
      return;
    }
    root.dataset.shoppingBagInitialized = "true";
    const accordion = root.querySelector("[data-shopping-bag-accordion]");
    if (accordion) {
      initAccordion(accordion);
    }
    const option = accordion?.querySelector("[data-shopping-bag-option]");
    option?.addEventListener("click", () => {
      window.requestAnimationFrame(async () => {
        const isActive = accordion.classList.contains("is-active");
        if (!isActive) {
          try {
            await clearShoppingBag(root);
          } catch (error) {
            console.error("Shopping bag clear failed:", error);
          }
        }
      });
    });
  }
  function initShoppingBags(root = document) {
    root.querySelectorAll("[data-shopping-bag]").forEach((element) => {
      bindShoppingBag(element);
    });
  }

  // src/js/modules/components/cart-egift-body-class.js
  var GIFT_PROPERTY_KEY = "\u30AE\u30D5\u30C8\u8CFC\u5165";
  var GIFT_PROPERTY_VALUE = "\u6709\u52B9";
  var BODY_CLASS = "has-egift-item";
  var initialized = false;
  function cartHasEgift(cart) {
    return (cart?.items || []).some(
      (item) => item?.properties?.[GIFT_PROPERTY_KEY] === GIFT_PROPERTY_VALUE
    );
  }
  async function syncCartEgiftBodyClass() {
    if (!document.body.classList.contains("is-cart")) {
      return;
    }
    try {
      const response = await fetch(`${window.routes?.cart_url || "/cart"}.js`, {
        headers: { Accept: "application/json" }
      });
      if (!response.ok) {
        return;
      }
      const cart = await response.json();
      document.body.classList.toggle(BODY_CLASS, cartHasEgift(cart));
    } catch (error) {
      console.error("Failed to sync cart egift body class", error);
    }
  }
  function initCartEgiftBodyClass() {
    if (initialized || !document.body.classList.contains("is-cart")) {
      return;
    }
    initialized = true;
    document.addEventListener("cart:sections:updated", () => {
      syncCartEgiftBodyClass();
    });
  }

  // node_modules/@material/ripple/util.js
  var supportsCssVariables_;
  function detectEdgePseudoVarBug(windowObj) {
    var document2 = windowObj.document;
    var node = document2.createElement("div");
    node.className = "mdc-ripple-surface--test-edge-var-bug";
    document2.head.appendChild(node);
    var computedStyle = windowObj.getComputedStyle(node);
    var hasPseudoVarBug = computedStyle !== null && computedStyle.borderTopStyle === "solid";
    if (node.parentNode) {
      node.parentNode.removeChild(node);
    }
    return hasPseudoVarBug;
  }
  function supportsCssVariables(windowObj, forceRefresh) {
    if (forceRefresh === void 0) {
      forceRefresh = false;
    }
    var CSS2 = windowObj.CSS;
    var supportsCssVars = supportsCssVariables_;
    if (typeof supportsCssVariables_ === "boolean" && !forceRefresh) {
      return supportsCssVariables_;
    }
    var supportsFunctionPresent = CSS2 && typeof CSS2.supports === "function";
    if (!supportsFunctionPresent) {
      return false;
    }
    var explicitlySupportsCssVars = CSS2.supports("--css-vars", "yes");
    var weAreFeatureDetectingSafari10plus = CSS2.supports("(--css-vars: yes)") && CSS2.supports("color", "#00000000");
    if (explicitlySupportsCssVars || weAreFeatureDetectingSafari10plus) {
      supportsCssVars = !detectEdgePseudoVarBug(windowObj);
    } else {
      supportsCssVars = false;
    }
    if (!forceRefresh) {
      supportsCssVariables_ = supportsCssVars;
    }
    return supportsCssVars;
  }
  function getNormalizedEventCoords(evt, pageOffset, clientRect) {
    if (!evt) {
      return { x: 0, y: 0 };
    }
    var x = pageOffset.x, y = pageOffset.y;
    var documentX = x + clientRect.left;
    var documentY = y + clientRect.top;
    var normalizedX;
    var normalizedY;
    if (evt.type === "touchstart") {
      var touchEvent = evt;
      normalizedX = touchEvent.changedTouches[0].pageX - documentX;
      normalizedY = touchEvent.changedTouches[0].pageY - documentY;
    } else {
      var mouseEvent = evt;
      normalizedX = mouseEvent.pageX - documentX;
      normalizedY = mouseEvent.pageY - documentY;
    }
    return { x: normalizedX, y: normalizedY };
  }

  // node_modules/@material/ripple/node_modules/tslib/tslib.es6.js
  var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
      d2.__proto__ = b2;
    } || function(d2, b2) {
      for (var p in b2) if (b2.hasOwnProperty(p)) d2[p] = b2[p];
    };
    return extendStatics(d, b);
  };
  function __extends(d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  }
  var __assign = function() {
    __assign = Object.assign || function __assign2(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
    };
    return __assign.apply(this, arguments);
  };

  // node_modules/@material/base/node_modules/tslib/tslib.es6.js
  function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    } catch (error) {
      e = { error };
    } finally {
      try {
        if (r && !r.done && (m = i["return"])) m.call(i);
      } finally {
        if (e) throw e.error;
      }
    }
    return ar;
  }
  function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
      ar = ar.concat(__read(arguments[i]));
    return ar;
  }

  // node_modules/@material/base/foundation.js
  var MDCFoundation = (
    /** @class */
    (function() {
      function MDCFoundation2(adapter) {
        if (adapter === void 0) {
          adapter = {};
        }
        this.adapter_ = adapter;
      }
      Object.defineProperty(MDCFoundation2, "cssClasses", {
        get: function() {
          return {};
        },
        enumerable: true,
        configurable: true
      });
      Object.defineProperty(MDCFoundation2, "strings", {
        get: function() {
          return {};
        },
        enumerable: true,
        configurable: true
      });
      Object.defineProperty(MDCFoundation2, "numbers", {
        get: function() {
          return {};
        },
        enumerable: true,
        configurable: true
      });
      Object.defineProperty(MDCFoundation2, "defaultAdapter", {
        get: function() {
          return {};
        },
        enumerable: true,
        configurable: true
      });
      MDCFoundation2.prototype.init = function() {
      };
      MDCFoundation2.prototype.destroy = function() {
      };
      return MDCFoundation2;
    })()
  );

  // node_modules/@material/base/component.js
  var MDCComponent = (
    /** @class */
    (function() {
      function MDCComponent2(root, foundation) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
          args[_i - 2] = arguments[_i];
        }
        this.root_ = root;
        this.initialize.apply(this, __spread(args));
        this.foundation_ = foundation === void 0 ? this.getDefaultFoundation() : foundation;
        this.foundation_.init();
        this.initialSyncWithDOM();
      }
      MDCComponent2.attachTo = function(root) {
        return new MDCComponent2(root, new MDCFoundation({}));
      };
      MDCComponent2.prototype.initialize = function() {
        var _args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          _args[_i] = arguments[_i];
        }
      };
      MDCComponent2.prototype.getDefaultFoundation = function() {
        throw new Error("Subclasses must override getDefaultFoundation to return a properly configured foundation class");
      };
      MDCComponent2.prototype.initialSyncWithDOM = function() {
      };
      MDCComponent2.prototype.destroy = function() {
        this.foundation_.destroy();
      };
      MDCComponent2.prototype.listen = function(evtType, handler, options) {
        this.root_.addEventListener(evtType, handler, options);
      };
      MDCComponent2.prototype.unlisten = function(evtType, handler, options) {
        this.root_.removeEventListener(evtType, handler, options);
      };
      MDCComponent2.prototype.emit = function(evtType, evtData, shouldBubble) {
        if (shouldBubble === void 0) {
          shouldBubble = false;
        }
        var evt;
        if (typeof CustomEvent === "function") {
          evt = new CustomEvent(evtType, {
            bubbles: shouldBubble,
            detail: evtData
          });
        } else {
          evt = document.createEvent("CustomEvent");
          evt.initCustomEvent(evtType, shouldBubble, false, evtData);
        }
        this.root_.dispatchEvent(evt);
      };
      return MDCComponent2;
    })()
  );

  // node_modules/@material/dom/events.js
  var supportsPassive_;
  function applyPassive(globalObj, forceRefresh) {
    if (globalObj === void 0) {
      globalObj = window;
    }
    if (forceRefresh === void 0) {
      forceRefresh = false;
    }
    if (supportsPassive_ === void 0 || forceRefresh) {
      var isSupported_1 = false;
      try {
        globalObj.document.addEventListener("test", function() {
          return void 0;
        }, {
          get passive() {
            isSupported_1 = true;
            return isSupported_1;
          }
        });
      } catch (e) {
      }
      supportsPassive_ = isSupported_1;
    }
    return supportsPassive_ ? { passive: true } : false;
  }

  // node_modules/@material/dom/ponyfill.js
  function matches(element, selector) {
    var nativeMatches = element.matches || element.webkitMatchesSelector || element.msMatchesSelector;
    return nativeMatches.call(element, selector);
  }

  // node_modules/@material/ripple/constants.js
  var cssClasses = {
    // Ripple is a special case where the "root" component is really a "mixin" of sorts,
    // given that it's an 'upgrade' to an existing component. That being said it is the root
    // CSS class that all other CSS classes derive from.
    BG_FOCUSED: "mdc-ripple-upgraded--background-focused",
    FG_ACTIVATION: "mdc-ripple-upgraded--foreground-activation",
    FG_DEACTIVATION: "mdc-ripple-upgraded--foreground-deactivation",
    ROOT: "mdc-ripple-upgraded",
    UNBOUNDED: "mdc-ripple-upgraded--unbounded"
  };
  var strings = {
    VAR_FG_SCALE: "--mdc-ripple-fg-scale",
    VAR_FG_SIZE: "--mdc-ripple-fg-size",
    VAR_FG_TRANSLATE_END: "--mdc-ripple-fg-translate-end",
    VAR_FG_TRANSLATE_START: "--mdc-ripple-fg-translate-start",
    VAR_LEFT: "--mdc-ripple-left",
    VAR_TOP: "--mdc-ripple-top"
  };
  var numbers = {
    DEACTIVATION_TIMEOUT_MS: 225,
    FG_DEACTIVATION_MS: 150,
    INITIAL_ORIGIN_SCALE: 0.6,
    PADDING: 10,
    TAP_DELAY_MS: 300
  };

  // node_modules/@material/ripple/foundation.js
  var ACTIVATION_EVENT_TYPES = [
    "touchstart",
    "pointerdown",
    "mousedown",
    "keydown"
  ];
  var POINTER_DEACTIVATION_EVENT_TYPES = [
    "touchend",
    "pointerup",
    "mouseup",
    "contextmenu"
  ];
  var activatedTargets = [];
  var MDCRippleFoundation = (
    /** @class */
    (function(_super) {
      __extends(MDCRippleFoundation2, _super);
      function MDCRippleFoundation2(adapter) {
        var _this = _super.call(this, __assign({}, MDCRippleFoundation2.defaultAdapter, adapter)) || this;
        _this.activationAnimationHasEnded_ = false;
        _this.activationTimer_ = 0;
        _this.fgDeactivationRemovalTimer_ = 0;
        _this.fgScale_ = "0";
        _this.frame_ = { width: 0, height: 0 };
        _this.initialSize_ = 0;
        _this.layoutFrame_ = 0;
        _this.maxRadius_ = 0;
        _this.unboundedCoords_ = { left: 0, top: 0 };
        _this.activationState_ = _this.defaultActivationState_();
        _this.activationTimerCallback_ = function() {
          _this.activationAnimationHasEnded_ = true;
          _this.runDeactivationUXLogicIfReady_();
        };
        _this.activateHandler_ = function(e) {
          return _this.activate_(e);
        };
        _this.deactivateHandler_ = function() {
          return _this.deactivate_();
        };
        _this.focusHandler_ = function() {
          return _this.handleFocus();
        };
        _this.blurHandler_ = function() {
          return _this.handleBlur();
        };
        _this.resizeHandler_ = function() {
          return _this.layout();
        };
        return _this;
      }
      Object.defineProperty(MDCRippleFoundation2, "cssClasses", {
        get: function() {
          return cssClasses;
        },
        enumerable: true,
        configurable: true
      });
      Object.defineProperty(MDCRippleFoundation2, "strings", {
        get: function() {
          return strings;
        },
        enumerable: true,
        configurable: true
      });
      Object.defineProperty(MDCRippleFoundation2, "numbers", {
        get: function() {
          return numbers;
        },
        enumerable: true,
        configurable: true
      });
      Object.defineProperty(MDCRippleFoundation2, "defaultAdapter", {
        get: function() {
          return {
            addClass: function() {
              return void 0;
            },
            browserSupportsCssVars: function() {
              return true;
            },
            computeBoundingRect: function() {
              return { top: 0, right: 0, bottom: 0, left: 0, width: 0, height: 0 };
            },
            containsEventTarget: function() {
              return true;
            },
            deregisterDocumentInteractionHandler: function() {
              return void 0;
            },
            deregisterInteractionHandler: function() {
              return void 0;
            },
            deregisterResizeHandler: function() {
              return void 0;
            },
            getWindowPageOffset: function() {
              return { x: 0, y: 0 };
            },
            isSurfaceActive: function() {
              return true;
            },
            isSurfaceDisabled: function() {
              return true;
            },
            isUnbounded: function() {
              return true;
            },
            registerDocumentInteractionHandler: function() {
              return void 0;
            },
            registerInteractionHandler: function() {
              return void 0;
            },
            registerResizeHandler: function() {
              return void 0;
            },
            removeClass: function() {
              return void 0;
            },
            updateCssVariable: function() {
              return void 0;
            }
          };
        },
        enumerable: true,
        configurable: true
      });
      MDCRippleFoundation2.prototype.init = function() {
        var _this = this;
        var supportsPressRipple = this.supportsPressRipple_();
        this.registerRootHandlers_(supportsPressRipple);
        if (supportsPressRipple) {
          var _a = MDCRippleFoundation2.cssClasses, ROOT_1 = _a.ROOT, UNBOUNDED_1 = _a.UNBOUNDED;
          requestAnimationFrame(function() {
            _this.adapter_.addClass(ROOT_1);
            if (_this.adapter_.isUnbounded()) {
              _this.adapter_.addClass(UNBOUNDED_1);
              _this.layoutInternal_();
            }
          });
        }
      };
      MDCRippleFoundation2.prototype.destroy = function() {
        var _this = this;
        if (this.supportsPressRipple_()) {
          if (this.activationTimer_) {
            clearTimeout(this.activationTimer_);
            this.activationTimer_ = 0;
            this.adapter_.removeClass(MDCRippleFoundation2.cssClasses.FG_ACTIVATION);
          }
          if (this.fgDeactivationRemovalTimer_) {
            clearTimeout(this.fgDeactivationRemovalTimer_);
            this.fgDeactivationRemovalTimer_ = 0;
            this.adapter_.removeClass(MDCRippleFoundation2.cssClasses.FG_DEACTIVATION);
          }
          var _a = MDCRippleFoundation2.cssClasses, ROOT_2 = _a.ROOT, UNBOUNDED_2 = _a.UNBOUNDED;
          requestAnimationFrame(function() {
            _this.adapter_.removeClass(ROOT_2);
            _this.adapter_.removeClass(UNBOUNDED_2);
            _this.removeCssVars_();
          });
        }
        this.deregisterRootHandlers_();
        this.deregisterDeactivationHandlers_();
      };
      MDCRippleFoundation2.prototype.activate = function(evt) {
        this.activate_(evt);
      };
      MDCRippleFoundation2.prototype.deactivate = function() {
        this.deactivate_();
      };
      MDCRippleFoundation2.prototype.layout = function() {
        var _this = this;
        if (this.layoutFrame_) {
          cancelAnimationFrame(this.layoutFrame_);
        }
        this.layoutFrame_ = requestAnimationFrame(function() {
          _this.layoutInternal_();
          _this.layoutFrame_ = 0;
        });
      };
      MDCRippleFoundation2.prototype.setUnbounded = function(unbounded) {
        var UNBOUNDED = MDCRippleFoundation2.cssClasses.UNBOUNDED;
        if (unbounded) {
          this.adapter_.addClass(UNBOUNDED);
        } else {
          this.adapter_.removeClass(UNBOUNDED);
        }
      };
      MDCRippleFoundation2.prototype.handleFocus = function() {
        var _this = this;
        requestAnimationFrame(function() {
          return _this.adapter_.addClass(MDCRippleFoundation2.cssClasses.BG_FOCUSED);
        });
      };
      MDCRippleFoundation2.prototype.handleBlur = function() {
        var _this = this;
        requestAnimationFrame(function() {
          return _this.adapter_.removeClass(MDCRippleFoundation2.cssClasses.BG_FOCUSED);
        });
      };
      MDCRippleFoundation2.prototype.supportsPressRipple_ = function() {
        return this.adapter_.browserSupportsCssVars();
      };
      MDCRippleFoundation2.prototype.defaultActivationState_ = function() {
        return {
          activationEvent: void 0,
          hasDeactivationUXRun: false,
          isActivated: false,
          isProgrammatic: false,
          wasActivatedByPointer: false,
          wasElementMadeActive: false
        };
      };
      MDCRippleFoundation2.prototype.registerRootHandlers_ = function(supportsPressRipple) {
        var _this = this;
        if (supportsPressRipple) {
          ACTIVATION_EVENT_TYPES.forEach(function(evtType) {
            _this.adapter_.registerInteractionHandler(evtType, _this.activateHandler_);
          });
          if (this.adapter_.isUnbounded()) {
            this.adapter_.registerResizeHandler(this.resizeHandler_);
          }
        }
        this.adapter_.registerInteractionHandler("focus", this.focusHandler_);
        this.adapter_.registerInteractionHandler("blur", this.blurHandler_);
      };
      MDCRippleFoundation2.prototype.registerDeactivationHandlers_ = function(evt) {
        var _this = this;
        if (evt.type === "keydown") {
          this.adapter_.registerInteractionHandler("keyup", this.deactivateHandler_);
        } else {
          POINTER_DEACTIVATION_EVENT_TYPES.forEach(function(evtType) {
            _this.adapter_.registerDocumentInteractionHandler(evtType, _this.deactivateHandler_);
          });
        }
      };
      MDCRippleFoundation2.prototype.deregisterRootHandlers_ = function() {
        var _this = this;
        ACTIVATION_EVENT_TYPES.forEach(function(evtType) {
          _this.adapter_.deregisterInteractionHandler(evtType, _this.activateHandler_);
        });
        this.adapter_.deregisterInteractionHandler("focus", this.focusHandler_);
        this.adapter_.deregisterInteractionHandler("blur", this.blurHandler_);
        if (this.adapter_.isUnbounded()) {
          this.adapter_.deregisterResizeHandler(this.resizeHandler_);
        }
      };
      MDCRippleFoundation2.prototype.deregisterDeactivationHandlers_ = function() {
        var _this = this;
        this.adapter_.deregisterInteractionHandler("keyup", this.deactivateHandler_);
        POINTER_DEACTIVATION_EVENT_TYPES.forEach(function(evtType) {
          _this.adapter_.deregisterDocumentInteractionHandler(evtType, _this.deactivateHandler_);
        });
      };
      MDCRippleFoundation2.prototype.removeCssVars_ = function() {
        var _this = this;
        var rippleStrings = MDCRippleFoundation2.strings;
        var keys = Object.keys(rippleStrings);
        keys.forEach(function(key) {
          if (key.indexOf("VAR_") === 0) {
            _this.adapter_.updateCssVariable(rippleStrings[key], null);
          }
        });
      };
      MDCRippleFoundation2.prototype.activate_ = function(evt) {
        var _this = this;
        if (this.adapter_.isSurfaceDisabled()) {
          return;
        }
        var activationState = this.activationState_;
        if (activationState.isActivated) {
          return;
        }
        var previousActivationEvent = this.previousActivationEvent_;
        var isSameInteraction = previousActivationEvent && evt !== void 0 && previousActivationEvent.type !== evt.type;
        if (isSameInteraction) {
          return;
        }
        activationState.isActivated = true;
        activationState.isProgrammatic = evt === void 0;
        activationState.activationEvent = evt;
        activationState.wasActivatedByPointer = activationState.isProgrammatic ? false : evt !== void 0 && (evt.type === "mousedown" || evt.type === "touchstart" || evt.type === "pointerdown");
        var hasActivatedChild = evt !== void 0 && activatedTargets.length > 0 && activatedTargets.some(function(target) {
          return _this.adapter_.containsEventTarget(target);
        });
        if (hasActivatedChild) {
          this.resetActivationState_();
          return;
        }
        if (evt !== void 0) {
          activatedTargets.push(evt.target);
          this.registerDeactivationHandlers_(evt);
        }
        activationState.wasElementMadeActive = this.checkElementMadeActive_(evt);
        if (activationState.wasElementMadeActive) {
          this.animateActivation_();
        }
        requestAnimationFrame(function() {
          activatedTargets = [];
          if (!activationState.wasElementMadeActive && evt !== void 0 && (evt.key === " " || evt.keyCode === 32)) {
            activationState.wasElementMadeActive = _this.checkElementMadeActive_(evt);
            if (activationState.wasElementMadeActive) {
              _this.animateActivation_();
            }
          }
          if (!activationState.wasElementMadeActive) {
            _this.activationState_ = _this.defaultActivationState_();
          }
        });
      };
      MDCRippleFoundation2.prototype.checkElementMadeActive_ = function(evt) {
        return evt !== void 0 && evt.type === "keydown" ? this.adapter_.isSurfaceActive() : true;
      };
      MDCRippleFoundation2.prototype.animateActivation_ = function() {
        var _this = this;
        var _a = MDCRippleFoundation2.strings, VAR_FG_TRANSLATE_START = _a.VAR_FG_TRANSLATE_START, VAR_FG_TRANSLATE_END = _a.VAR_FG_TRANSLATE_END;
        var _b = MDCRippleFoundation2.cssClasses, FG_DEACTIVATION = _b.FG_DEACTIVATION, FG_ACTIVATION = _b.FG_ACTIVATION;
        var DEACTIVATION_TIMEOUT_MS = MDCRippleFoundation2.numbers.DEACTIVATION_TIMEOUT_MS;
        this.layoutInternal_();
        var translateStart = "";
        var translateEnd = "";
        if (!this.adapter_.isUnbounded()) {
          var _c = this.getFgTranslationCoordinates_(), startPoint = _c.startPoint, endPoint = _c.endPoint;
          translateStart = startPoint.x + "px, " + startPoint.y + "px";
          translateEnd = endPoint.x + "px, " + endPoint.y + "px";
        }
        this.adapter_.updateCssVariable(VAR_FG_TRANSLATE_START, translateStart);
        this.adapter_.updateCssVariable(VAR_FG_TRANSLATE_END, translateEnd);
        clearTimeout(this.activationTimer_);
        clearTimeout(this.fgDeactivationRemovalTimer_);
        this.rmBoundedActivationClasses_();
        this.adapter_.removeClass(FG_DEACTIVATION);
        this.adapter_.computeBoundingRect();
        this.adapter_.addClass(FG_ACTIVATION);
        this.activationTimer_ = setTimeout(function() {
          return _this.activationTimerCallback_();
        }, DEACTIVATION_TIMEOUT_MS);
      };
      MDCRippleFoundation2.prototype.getFgTranslationCoordinates_ = function() {
        var _a = this.activationState_, activationEvent = _a.activationEvent, wasActivatedByPointer = _a.wasActivatedByPointer;
        var startPoint;
        if (wasActivatedByPointer) {
          startPoint = getNormalizedEventCoords(activationEvent, this.adapter_.getWindowPageOffset(), this.adapter_.computeBoundingRect());
        } else {
          startPoint = {
            x: this.frame_.width / 2,
            y: this.frame_.height / 2
          };
        }
        startPoint = {
          x: startPoint.x - this.initialSize_ / 2,
          y: startPoint.y - this.initialSize_ / 2
        };
        var endPoint = {
          x: this.frame_.width / 2 - this.initialSize_ / 2,
          y: this.frame_.height / 2 - this.initialSize_ / 2
        };
        return { startPoint, endPoint };
      };
      MDCRippleFoundation2.prototype.runDeactivationUXLogicIfReady_ = function() {
        var _this = this;
        var FG_DEACTIVATION = MDCRippleFoundation2.cssClasses.FG_DEACTIVATION;
        var _a = this.activationState_, hasDeactivationUXRun = _a.hasDeactivationUXRun, isActivated = _a.isActivated;
        var activationHasEnded = hasDeactivationUXRun || !isActivated;
        if (activationHasEnded && this.activationAnimationHasEnded_) {
          this.rmBoundedActivationClasses_();
          this.adapter_.addClass(FG_DEACTIVATION);
          this.fgDeactivationRemovalTimer_ = setTimeout(function() {
            _this.adapter_.removeClass(FG_DEACTIVATION);
          }, numbers.FG_DEACTIVATION_MS);
        }
      };
      MDCRippleFoundation2.prototype.rmBoundedActivationClasses_ = function() {
        var FG_ACTIVATION = MDCRippleFoundation2.cssClasses.FG_ACTIVATION;
        this.adapter_.removeClass(FG_ACTIVATION);
        this.activationAnimationHasEnded_ = false;
        this.adapter_.computeBoundingRect();
      };
      MDCRippleFoundation2.prototype.resetActivationState_ = function() {
        var _this = this;
        this.previousActivationEvent_ = this.activationState_.activationEvent;
        this.activationState_ = this.defaultActivationState_();
        setTimeout(function() {
          return _this.previousActivationEvent_ = void 0;
        }, MDCRippleFoundation2.numbers.TAP_DELAY_MS);
      };
      MDCRippleFoundation2.prototype.deactivate_ = function() {
        var _this = this;
        var activationState = this.activationState_;
        if (!activationState.isActivated) {
          return;
        }
        var state = __assign({}, activationState);
        if (activationState.isProgrammatic) {
          requestAnimationFrame(function() {
            return _this.animateDeactivation_(state);
          });
          this.resetActivationState_();
        } else {
          this.deregisterDeactivationHandlers_();
          requestAnimationFrame(function() {
            _this.activationState_.hasDeactivationUXRun = true;
            _this.animateDeactivation_(state);
            _this.resetActivationState_();
          });
        }
      };
      MDCRippleFoundation2.prototype.animateDeactivation_ = function(_a) {
        var wasActivatedByPointer = _a.wasActivatedByPointer, wasElementMadeActive = _a.wasElementMadeActive;
        if (wasActivatedByPointer || wasElementMadeActive) {
          this.runDeactivationUXLogicIfReady_();
        }
      };
      MDCRippleFoundation2.prototype.layoutInternal_ = function() {
        var _this = this;
        this.frame_ = this.adapter_.computeBoundingRect();
        var maxDim = Math.max(this.frame_.height, this.frame_.width);
        var getBoundedRadius = function() {
          var hypotenuse = Math.sqrt(Math.pow(_this.frame_.width, 2) + Math.pow(_this.frame_.height, 2));
          return hypotenuse + MDCRippleFoundation2.numbers.PADDING;
        };
        this.maxRadius_ = this.adapter_.isUnbounded() ? maxDim : getBoundedRadius();
        this.initialSize_ = Math.floor(maxDim * MDCRippleFoundation2.numbers.INITIAL_ORIGIN_SCALE);
        this.fgScale_ = "" + this.maxRadius_ / this.initialSize_;
        this.updateLayoutCssVars_();
      };
      MDCRippleFoundation2.prototype.updateLayoutCssVars_ = function() {
        var _a = MDCRippleFoundation2.strings, VAR_FG_SIZE = _a.VAR_FG_SIZE, VAR_LEFT = _a.VAR_LEFT, VAR_TOP = _a.VAR_TOP, VAR_FG_SCALE = _a.VAR_FG_SCALE;
        this.adapter_.updateCssVariable(VAR_FG_SIZE, this.initialSize_ + "px");
        this.adapter_.updateCssVariable(VAR_FG_SCALE, this.fgScale_);
        if (this.adapter_.isUnbounded()) {
          this.unboundedCoords_ = {
            left: Math.round(this.frame_.width / 2 - this.initialSize_ / 2),
            top: Math.round(this.frame_.height / 2 - this.initialSize_ / 2)
          };
          this.adapter_.updateCssVariable(VAR_LEFT, this.unboundedCoords_.left + "px");
          this.adapter_.updateCssVariable(VAR_TOP, this.unboundedCoords_.top + "px");
        }
      };
      return MDCRippleFoundation2;
    })(MDCFoundation)
  );

  // node_modules/@material/ripple/component.js
  var MDCRipple = (
    /** @class */
    (function(_super) {
      __extends(MDCRipple2, _super);
      function MDCRipple2() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.disabled = false;
        return _this;
      }
      MDCRipple2.attachTo = function(root, opts) {
        if (opts === void 0) {
          opts = { isUnbounded: void 0 };
        }
        var ripple = new MDCRipple2(root);
        if (opts.isUnbounded !== void 0) {
          ripple.unbounded = opts.isUnbounded;
        }
        return ripple;
      };
      MDCRipple2.createAdapter = function(instance) {
        return {
          addClass: function(className) {
            return instance.root_.classList.add(className);
          },
          browserSupportsCssVars: function() {
            return supportsCssVariables(window);
          },
          computeBoundingRect: function() {
            return instance.root_.getBoundingClientRect();
          },
          containsEventTarget: function(target) {
            return instance.root_.contains(target);
          },
          deregisterDocumentInteractionHandler: function(evtType, handler) {
            return document.documentElement.removeEventListener(evtType, handler, applyPassive());
          },
          deregisterInteractionHandler: function(evtType, handler) {
            return instance.root_.removeEventListener(evtType, handler, applyPassive());
          },
          deregisterResizeHandler: function(handler) {
            return window.removeEventListener("resize", handler);
          },
          getWindowPageOffset: function() {
            return { x: window.pageXOffset, y: window.pageYOffset };
          },
          isSurfaceActive: function() {
            return matches(instance.root_, ":active");
          },
          isSurfaceDisabled: function() {
            return Boolean(instance.disabled);
          },
          isUnbounded: function() {
            return Boolean(instance.unbounded);
          },
          registerDocumentInteractionHandler: function(evtType, handler) {
            return document.documentElement.addEventListener(evtType, handler, applyPassive());
          },
          registerInteractionHandler: function(evtType, handler) {
            return instance.root_.addEventListener(evtType, handler, applyPassive());
          },
          registerResizeHandler: function(handler) {
            return window.addEventListener("resize", handler);
          },
          removeClass: function(className) {
            return instance.root_.classList.remove(className);
          },
          updateCssVariable: function(varName, value) {
            return instance.root_.style.setProperty(varName, value);
          }
        };
      };
      Object.defineProperty(MDCRipple2.prototype, "unbounded", {
        get: function() {
          return Boolean(this.unbounded_);
        },
        set: function(unbounded) {
          this.unbounded_ = Boolean(unbounded);
          this.setUnbounded_();
        },
        enumerable: true,
        configurable: true
      });
      MDCRipple2.prototype.activate = function() {
        this.foundation_.activate();
      };
      MDCRipple2.prototype.deactivate = function() {
        this.foundation_.deactivate();
      };
      MDCRipple2.prototype.layout = function() {
        this.foundation_.layout();
      };
      MDCRipple2.prototype.getDefaultFoundation = function() {
        return new MDCRippleFoundation(MDCRipple2.createAdapter(this));
      };
      MDCRipple2.prototype.initialSyncWithDOM = function() {
        var root = this.root_;
        this.unbounded = "mdcRippleIsUnbounded" in root.dataset;
      };
      MDCRipple2.prototype.setUnbounded_ = function() {
        this.foundation_.setUnbounded(Boolean(this.unbounded_));
      };
      return MDCRipple2;
    })(MDCComponent)
  );

  // src/js/modules/vendors/mdc.js
  if (typeof window !== "undefined") {
    window.mdc = window.mdc || {};
    window.mdc.ripple = window.mdc.ripple || {};
    window.mdc.ripple.MDCRipple = MDCRipple;
  }
  function initMDCButtons() {
    const buttons = document.querySelectorAll(".mdc-button");
    buttons.forEach((button) => {
      if (button.mdcButton) {
        return;
      }
      try {
        new MDCRipple(button);
      } catch (error) {
        console.warn("Failed to initialize MDC button:", error);
      }
    });
  }
  function initMDCRipples() {
    const ripples = document.querySelectorAll(".mdc-ripple-surface:not(.mdc-button)");
    ripples.forEach((ripple) => {
      if (ripple.mdcRipple) {
        return;
      }
      try {
        new MDCRipple(ripple);
      } catch (error) {
        console.warn("Failed to initialize MDC ripple:", error);
      }
    });
  }
  function initMDC() {
    initMDCButtons();
    initMDCRipples();
  }

  // src/js/customize.js
  function initializeApp(root = document) {
    console.log("Shopify theme customize script loaded");
    initMDC();
    initLegacyAccordions();
    initAccordions(".js-accordion", document, { excludeDrawer: true });
    initSmoothScroll({
      offsetPc: 0,
      offsetSp: 0,
      // TB 以下: --header-sticky-offset（未設定時のフォールバック）
      offsetSpHasNavi: 100,
      breakpoint: BREAKPOINT_TB
    });
    initColumnDetailMokuji(root);
    initAnnouncementBarSwipers();
    initMainVisualSwipers();
    initCollectionCategorySwipers();
    initCollectionSliderSwipers();
    initCardSliderSwipers();
    initCustomerReviewsSwipers();
    initColumnRankingSwipers(root);
    initColumnRelatedSwipers(root);
    initColumnTagsSwipers(root);
    initProductMediaSwipers();
    initHeaderNaviScroll();
    initDrawers();
    initProductSheets();
    initProductNekopos(root);
    initFacetsDrawer();
    initNewsletterCustomerPostedHandling();
    initProductContentNaviScrollSpy();
    initStickyBuy();
    initCardForm(root);
    initShareButtons();
    initMessageCards();
    initShoppingBags();
  }
  function onProductRecommendationsLoaded(event2) {
    initCardSliderSwipers(event2.target);
    initCardForm(event2.target);
  }
  document.addEventListener("DOMContentLoaded", () => {
    initializeApp();
    correctLocationHashScroll();
    initPopularRankingSections();
    initRankingPageCategories();
    initCartEgiftBodyClass();
  });
  document.addEventListener("shopify:section:load", (event2) => {
    initializeApp(event2.target);
    initPopularRankingSections(event2.target);
    initRankingPageCategories(event2.target);
    onStickyBuyUpdated(event2.target);
  });
  document.addEventListener("product-recommendations:loaded", onProductRecommendationsLoaded);
  document.addEventListener("facets-drawer:updated", () => {
    onFacetsDrawerUpdated();
    initCardForm();
  });
  document.addEventListener("cart:sections:updated", () => {
    initAccordions(".js-accordion", document, { excludeDrawer: true });
    initMessageCards();
    initShoppingBags();
  });
})();
/*! Bundled license information:

tslib/tslib.es6.js:
tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

@material/base/foundation.js:
@material/base/component.js:
@material/ripple/constants.js:
@material/ripple/foundation.js:
@material/ripple/component.js:
  (**
   * @license
   * Copyright 2016 Google Inc.
   *
   * Permission is hereby granted, free of charge, to any person obtaining a copy
   * of this software and associated documentation files (the "Software"), to deal
   * in the Software without restriction, including without limitation the rights
   * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
   * copies of the Software, and to permit persons to whom the Software is
   * furnished to do so, subject to the following conditions:
   *
   * The above copyright notice and this permission notice shall be included in
   * all copies or substantial portions of the Software.
   *
   * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
   * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
   * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
   * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
   * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
   * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
   * THE SOFTWARE.
   *)

@material/dom/events.js:
  (**
   * @license
   * Copyright 2019 Google Inc.
   *
   * Permission is hereby granted, free of charge, to any person obtaining a copy
   * of this software and associated documentation files (the "Software"), to deal
   * in the Software without restriction, including without limitation the rights
   * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
   * copies of the Software, and to permit persons to whom the Software is
   * furnished to do so, subject to the following conditions:
   *
   * The above copyright notice and this permission notice shall be included in
   * all copies or substantial portions of the Software.
   *
   * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
   * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
   * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
   * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
   * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
   * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
   * THE SOFTWARE.
   *)

@material/dom/ponyfill.js:
  (**
   * @license
   * Copyright 2018 Google Inc.
   *
   * Permission is hereby granted, free of charge, to any person obtaining a copy
   * of this software and associated documentation files (the "Software"), to deal
   * in the Software without restriction, including without limitation the rights
   * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
   * copies of the Software, and to permit persons to whom the Software is
   * furnished to do so, subject to the following conditions:
   *
   * The above copyright notice and this permission notice shall be included in
   * all copies or substantial portions of the Software.
   *
   * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
   * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
   * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
   * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
   * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
   * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
   * THE SOFTWARE.
   *)
*/
